import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Account = Consumer | Maker | Organizer | Spot | Support;

export type AccountCounts = {
  __typename?: 'AccountCounts';
  artist: Scalars['Int']['output'];
  consumer: Scalars['Int']['output'];
  spot: Scalars['Int']['output'];
};

export type AccountFeedbackNotifications = {
  __typename?: 'AccountFeedbackNotifications';
  new: AccountNotification;
};

export type AccountImage = ImageInterface & {
  __typename?: 'AccountImage';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idx: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: AccountImageTypeEnum;
  url: Scalars['String']['output'];
};

export enum AccountImageTypeEnum {
  Avatar = 'AVATAR',
  Cover = 'COVER',
  Feed = 'FEED'
}

export type AccountInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type AccountInterface = {
  address?: Maybe<Address>;
  avatar?: Maybe<AccountImage>;
  covers: Array<AccountImage>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type AccountNotification = {
  __typename?: 'AccountNotification';
  email: NotificationChannelPreference;
  push: NotificationChannelPreference;
};

export type AccountNotifications = ConsumerNotifications | MakerNotifications | OrganizerNotifications | SpotNotifications | SupportNotifications;

export type AccountStandbyNotifications = {
  __typename?: 'AccountStandbyNotifications';
  all: AccountNotification;
};

export type AccountStatusesInput = {
  isActive: Scalars['Boolean']['input'];
  isDelete: Scalars['Boolean']['input'];
  isPrivate: Scalars['Boolean']['input'];
  isVerified: Scalars['Boolean']['input'];
};

export enum AccountTypeEnum {
  Artist = 'ARTIST',
  Consumer = 'CONSUMER',
  Organizer = 'ORGANIZER',
  Spot = 'SPOT',
  Support = 'SUPPORT'
}

export type AccountsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type AddAccountInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** To fill addresses's datas, please check https://developer.here.com/ */
export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  county?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  placeIdFreshness?: Maybe<Scalars['Date']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AddressInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddressSearch = {
  __typename?: 'AddressSearch';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  county?: Maybe<Scalars['String']['output']>;
  houseNumber: Scalars['String']['output'];
  label: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export type Billing = {
  __typename?: 'Billing';
  account: Account;
  contact: BillingContact;
  createdAt: Scalars['Date']['output'];
  deleteReason?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  forceInactiveReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAcceptedTOS?: Maybe<Scalars['Boolean']['output']>;
  isActive: Scalars['Boolean']['output'];
  isForceInactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  plan: BillingPlanEnum;
  siren: Scalars['String']['output'];
  siret: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type BillingContact = {
  __typename?: 'BillingContact';
  createdAt: Scalars['Date']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname: Scalars['String']['output'];
  mobilePhone: Scalars['String']['output'];
  role: BillingRoleEnum;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum BillingPlanEnum {
  Business = 'BUSINESS',
  Essential = 'ESSENTIAL',
  Freemium = 'FREEMIUM',
  Premium = 'PREMIUM'
}

export enum BillingRoleEnum {
  Director = 'DIRECTOR',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER',
  Other = 'OTHER',
  Owner = 'OWNER'
}

export type BookByConsumerInput = {
  date: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['Date']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  occasion?: InputMaybe<BookingOccasionEnum>;
  participants: Scalars['Int']['input'];
  spotId: Scalars['ID']['input'];
  startTime: Scalars['Date']['input'];
  time: Scalars['String']['input'];
};

export type BookBySpotInput = {
  client: BookClientCreateInput;
  date?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  occasion?: InputMaybe<BookingOccasionEnum>;
  participants: Scalars['Int']['input'];
  startTime: Scalars['Date']['input'];
  status?: InputMaybe<BookingStatusEnum>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type BookClientCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type BookClientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type Booking = {
  __typename?: 'Booking';
  author: BookingAuthor;
  client: Client;
  createdAt: Scalars['Date']['output'];
  date: Scalars['String']['output'];
  endTime?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  occasion?: Maybe<BookingOccasionEnum>;
  origin: AccountTypeEnum;
  participants: Scalars['Int']['output'];
  ref: Scalars['String']['output'];
  spot: Spot;
  startTime: Scalars['Date']['output'];
  status: BookingStatusEnum;
  time: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updates: Array<BookingUpdate>;
};

export type BookingAuthor = Consumer | Spot;

export type BookingClient = {
  __typename?: 'BookingClient';
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum BookingOccasionEnum {
  Afterwork = 'AFTERWORK',
  Bachelor = 'BACHELOR',
  Birthday = 'BIRTHDAY',
  BusinessMeal = 'BUSINESS_MEAL',
  CocktailPro = 'COCKTAIL_PRO',
  CompanyEvent = 'COMPANY_EVENT',
  Exposition = 'EXPOSITION',
  Farewell = 'FAREWELL',
  FashionShow = 'FASHION_SHOW',
  FriendsDrink = 'FRIENDS_DRINK',
  ProductLaunch = 'PRODUCT_LAUNCH',
  StudentParty = 'STUDENT_PARTY',
  TeamMeal = 'TEAM_MEAL',
  Wedding = 'WEDDING'
}

export enum BookingStatusEnum {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  NoShow = 'NO_SHOW',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type BookingUpdate = {
  __typename?: 'BookingUpdate';
  author: BookingAuthor;
  booking: Booking;
  createdAt: Scalars['Date']['output'];
  date?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  occasion?: Maybe<BookingOccasionEnum>;
  participants?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<BookingStatusEnum>;
  time?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CategoriesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type Category = {
  __typename?: 'Category';
  categoryId?: Maybe<Scalars['ID']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  isDraft: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CategoryEvents = {
  __typename?: 'CategoryEvents';
  category: Scalars['String']['output'];
  events: Array<Event>;
};

export type ClaimInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  siret: Scalars['String']['input'];
};

export type Client = BookingClient | Consumer;

export type Consumer = AccountInterface & {
  __typename?: 'Consumer';
  address?: Maybe<Address>;
  avatar?: Maybe<AccountImage>;
  covers: Array<AccountImage>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  feedbacks: Array<ConsumerFeedback>;
  following: Array<Spot>;
  friendships: Friendships;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isFollowing: Scalars['Boolean']['output'];
  isMyFriend: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifications: ConsumerNotifications;
  phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  supportTickets: Array<SupportTicket>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type ConsumerBookingNotifications = {
  __typename?: 'ConsumerBookingNotifications';
  message: AccountNotification;
  update: AccountNotification;
};

export type ConsumerEventNotifications = {
  __typename?: 'ConsumerEventNotifications';
  invitation: AccountNotification;
  upcoming: AccountNotification;
  update: AccountNotification;
};

export type ConsumerFeedback = {
  __typename?: 'ConsumerFeedback';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  spot: Spot;
  spotId: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ConsumerNotifications = {
  __typename?: 'ConsumerNotifications';
  booking: ConsumerBookingNotifications;
  event: ConsumerEventNotifications;
  id: Scalars['ID']['output'];
  request: ConsumerRequestNotifications;
  standby: AccountStandbyNotifications;
};

export type ConsumerRequestNotifications = {
  __typename?: 'ConsumerRequestNotifications';
  friendship: AccountNotification;
  mention: AccountNotification;
  message: AccountNotification;
};

export type Conversation = {
  __typename?: 'Conversation';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<Message>;
  lastReadMessageId?: Maybe<Scalars['ID']['output']>;
  members: Array<AccountInterface>;
  messages: MessageConnection;
  name?: Maybe<Scalars['String']['output']>;
  unreadCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type ConversationMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateBillingInput = {
  accountId: Scalars['ID']['input'];
  firstname: Scalars['String']['input'];
  isAcceptedTOS: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  name: Scalars['String']['input'];
  plan: BillingPlanEnum;
  role: BillingRoleEnum;
  siren: Scalars['String']['input'];
  siret: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateEventInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  cover?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['Date']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  participantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type DateRangeInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type Event = {
  __typename?: 'Event';
  FAQs: Array<FaQs>;
  address?: Maybe<Address>;
  category?: Maybe<EventCategory>;
  children: Array<Event>;
  covers: Array<EventImage>;
  createdAt: Scalars['Date']['output'];
  creator: AccountInterface;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  flyer?: Maybe<Scalars['String']['output']>;
  from: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isLiking: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  likers: Likers;
  makers: Array<Maker>;
  meta: Scalars['JSON']['output'];
  participants: Participants;
  publishedAt?: Maybe<Scalars['Date']['output']>;
  ref: Scalars['String']['output'];
  settings: Scalars['JSON']['output'];
  spot?: Maybe<Spot>;
  status: EventStatusEnum;
  tags: Array<Tag>;
  thumb?: Maybe<Scalars['String']['output']>;
  tickets: Array<EventTicket>;
  title: Scalars['String']['output'];
  to?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updates: Array<EventUpdate>;
};

export type EventCategoriesInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EventCategory = {
  __typename?: 'EventCategory';
  categoryId?: Maybe<Scalars['ID']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  isDraft: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type EventImage = ImageInterface & {
  __typename?: 'EventImage';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idx: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  type: EventImageTypeEnum;
  url: Scalars['String']['output'];
};

export enum EventImageTypeEnum {
  Avatar = 'AVATAR',
  Cover = 'COVER',
  Feed = 'FEED'
}

export enum EventParticipationStatusEnum {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Declined = 'DECLINED',
  Interested = 'INTERESTED',
  Invited = 'INVITED',
  Removed = 'REMOVED'
}

export enum EventStatusEnum {
  Canceled = 'CANCELED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Postponed = 'POSTPONED',
  Published = 'PUBLISHED',
  Removed = 'REMOVED'
}

export type EventTicket = {
  __typename?: 'EventTicket';
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  idx: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  to?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type EventUpdate = {
  __typename?: 'EventUpdate';
  author?: Maybe<AccountInterface>;
  category?: Maybe<EventCategory>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Event>;
  from?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['JSON']['output']>;
  parentEvent?: Maybe<Event>;
  settings?: Maybe<Scalars['JSON']['output']>;
  spot?: Maybe<Spot>;
  status?: Maybe<EventStatusEnum>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
};

export type EventsInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  addressId?: InputMaybe<Scalars['ID']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type FaQs = {
  __typename?: 'FAQs';
  answer: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  idx: Scalars['Int']['output'];
  isDelete: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Friend = {
  __typename?: 'Friend';
  friend: Consumer;
  id: Scalars['ID']['output'];
  isAccepted: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  isSent: Scalars['Boolean']['output'];
};

export type Friendships = {
  __typename?: 'Friendships';
  active: FriendshipsDetail;
  pending?: Maybe<FriendshipsDetail>;
};

export type FriendshipsDetail = {
  __typename?: 'FriendshipsDetail';
  count: Scalars['Int']['output'];
  list: Array<Friend>;
};

export enum GenderEnum {
  Feminine = 'FEMININE',
  GenderFluid = 'GENDER_FLUID',
  Masculine = 'MASCULINE',
  NonBinary = 'NON_BINARY',
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type HomeMakers = {
  __typename?: 'HomeMakers';
  id: Scalars['ID']['output'];
  makers: Array<Maker>;
  title: Scalars['String']['output'];
};

export type HomeSpots = {
  __typename?: 'HomeSpots';
  id: Scalars['ID']['output'];
  spots: Array<Spot>;
  title: Scalars['String']['output'];
};

export type Image = ImageInterface & {
  __typename?: 'Image';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idx: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum ImageEntityTypeEnum {
  Account = 'ACCOUNT',
  Event = 'EVENT'
}

export type ImageInterface = {
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  fileId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idx: Scalars['Int']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum ImageTypeEnum {
  Avatar = 'AVATAR',
  Cover = 'COVER',
  Feed = 'FEED'
}

export type Likers = {
  __typename?: 'Likers';
  accounts: Array<AccountInterface>;
  count: Scalars['Int']['output'];
  eventId: Scalars['ID']['output'];
};

export type ListAccountFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<DateRangeInput>;
  deletedAt?: InputMaybe<DateRangeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountTypeEnum>;
  updatedAt?: InputMaybe<DateRangeInput>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListUserFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  birthdate?: InputMaybe<DateRangeInput>;
  createdAt?: InputMaybe<DateRangeInput>;
  deletedAt?: InputMaybe<DateRangeInput>;
  gender?: InputMaybe<GenderEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<DateRangeInput>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
};

export type LoginSsoInput = {
  provider?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type Maker = AccountInterface & {
  __typename?: 'Maker';
  address?: Maybe<Address>;
  avatar?: Maybe<AccountImage>;
  covers: Array<AccountImage>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifications: MakerNotifications;
  phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  supportTickets: Array<SupportTicket>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type MakerNotifications = {
  __typename?: 'MakerNotifications';
  id: Scalars['ID']['output'];
  standby: AccountStandbyNotifications;
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String']['output'];
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  sender: AccountInterface;
  senderId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges: Array<MessageEdge>;
  pageInfo: PageInfo;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

export type MobilePushNotifTestInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAccount: NewAccount;
  bookByConsumer: Booking;
  bookBySpot: Booking;
  changePassword: Scalars['Boolean']['output'];
  claimSpot: Scalars['Boolean']['output'];
  createConversation: Conversation;
  createEvent: Event;
  deleteAccount: Scalars['Boolean']['output'];
  deleteMobilePhone: User;
  deleteUser: Scalars['Boolean']['output'];
  follow: Account;
  handleFriend: Friend;
  isPasswordValid: Scalars['Boolean']['output'];
  likeEvent: Scalars['Boolean']['output'];
  login: Tokens;
  loginSSO: TokensOrProfileSso;
  logout: Scalars['Boolean']['output'];
  markNotificationAsRead: Notification;
  openTicketAuth: SupportTicket;
  openTicketPublic: SupportTicket;
  openTicketSupport: SupportTicket;
  reSendActivationMail: User;
  refreshTokens: Tokens;
  registerMobilePhone: User;
  registerSpot: Account;
  removeAvatar: Scalars['Boolean']['output'];
  removeEventFAQ: Scalars['Boolean']['output'];
  removeEventImage: Scalars['Boolean']['output'];
  removeImage: Scalars['Boolean']['output'];
  resetUnreadCount: Scalars['Boolean']['output'];
  /** @deprecated Use saveUserPushToken instead */
  savePushSubscription: Scalars['Boolean']['output'];
  saveUserPushToken?: Maybe<Scalars['Boolean']['output']>;
  sendMessage: Scalars['Boolean']['output'];
  sendMobilePushNotifTest: Scalars['Boolean']['output'];
  sendPushNotificationTest: Scalars['Boolean']['output'];
  setTyping: Scalars['Boolean']['output'];
  signup: Scalars['Boolean']['output'];
  signupSSO: User;
  sortEventFAQ: Array<FaQs>;
  supdateAccount: Account;
  supdateAccountStatuses: Account;
  supdateSpotAtmosphere: SpotAtmosphere;
  supdateSpotBringable: SpotBringable;
  supdateSpotCapacity: SpotConfiguration;
  supdateSpotCloseSpaces: SpotConfiguration;
  supdateSpotEquipment: SpotEquipment;
  supdateSpotHighlight: SpotHighlight;
  supdateSpotPayment: SpotPayment;
  supdateSpotPricing: SpotConfiguration;
  supdateSpotSchedule: SpotSchedulesOpening;
  supdateSpotService: SpotService;
  supdateSpotSuitable: SpotSuitable;
  supdateSpotType: SpotType;
  supdateSpotTypes: SpotConfiguration;
  switchAccount: Scalars['Boolean']['output'];
  syncSireneSpot: Scalars['Boolean']['output'];
  unfollow: Account;
  unlikeEvent: Scalars['Boolean']['output'];
  updateAccount: Account;
  updateAccountDescription: Scalars['Boolean']['output'];
  updateBooking: Booking;
  updateEvent: Event;
  updateEventParticipants: Event;
  updateEventParticipation: Participant;
  updateEventStatus: Event;
  updateEventTicket: Event;
  updateNotifications: AccountNotifications;
  updateSpotAtmosphere: SpotAtmosphere;
  updateSpotBringable: SpotBringable;
  updateSpotCapacity: SpotConfiguration;
  updateSpotCloseSpaces: SpotConfiguration;
  updateSpotEquipment: SpotEquipment;
  updateSpotPayment: SpotPayment;
  updateSpotPricing: SpotConfiguration;
  updateSpotSchedules: SpotSchedulesOpening;
  updateSpotService: SpotService;
  updateSpotSuitable: SpotSuitable;
  updateSpotType: SpotType;
  updateSpotTypes: SpotConfiguration;
  updateUser: User;
  updateUserPreferences?: Maybe<Scalars['Boolean']['output']>;
  upsertAvatar: Image;
  upsertEventFAQ: FaQs;
  upsertEventImage: Image;
  upsertSpotMenu: Scalars['Boolean']['output'];
  verifyEmail: User;
};


export type MutationAddAccountArgs = {
  input: AddAccountInput;
};


export type MutationBookByConsumerArgs = {
  input: BookByConsumerInput;
};


export type MutationBookBySpotArgs = {
  input: BookBySpotInput;
};


export type MutationChangePasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationClaimSpotArgs = {
  id: Scalars['ID']['input'];
  input: ClaimInput;
};


export type MutationCreateConversationArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  participants: Array<Scalars['ID']['input']>;
};


export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


export type MutationFollowArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationHandleFriendArgs = {
  accountId: Scalars['ID']['input'];
  action: Scalars['String']['input'];
};


export type MutationIsPasswordValidArgs = {
  password: Scalars['String']['input'];
};


export type MutationLikeEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLoginSsoArgs = {
  input: LoginSsoInput;
};


export type MutationLogoutArgs = {
  FCMToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkNotificationAsReadArgs = {
  notificationId: Scalars['ID']['input'];
};


export type MutationOpenTicketAuthArgs = {
  input: OpenAuthTicketInput;
};


export type MutationOpenTicketPublicArgs = {
  input: OpenPublicTicketInput;
};


export type MutationOpenTicketSupportArgs = {
  input: OpenSupportTicketInput;
};


export type MutationRefreshTokensArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterMobilePhoneArgs = {
  mobilePhone: Scalars['String']['input'];
};


export type MutationRegisterSpotArgs = {
  input: RegisterSpotInput;
};


export type MutationRemoveEventFaqArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveEventImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveImageArgs = {
  id: Scalars['ID']['input'];
  input: RemoveImageInput;
};


export type MutationResetUnreadCountArgs = {
  conversationId: Scalars['ID']['input'];
};


export type MutationSavePushSubscriptionArgs = {
  input: PushSubscriptionInput;
};


export type MutationSaveUserPushTokenArgs = {
  input: UserPushTokenInput;
};


export type MutationSendMessageArgs = {
  content: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
};


export type MutationSendMobilePushNotifTestArgs = {
  input?: InputMaybe<MobilePushNotifTestInput>;
  token: Scalars['String']['input'];
};


export type MutationSendPushNotificationTestArgs = {
  input?: InputMaybe<PushNotificationInput>;
  userId: Scalars['ID']['input'];
};


export type MutationSetTypingArgs = {
  conversationId: Scalars['ID']['input'];
  isTyping: Scalars['Boolean']['input'];
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationSignupSsoArgs = {
  input: SignupSsoInput;
};


export type MutationSortEventFaqArgs = {
  eventId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']>;
};


export type MutationSupdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
};


export type MutationSupdateAccountStatusesArgs = {
  id: Scalars['ID']['input'];
  input: AccountStatusesInput;
};


export type MutationSupdateSpotAtmosphereArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotAtmosphereInput;
};


export type MutationSupdateSpotBringableArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotBringableInput;
};


export type MutationSupdateSpotCapacityArgs = {
  id: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
};


export type MutationSupdateSpotCloseSpacesArgs = {
  id: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
};


export type MutationSupdateSpotEquipmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotEquipmentInput;
};


export type MutationSupdateSpotHighlightArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotHighlightInput;
};


export type MutationSupdateSpotPaymentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotPaymentInput;
};


export type MutationSupdateSpotPricingArgs = {
  id: Scalars['ID']['input'];
  pricing: SpotPricingEnum;
};


export type MutationSupdateSpotScheduleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotScheduleInput;
};


export type MutationSupdateSpotServiceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotServiceInput;
};


export type MutationSupdateSpotSuitableArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotSuitableInput;
};


export type MutationSupdateSpotTypeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotTypeInput;
};


export type MutationSupdateSpotTypesArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSpotTypesInput;
};


export type MutationSwitchAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnfollowArgs = {
  accountId: Scalars['ID']['input'];
};


export type MutationUnlikeEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateAccountDescriptionArgs = {
  input?: InputMaybe<UpdateAccountDescriptionInput>;
};


export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateEventParticipantsArgs = {
  eventId: Scalars['ID']['input'];
  participantIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateEventParticipationArgs = {
  eventId: Scalars['ID']['input'];
  status: EventParticipationStatusEnum;
};


export type MutationUpdateEventStatusArgs = {
  id: Scalars['ID']['input'];
  status: EventStatusEnum;
};


export type MutationUpdateEventTicketArgs = {
  input: UpdateEventInput;
};


export type MutationUpdateNotificationsArgs = {
  input: UpdateNotificationInput;
};


export type MutationUpdateSpotAtmosphereArgs = {
  input: UpdateSpotAtmosphereInput;
};


export type MutationUpdateSpotBringableArgs = {
  input: UpdateSpotBringableInput;
};


export type MutationUpdateSpotCapacityArgs = {
  value: Scalars['Int']['input'];
};


export type MutationUpdateSpotCloseSpacesArgs = {
  value: Scalars['Int']['input'];
};


export type MutationUpdateSpotEquipmentArgs = {
  input: UpdateSpotEquipmentInput;
};


export type MutationUpdateSpotPaymentArgs = {
  input: UpdateSpotPaymentInput;
};


export type MutationUpdateSpotPricingArgs = {
  pricing?: InputMaybe<SpotPricingEnum>;
};


export type MutationUpdateSpotSchedulesArgs = {
  input: UpdateSpotScheduleInput;
};


export type MutationUpdateSpotServiceArgs = {
  input: UpdateSpotServiceInput;
};


export type MutationUpdateSpotSuitableArgs = {
  input: UpdateSpotSuitableInput;
};


export type MutationUpdateSpotTypeArgs = {
  input: UpdateSpotTypeInput;
};


export type MutationUpdateSpotTypesArgs = {
  input: UpdateSpotTypesInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput;
};


export type MutationUpsertAvatarArgs = {
  avatar: Scalars['Upload']['input'];
};


export type MutationUpsertEventFaqArgs = {
  input: UpsertEventFaqInput;
};


export type MutationUpsertEventImageArgs = {
  eventId: Scalars['ID']['input'];
  image: Scalars['Upload']['input'];
  type: EventImageTypeEnum;
};


export type MutationUpsertSpotMenuArgs = {
  input: UpsertSpotMenuInput;
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};

export type NewAccount = {
  __typename?: 'NewAccount';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  type: AccountTypeEnum;
};

export type Notification = {
  __typename?: 'Notification';
  action: NotificationActionEnum;
  count: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  details: Array<NotificationDetail>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  source?: Maybe<AccountInterface>;
  subtitle?: Maybe<Scalars['String']['output']>;
  target: AccountInterface;
  title: Scalars['String']['output'];
  type: NotificationTypeEnum;
};

export enum NotificationActionEnum {
  Cancel = 'CANCEL',
  Create = 'CREATE',
  Delete = 'DELETE',
  Friendship = 'FRIENDSHIP',
  Invitation = 'INVITATION',
  Update = 'UPDATE'
}

export type NotificationBookingInput = {
  late?: InputMaybe<NotificationInput>;
  message?: InputMaybe<NotificationInput>;
  new?: InputMaybe<NotificationInput>;
  update?: InputMaybe<NotificationInput>;
};

export type NotificationChannelPreference = {
  __typename?: 'NotificationChannelPreference';
  enabled: Scalars['Boolean']['output'];
  isOverridable: Scalars['Boolean']['output'];
};

export type NotificationDetail = {
  __typename?: 'NotificationDetail';
  action: NotificationActionEnum;
  createdAt: Scalars['Date']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  entityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  sourceId: Scalars['ID']['output'];
  targetId: Scalars['ID']['output'];
  type: NotificationTypeEnum;
};

export type NotificationEventInput = {
  invitation?: InputMaybe<NotificationInput>;
  upcoming?: InputMaybe<NotificationInput>;
  update?: InputMaybe<NotificationInput>;
};

export type NotificationFeedbackInput = {
  new?: InputMaybe<NotificationInput>;
};

export type NotificationInput = {
  email: Scalars['Boolean']['input'];
  push: Scalars['Boolean']['input'];
};

export type NotificationRequestInput = {
  friendship?: InputMaybe<NotificationInput>;
  mention?: InputMaybe<NotificationInput>;
  message?: InputMaybe<NotificationInput>;
};

export type NotificationStandbyInput = {
  all?: InputMaybe<NotificationInput>;
};

export enum NotificationTypeEnum {
  Booking = 'BOOKING',
  Event = 'EVENT',
  Message = 'MESSAGE',
  Request = 'REQUEST',
  System = 'SYSTEM'
}

export type OAuthResponse = {
  __typename?: 'OAuthResponse';
  url: Scalars['String']['output'];
};

export type OpenAuthTicketInput = {
  message: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  topic: SupportTicketTopicEnum;
};

export type OpenPublicTicketInput = {
  contactEmail: Scalars['String']['input'];
  contactFirstName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  topic: SupportTicketTopicEnum;
};

export type OpenSupportTicketInput = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactFirstName?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  origin?: InputMaybe<SupportTicketOriginEnum>;
  priority?: InputMaybe<SupportTicketPriorityEnum>;
  recaptchaToken: Scalars['String']['input'];
  status?: InputMaybe<SupportTicketStatusEnum>;
  topic: SupportTicketTopicEnum;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type Organizer = AccountInterface & {
  __typename?: 'Organizer';
  address?: Maybe<Address>;
  avatar?: Maybe<AccountImage>;
  covers: Array<AccountImage>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifications: OrganizerNotifications;
  phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  supportTickets: Array<SupportTicket>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type OrganizerNotifications = {
  __typename?: 'OrganizerNotifications';
  id: Scalars['ID']['output'];
  standby: AccountStandbyNotifications;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Participant = {
  __typename?: 'Participant';
  account: AccountInterface;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<EventParticipationStatusEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Participants = {
  __typename?: 'Participants';
  canceled: Scalars['Int']['output'];
  confirmed: Scalars['Int']['output'];
  declined: Scalars['Int']['output'];
  eventId: Scalars['ID']['output'];
  interested: Scalars['Int']['output'];
  invited: Scalars['Int']['output'];
  list: Array<Participant>;
  me?: Maybe<Participant>;
  removed: Scalars['Int']['output'];
};

export type PriceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  happyhour?: InputMaybe<Scalars['Float']['input']>;
};

export type PricesInput = {
  bottle: PriceInput;
  glass: PriceInput;
  half: PriceInput;
  pint: PriceInput;
  pitcher: PriceInput;
  product: PriceInput;
  shooter: PriceInput;
};

export type ProfileSso = {
  __typename?: 'ProfileSSO';
  avatar?: Maybe<Image>;
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  lastname?: Maybe<Scalars['String']['output']>;
};

export type PushNotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PushSubscriptionInput = {
  auth: Scalars['String']['input'];
  endpoint: Scalars['String']['input'];
  p256dh: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  account: Account;
  accountConversation?: Maybe<Conversation>;
  accountCounts: SupportAccountCounts;
  accounts: Array<Account>;
  billing: Billing;
  billings: Array<Billing>;
  booking: Booking;
  categories: Array<Category>;
  category: Category;
  consumer: Consumer;
  conversation: Conversation;
  conversations: Array<Conversation>;
  event: Event;
  eventCategories: Array<EventCategory>;
  eventCategory?: Maybe<EventCategory>;
  events: Array<Event>;
  getAccountNotifications: AccountNotifications;
  getFriendship?: Maybe<Friend>;
  /** @deprecated Use FCM instead of web push */
  getPublicVapidKey: Scalars['String']['output'];
  getSpotBySiret: SpotBySiret;
  getSpotStats: SpotStats;
  getTicket: Array<SupportTicket>;
  homeMakers: Array<HomeMakers>;
  homeSpots: Array<HomeSpots>;
  isEmailAvailable: Scalars['Boolean']['output'];
  isSlugAvailable: Scalars['Boolean']['output'];
  listAccounts: Array<Account>;
  listFriends: Friendships;
  listMyTickets: Array<SupportTicket>;
  listSupportTicketTopics: Array<SupportTicketTopic>;
  listTicketsByAccountId: Array<SupportTicket>;
  listTicketsByUserId: Array<SupportTicket>;
  listUsers: Array<User>;
  maker: Maker;
  myBillings: Array<Billing>;
  myBookings: Array<Booking>;
  myEvents: Array<Event>;
  notifications: Array<Notification>;
  organizer: Organizer;
  searchAccounts: SearchAccountsResults;
  searchAddresses: Array<AddressSearch>;
  searchEvents: SearchEventsResults;
  searchFriends: Array<Friend>;
  searchMembers: SearchAccountsResults;
  searchMyFriends: Array<AccountInterface>;
  searchSpots: SearchSpotsResults;
  searchSuggestLocation: Array<SuggestLocation>;
  session?: Maybe<User>;
  spot: Spot;
  support?: Maybe<Support>;
  user: User;
  userByEmailToken?: Maybe<User>;
  users: Array<User>;
};


export type QueryAccountArgs = {
  input: AccountInput;
};


export type QueryAccountConversationArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryAccountCountsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryAccountsArgs = {
  input: AccountsInput;
};


export type QueryBillingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConsumerArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryConversationArgs = {
  conversationId: Scalars['ID']['input'];
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventsArgs = {
  input: EventsInput;
};


export type QueryGetFriendshipArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryGetSpotBySiretArgs = {
  siret: Scalars['String']['input'];
};


export type QueryGetSpotStatsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  range: Scalars['String']['input'];
};


export type QueryGetTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']['input'];
};


export type QueryIsSlugAvailableArgs = {
  slug: Scalars['String']['input'];
};


export type QueryListAccountsArgs = {
  filters: ListAccountFilters;
};


export type QueryListFriendsArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryListSupportTicketTopicsArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTicketsByAccountIdArgs = {
  accountId: Scalars['ID']['input'];
};


export type QueryListTicketsByUserIdArgs = {
  userId: Scalars['ID']['input'];
};


export type QueryListUsersArgs = {
  filters: ListUserFilters;
};


export type QueryMakerArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryMyBillingsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryMyBookingsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryMyEventsArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
};


export type QueryOrganizerArgs = {
  slug: Scalars['ID']['input'];
};


export type QuerySearchAccountsArgs = {
  filters: SearchAccountsFilters;
  pagination: SearchPagination;
};


export type QuerySearchAddressesArgs = {
  search: Scalars['String']['input'];
};


export type QuerySearchEventsArgs = {
  filters: SearchEventFiltersInput;
  pagination: SearchPagination;
};


export type QuerySearchFriendsArgs = {
  text: Scalars['String']['input'];
};


export type QuerySearchMembersArgs = {
  filters: SearchMembersFilters;
  pagination: SearchPagination;
};


export type QuerySearchMyFriendsArgs = {
  text: Scalars['String']['input'];
};


export type QuerySearchSpotsArgs = {
  filters: SearchSpotFiltersInput;
  pagination: SearchPagination;
};


export type QuerySearchSuggestLocationArgs = {
  search: SearchSuggest;
};


export type QuerySpotArgs = {
  dateRange?: InputMaybe<DateRangeInput>;
  slug: Scalars['ID']['input'];
};


export type QuerySupportArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserByEmailTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  input: UsersInput;
};

export type RegisterSpotInput = {
  firstname: Scalars['String']['input'];
  isAcceptedTOS: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
  mobilePhone: Scalars['String']['input'];
  plan: BillingPlanEnum;
  recaptchaToken: Scalars['String']['input'];
  role: BillingRoleEnum;
  siret: Scalars['String']['input'];
};

export type RemoveImageInput = {
  id: Scalars['ID']['input'];
  type: ImageEntityTypeEnum;
};

export type SearchAccountsFilters = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AccountTypeEnum>;
};

export type SearchAccountsResults = {
  __typename?: 'SearchAccountsResults';
  accounts: Array<AccountInterface>;
  total: Scalars['Int']['output'];
};

export type SearchEventFiltersInput = {
  categories?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type SearchEventsResults = {
  __typename?: 'SearchEventsResults';
  events: Array<Event>;
  total: Scalars['Int']['output'];
};

export type SearchMembersFilters = {
  name?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type SearchPagination = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type SearchSpotFiltersInput = {
  afterwork?: InputMaybe<Scalars['Boolean']['input']>;
  amex?: InputMaybe<Scalars['Boolean']['input']>;
  amphitheater?: InputMaybe<Scalars['Boolean']['input']>;
  amusementPark?: InputMaybe<Scalars['Boolean']['input']>;
  aquarium?: InputMaybe<Scalars['Boolean']['input']>;
  artGallery?: InputMaybe<Scalars['Boolean']['input']>;
  auditorium?: InputMaybe<Scalars['Boolean']['input']>;
  bachelor?: InputMaybe<Scalars['Boolean']['input']>;
  bar?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['Boolean']['input']>;
  birthdayCake?: InputMaybe<Scalars['Boolean']['input']>;
  blueCard?: InputMaybe<Scalars['Boolean']['input']>;
  businessMeal?: InputMaybe<Scalars['Boolean']['input']>;
  cafe?: InputMaybe<Scalars['Boolean']['input']>;
  calm?: InputMaybe<Scalars['Boolean']['input']>;
  campground?: InputMaybe<Scalars['Boolean']['input']>;
  cash?: InputMaybe<Scalars['Boolean']['input']>;
  casino?: InputMaybe<Scalars['Boolean']['input']>;
  changingTable?: InputMaybe<Scalars['Boolean']['input']>;
  checks?: InputMaybe<Scalars['Boolean']['input']>;
  cocktailPro?: InputMaybe<Scalars['Boolean']['input']>;
  companyEvent?: InputMaybe<Scalars['Boolean']['input']>;
  concertHall?: InputMaybe<Scalars['Boolean']['input']>;
  dancefloor?: InputMaybe<Scalars['Boolean']['input']>;
  dancing?: InputMaybe<Scalars['Boolean']['input']>;
  departmentStore?: InputMaybe<Scalars['Boolean']['input']>;
  dj?: InputMaybe<Scalars['Boolean']['input']>;
  dogs?: InputMaybe<Scalars['Boolean']['input']>;
  drinks?: InputMaybe<Scalars['Boolean']['input']>;
  entertainmentShow?: InputMaybe<Scalars['Boolean']['input']>;
  exposition?: InputMaybe<Scalars['Boolean']['input']>;
  farewell?: InputMaybe<Scalars['Boolean']['input']>;
  fashionShow?: InputMaybe<Scalars['Boolean']['input']>;
  food?: InputMaybe<Scalars['Boolean']['input']>;
  friendsDrink?: InputMaybe<Scalars['Boolean']['input']>;
  isOpen?: InputMaybe<Scalars['Boolean']['input']>;
  karaoke?: InputMaybe<Scalars['Boolean']['input']>;
  kids?: InputMaybe<Scalars['Boolean']['input']>;
  liveMusic?: InputMaybe<Scalars['Boolean']['input']>;
  lively?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  locker?: InputMaybe<Scalars['Boolean']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxCloseSpaces?: InputMaybe<Scalars['Int']['input']>;
  mealTickets?: InputMaybe<Scalars['Boolean']['input']>;
  microphone?: InputMaybe<Scalars['Boolean']['input']>;
  minCapacity?: InputMaybe<Scalars['Int']['input']>;
  minCloseSpaces?: InputMaybe<Scalars['Int']['input']>;
  mountainView?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nightClub?: InputMaybe<Scalars['Boolean']['input']>;
  oceanView?: InputMaybe<Scalars['Boolean']['input']>;
  ownMusic?: InputMaybe<Scalars['Boolean']['input']>;
  park?: InputMaybe<Scalars['Boolean']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  prmAccess?: InputMaybe<Scalars['Boolean']['input']>;
  prmToilets?: InputMaybe<Scalars['Boolean']['input']>;
  productLaunch?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant?: InputMaybe<Scalars['Boolean']['input']>;
  rooftop?: InputMaybe<Scalars['Boolean']['input']>;
  seaView?: InputMaybe<Scalars['Boolean']['input']>;
  smokingRoom?: InputMaybe<Scalars['Boolean']['input']>;
  sono?: InputMaybe<Scalars['Boolean']['input']>;
  sportClub?: InputMaybe<Scalars['Boolean']['input']>;
  stadium?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['Boolean']['input']>;
  studentParty?: InputMaybe<Scalars['Boolean']['input']>;
  sunrise?: InputMaybe<Scalars['Boolean']['input']>;
  sunset?: InputMaybe<Scalars['Boolean']['input']>;
  takeout?: InputMaybe<Scalars['Boolean']['input']>;
  teamMeal?: InputMaybe<Scalars['Boolean']['input']>;
  telework?: InputMaybe<Scalars['Boolean']['input']>;
  terrace?: InputMaybe<Scalars['Boolean']['input']>;
  toilets?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  veggie?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<Scalars['Boolean']['input']>;
  watchSport?: InputMaybe<Scalars['Boolean']['input']>;
  wedding?: InputMaybe<Scalars['Boolean']['input']>;
  wifi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchSpotsResults = {
  __typename?: 'SearchSpotsResults';
  spots: Array<Spot>;
  total: Scalars['Int']['output'];
};

export enum SearchSuggest {
  Event = 'event',
  Member = 'member',
  Spot = 'spot'
}

export type SignupInput = {
  birthdate: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  gender: GenderEnum;
  isAcceptedNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  isAcceptedPrivacyPolicy: Scalars['Boolean']['input'];
  isAcceptedTOS: Scalars['Boolean']['input'];
  isSSO: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
  type: AccountTypeEnum;
};

export type SignupSsoInput = {
  birthdate: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  gender: GenderEnum;
  isAcceptedNewsletter?: InputMaybe<Scalars['Boolean']['input']>;
  isAcceptedPrivacyPolicy: Scalars['Boolean']['input'];
  isAcceptedTOS: Scalars['Boolean']['input'];
  lastname: Scalars['String']['input'];
};

export type Spot = AccountInterface & {
  __typename?: 'Spot';
  FAQs: Array<FaQs>;
  addicts: Array<Consumer>;
  address?: Maybe<Address>;
  atmosphere: SpotAtmosphere;
  avatar?: Maybe<AccountImage>;
  bringable: SpotBringable;
  closing: Array<SpotSchedulesClosing>;
  configuration: SpotConfiguration;
  covers: Array<AccountImage>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  equipment: SpotEquipment;
  events: Array<Event>;
  feedbacks: Array<SpotFeedback>;
  highlight: SpotHighlight;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isFollowing: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifications: SpotNotifications;
  opening: Array<SpotSchedulesOpening>;
  payment: SpotPayment;
  phone?: Maybe<Scalars['String']['output']>;
  service: SpotService;
  slug: Scalars['String']['output'];
  suitable: SpotSuitable;
  supportTickets: Array<SupportTicket>;
  type: SpotType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type SpotAtmosphere = {
  __typename?: 'SpotAtmosphere';
  calm?: Maybe<Scalars['Boolean']['output']>;
  dancing?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lively?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SpotBookingNotifications = {
  __typename?: 'SpotBookingNotifications';
  late: AccountNotification;
  message: AccountNotification;
  new: AccountNotification;
  update: AccountNotification;
};

export type SpotBringable = {
  __typename?: 'SpotBringable';
  birthdayCake?: Maybe<Scalars['Boolean']['output']>;
  dogs?: Maybe<Scalars['Boolean']['output']>;
  drinks?: Maybe<Scalars['Boolean']['output']>;
  food?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SpotBySiret = {
  __typename?: 'SpotBySiret';
  address?: Maybe<Scalars['String']['output']>;
  isConflict: Scalars['Boolean']['output'];
  isExists: Scalars['Boolean']['output'];
  isRegistered: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type SpotConfiguration = {
  __typename?: 'SpotConfiguration';
  capacity?: Maybe<Scalars['Int']['output']>;
  closeSpaces?: Maybe<Scalars['Int']['output']>;
  defaultImage?: Maybe<Scalars['String']['output']>;
  entryPrice?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isClaimed?: Maybe<Scalars['Boolean']['output']>;
  isEphemeral?: Maybe<Scalars['Boolean']['output']>;
  musicalGenre?: Maybe<SpotMusicalGenreEnum>;
  pricing?: Maybe<SpotPricingEnum>;
  primaryType?: Maybe<SpotTypeEnum>;
  secondaryType?: Maybe<SpotTypeEnum>;
  tertiaryType?: Maybe<SpotTypeEnum>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SpotEquipment = {
  __typename?: 'SpotEquipment';
  amphitheater?: Maybe<Scalars['Boolean']['output']>;
  auditorium?: Maybe<Scalars['Boolean']['output']>;
  changingTable?: Maybe<Scalars['Boolean']['output']>;
  dancefloor?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  locker?: Maybe<Scalars['Boolean']['output']>;
  microphone?: Maybe<Scalars['Boolean']['output']>;
  parking?: Maybe<Scalars['Boolean']['output']>;
  prmAccess?: Maybe<Scalars['Boolean']['output']>;
  prmToilets?: Maybe<Scalars['Boolean']['output']>;
  smokingRoom?: Maybe<Scalars['Boolean']['output']>;
  sono?: Maybe<Scalars['Boolean']['output']>;
  stage?: Maybe<Scalars['Boolean']['output']>;
  terrace?: Maybe<Scalars['Boolean']['output']>;
  toilets?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  video?: Maybe<Scalars['Boolean']['output']>;
  wifi?: Maybe<Scalars['Boolean']['output']>;
};

export type SpotFeedback = {
  __typename?: 'SpotFeedback';
  author: Consumer;
  consumerId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  media?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SpotHighlight = {
  __typename?: 'SpotHighlight';
  id: Scalars['ID']['output'];
  mountainView?: Maybe<Scalars['Boolean']['output']>;
  oceanView?: Maybe<Scalars['Boolean']['output']>;
  rooftop?: Maybe<Scalars['Boolean']['output']>;
  seaView?: Maybe<Scalars['Boolean']['output']>;
  sunrise?: Maybe<Scalars['Boolean']['output']>;
  sunset?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SpotMusicalGenreEnum {
  Afro = 'AFRO',
  Ambient = 'AMBIENT',
  Blues = 'BLUES',
  ChillOut = 'CHILL_OUT',
  Classical = 'CLASSICAL',
  Disco = 'DISCO',
  Electro = 'ELECTRO',
  Funk = 'FUNK',
  HipHop = 'HIP_HOP',
  House = 'HOUSE',
  Jazz = 'JAZZ',
  Latin = 'LATIN',
  Lounge = 'LOUNGE',
  Mainstream = 'MAINSTREAM',
  Pop = 'POP',
  Reggae = 'REGGAE',
  Reggaeton = 'REGGAETON',
  Rock = 'ROCK',
  RockNRoll = 'ROCK_N_ROLL',
  Salsa = 'SALSA',
  Soul = 'SOUL',
  Tango = 'TANGO',
  Techno = 'TECHNO'
}

export type SpotNotifications = {
  __typename?: 'SpotNotifications';
  booking: SpotBookingNotifications;
  feedback: AccountFeedbackNotifications;
  id: Scalars['ID']['output'];
  request: SpotRequestNotifications;
  standby: AccountStandbyNotifications;
};

export type SpotPayment = {
  __typename?: 'SpotPayment';
  amex?: Maybe<Scalars['Boolean']['output']>;
  blueCard?: Maybe<Scalars['Boolean']['output']>;
  cash?: Maybe<Scalars['Boolean']['output']>;
  checks?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  mealTickets?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SpotPricingEnum {
  Eco = 'ECO',
  High = 'HIGH',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

export type SpotRequestNotifications = {
  __typename?: 'SpotRequestNotifications';
  mention: AccountNotification;
  message: AccountNotification;
};

export type SpotSchedulesClosing = {
  __typename?: 'SpotSchedulesClosing';
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  from: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SpotSchedulesOpening = {
  __typename?: 'SpotSchedulesOpening';
  breakIn?: Maybe<Scalars['String']['output']>;
  breakOut?: Maybe<Scalars['String']['output']>;
  closingTime?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  dayOfWeek: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  openTime?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SpotService = {
  __typename?: 'SpotService';
  dj?: Maybe<Scalars['Boolean']['output']>;
  entertainmentShow?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  karaoke?: Maybe<Scalars['Boolean']['output']>;
  liveMusic?: Maybe<Scalars['Boolean']['output']>;
  ownMusic?: Maybe<Scalars['Boolean']['output']>;
  takeout?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SpotStats = {
  __typename?: 'SpotStats';
  addicts: SpotStatsCard;
  bookings: SpotStatsCard;
  bounces: SpotStatsCard;
  events: SpotStatsCard;
  id: Scalars['ID']['output'];
  transformation: SpotStatsCard;
  views: SpotStatsCard;
};

export type SpotStatsCard = {
  __typename?: 'SpotStatsCard';
  current?: Maybe<Scalars['Int']['output']>;
  dataSet: Array<Scalars['Float']['output']>;
  previous?: Maybe<Scalars['Int']['output']>;
};

export type SpotSuitable = {
  __typename?: 'SpotSuitable';
  afterwork?: Maybe<Scalars['Boolean']['output']>;
  bachelor?: Maybe<Scalars['Boolean']['output']>;
  birthday?: Maybe<Scalars['Boolean']['output']>;
  businessMeal?: Maybe<Scalars['Boolean']['output']>;
  cocktailPro?: Maybe<Scalars['Boolean']['output']>;
  companyEvent?: Maybe<Scalars['Boolean']['output']>;
  exposition?: Maybe<Scalars['Boolean']['output']>;
  farewell?: Maybe<Scalars['Boolean']['output']>;
  fashionShow?: Maybe<Scalars['Boolean']['output']>;
  friendsDrink?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kids?: Maybe<Scalars['Boolean']['output']>;
  productLaunch?: Maybe<Scalars['Boolean']['output']>;
  studentParty?: Maybe<Scalars['Boolean']['output']>;
  teamMeal?: Maybe<Scalars['Boolean']['output']>;
  telework?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vegan?: Maybe<Scalars['Boolean']['output']>;
  veggie?: Maybe<Scalars['Boolean']['output']>;
  watchSport?: Maybe<Scalars['Boolean']['output']>;
  wedding?: Maybe<Scalars['Boolean']['output']>;
};

export type SpotType = {
  __typename?: 'SpotType';
  amusementPark?: Maybe<Scalars['Boolean']['output']>;
  aquarium?: Maybe<Scalars['Boolean']['output']>;
  artGallery?: Maybe<Scalars['Boolean']['output']>;
  bar?: Maybe<Scalars['Boolean']['output']>;
  cafe?: Maybe<Scalars['Boolean']['output']>;
  campground?: Maybe<Scalars['Boolean']['output']>;
  casino?: Maybe<Scalars['Boolean']['output']>;
  concertHall?: Maybe<Scalars['Boolean']['output']>;
  departmentStore?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  nightClub?: Maybe<Scalars['Boolean']['output']>;
  park?: Maybe<Scalars['Boolean']['output']>;
  restaurant?: Maybe<Scalars['Boolean']['output']>;
  sportClub?: Maybe<Scalars['Boolean']['output']>;
  stadium?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum SpotTypeEnum {
  BarBeach = 'BAR_BEACH',
  BarBodega = 'BAR_BODEGA',
  BarBrewpub = 'BAR_BREWPUB',
  BarCocktail = 'BAR_COCKTAIL',
  BarDancing = 'BAR_DANCING',
  BarDive = 'BAR_DIVE',
  BarGames = 'BAR_GAMES',
  BarIce = 'BAR_ICE',
  BarJazz = 'BAR_JAZZ',
  BarKaraoke = 'BAR_KARAOKE',
  BarOyster = 'BAR_OYSTER',
  BarPena = 'BAR_PENA',
  BarPiano = 'BAR_PIANO',
  BarPub = 'BAR_PUB',
  BarSake = 'BAR_SAKE',
  BarSpeakeasy = 'BAR_SPEAKEASY',
  BarSports = 'BAR_SPORTS',
  BarTapas = 'BAR_TAPAS',
  BarTiki = 'BAR_TIKI',
  BarWhisky = 'BAR_WHISKY',
  BarWine = 'BAR_WINE',
  CafeArt = 'CAFE_ART',
  CafeBike = 'CAFE_BIKE',
  CafeBreakfast = 'CAFE_BREAKFAST',
  CafeCat = 'CAFE_CAT',
  CafeCoffeehouse = 'CAFE_COFFEEHOUSE',
  CafeCultural = 'CAFE_CULTURAL',
  CafeEcoFriendly = 'CAFE_ECO_FRIENDLY',
  CafeEspresso = 'CAFE_ESPRESSO',
  CafeGarden = 'CAFE_GARDEN',
  CafeJazz = 'CAFE_JAZZ',
  CafeLiterary = 'CAFE_LITERARY',
  CafeParisian = 'CAFE_PARISIAN',
  CafeRetro = 'CAFE_RETRO',
  CafeTeaRoom = 'CAFE_TEA_ROOM',
  CafeWorking = 'CAFE_WORKING',
  NightclubAfter = 'NIGHTCLUB_AFTER',
  NightclubBeach = 'NIGHTCLUB_BEACH',
  NightclubCabaret = 'NIGHTCLUB_CABARET',
  NightclubDance = 'NIGHTCLUB_DANCE',
  NightclubElectro = 'NIGHTCLUB_ELECTRO',
  NightclubHipHop = 'NIGHTCLUB_HIP_HOP',
  NightclubHouse = 'NIGHTCLUB_HOUSE',
  NightclubJazz = 'NIGHTCLUB_JAZZ',
  NightclubKaraoke = 'NIGHTCLUB_KARAOKE',
  NightclubLatin = 'NIGHTCLUB_LATIN',
  NightclubLgbt = 'NIGHTCLUB_LGBT',
  NightclubLiveMusic = 'NIGHTCLUB_LIVE_MUSIC',
  NightclubLounge = 'NIGHTCLUB_LOUNGE',
  NightclubMainstream = 'NIGHTCLUB_MAINSTREAM',
  NightclubOpenAir = 'NIGHTCLUB_OPEN_AIR',
  NightclubPoolParty = 'NIGHTCLUB_POOL_PARTY',
  NightclubRetro = 'NIGHTCLUB_RETRO',
  NightclubSilent = 'NIGHTCLUB_SILENT',
  NightclubTechno = 'NIGHTCLUB_TECHNO',
  NightclubUnderground = 'NIGHTCLUB_UNDERGROUND',
  NightclubVip = 'NIGHTCLUB_VIP',
  RestaurantBbqJoint = 'RESTAURANT_BBQ_JOINT',
  RestaurantBistronomic = 'RESTAURANT_BISTRONOMIC',
  RestaurantBistrot = 'RESTAURANT_BISTROT',
  RestaurantBrasserie = 'RESTAURANT_BRASSERIE',
  RestaurantBuffet = 'RESTAURANT_BUFFET',
  RestaurantCasualDining = 'RESTAURANT_CASUAL_DINING',
  RestaurantCiderHouse = 'RESTAURANT_CIDER_HOUSE',
  RestaurantDimSum = 'RESTAURANT_DIM_SUM',
  RestaurantDiner = 'RESTAURANT_DINER',
  RestaurantEthnic = 'RESTAURANT_ETHNIC',
  RestaurantFarmToTable = 'RESTAURANT_FARM_TO_TABLE',
  RestaurantFineDining = 'RESTAURANT_FINE_DINING',
  RestaurantFoodCourt = 'RESTAURANT_FOOD_COURT',
  RestaurantGrill = 'RESTAURANT_GRILL',
  RestaurantPizzeria = 'RESTAURANT_PIZZERIA',
  RestaurantRamenShop = 'RESTAURANT_RAMEN_SHOP',
  RestaurantSeafood = 'RESTAURANT_SEAFOOD',
  RestaurantSteakhouse = 'RESTAURANT_STEAKHOUSE',
  RestaurantSushi = 'RESTAURANT_SUSHI',
  RestaurantTapas = 'RESTAURANT_TAPAS',
  RestaurantTavern = 'RESTAURANT_TAVERN',
  RestaurantTrattoria = 'RESTAURANT_TRATTORIA',
  RestaurantVegan = 'RESTAURANT_VEGAN',
  RestaurantVegetarian = 'RESTAURANT_VEGETARIAN'
}

export type Subscription = {
  __typename?: 'Subscription';
  bookingCreate: Booking;
  bookingUpdate: BookingUpdate;
  bookings: Array<Booking>;
  conversationUpdate: Conversation;
  conversations: Array<Conversation>;
  eventInvitation: Event;
  eventUpdate: EventUpdate;
  messageSent: MessageEdge;
  notificationDelete: Scalars['ID']['output'];
  notificationUpdate: Notification;
  typing: TypingEvent;
};


export type SubscriptionMessageSentArgs = {
  conversationId: Scalars['ID']['input'];
};


export type SubscriptionTypingArgs = {
  conversationId: Scalars['ID']['input'];
};

export type SuggestLocation = {
  __typename?: 'SuggestLocation';
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type Support = AccountInterface & {
  __typename?: 'Support';
  address?: Maybe<Address>;
  avatar?: Maybe<AccountImage>;
  covers: Array<AccountImage>;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notifications: SupportNotifications;
  phone?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  supportTickets: Array<SupportTicket>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
};

export type SupportAccountCounts = {
  __typename?: 'SupportAccountCounts';
  current: AccountCounts;
  previous?: Maybe<AccountCounts>;
};

export type SupportNotifications = {
  __typename?: 'SupportNotifications';
  id: Scalars['ID']['output'];
  standby: AccountStandbyNotifications;
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  account?: Maybe<Account>;
  closedAt?: Maybe<Scalars['Date']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  extra: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  messages: Array<SupportTicketMessage>;
  origin: SupportTicketOriginEnum;
  priority: SupportTicketPriorityEnum;
  status: SupportTicketStatusEnum;
  topic: SupportTicketTopicEnum;
  topicInfo?: Maybe<SupportTicketTopicInfo>;
  updatedAt: Scalars['Date']['output'];
  user?: Maybe<User>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export enum SupportTicketActorTypeEnum {
  Support = 'SUPPORT',
  System = 'SYSTEM',
  User = 'USER'
}

export type SupportTicketMessage = {
  __typename?: 'SupportTicketMessage';
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorName?: Maybe<Scalars['String']['output']>;
  actorType?: Maybe<Scalars['String']['output']>;
  actorUserId?: Maybe<Scalars['ID']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  extra?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
};

export enum SupportTicketOriginEnum {
  Admin = 'ADMIN',
  Api = 'API',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum SupportTicketPriorityEnum {
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL',
  Urgent = 'URGENT'
}

export enum SupportTicketStatusEnum {
  Closed = 'CLOSED',
  InProgress = 'IN_PROGRESS',
  Open = 'OPEN',
  Resolved = 'RESOLVED',
  WaitingCustomer = 'WAITING_CUSTOMER'
}

export type SupportTicketTopic = {
  __typename?: 'SupportTicketTopic';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  topic: SupportTicketTopicEnum;
};

export enum SupportTicketTopicEnum {
  BugReport = 'BUG_REPORT',
  CannotLogin = 'CANNOT_LOGIN',
  DataRequest = 'DATA_REQUEST',
  FeatureRequest = 'FEATURE_REQUEST',
  GeneralQuestion = 'GENERAL_QUESTION',
  PaymentIssue = 'PAYMENT_ISSUE',
  ReportAbuse = 'REPORT_ABUSE',
  SecurityIssue = 'SECURITY_ISSUE',
  SiretIssue = 'SIRET_ISSUE',
  SpotSuggestUpdate = 'SPOT_SUGGEST_UPDATE'
}

export type SupportTicketTopicInfo = {
  __typename?: 'SupportTicketTopicInfo';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type Tokens = {
  __typename?: 'Tokens';
  access: Scalars['String']['output'];
  refresh: Scalars['String']['output'];
};

export type TokensOrProfileSso = ProfileSso | Tokens;

export type TypingEvent = {
  __typename?: 'TypingEvent';
  conversationId: Scalars['ID']['output'];
  isTyping: Scalars['Boolean']['output'];
  senderId: Scalars['ID']['output'];
};

export type UpdateAccountDescriptionInput = {
  accountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAccountInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBillingInput = {
  deleteReason?: InputMaybe<Scalars['String']['input']>;
  forceInactiveReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isForceInactive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  siren?: InputMaybe<Scalars['String']['input']>;
  siret?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBookingInput = {
  client?: InputMaybe<BookClientInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  occasion?: InputMaybe<BookingOccasionEnum>;
  participants?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<BookingStatusEnum>;
  time?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConsumerNotificationInput = {
  booking?: InputMaybe<NotificationBookingInput>;
  event?: InputMaybe<NotificationEventInput>;
  request?: InputMaybe<NotificationRequestInput>;
  standby?: InputMaybe<NotificationStandbyInput>;
};

export type UpdateEventInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  cover?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateMakerNotificationInput = {
  standby?: InputMaybe<NotificationStandbyInput>;
};

export type UpdateNotificationInput = {
  consumer?: InputMaybe<UpdateConsumerNotificationInput>;
  maker?: InputMaybe<UpdateMakerNotificationInput>;
  organizer?: InputMaybe<UpdateOrganizerNotificationInput>;
  spot?: InputMaybe<UpdateSpotNotificationInput>;
  support?: InputMaybe<UpdateSupportNotificationInput>;
};

export type UpdateOrganizerNotificationInput = {
  standby?: InputMaybe<NotificationStandbyInput>;
};

export type UpdateSpotAtmosphereInput = {
  calm?: InputMaybe<Scalars['Boolean']['input']>;
  dancing?: InputMaybe<Scalars['Boolean']['input']>;
  lively?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotBringableInput = {
  birthdayCake?: InputMaybe<Scalars['Boolean']['input']>;
  dogs?: InputMaybe<Scalars['Boolean']['input']>;
  drinks?: InputMaybe<Scalars['Boolean']['input']>;
  food?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotEquipmentInput = {
  amphitheater?: InputMaybe<Scalars['Boolean']['input']>;
  auditorium?: InputMaybe<Scalars['Boolean']['input']>;
  changingTable?: InputMaybe<Scalars['Boolean']['input']>;
  dancefloor?: InputMaybe<Scalars['Boolean']['input']>;
  locker?: InputMaybe<Scalars['Boolean']['input']>;
  microphone?: InputMaybe<Scalars['Boolean']['input']>;
  parking?: InputMaybe<Scalars['Boolean']['input']>;
  prmAccess?: InputMaybe<Scalars['Boolean']['input']>;
  prmToilets?: InputMaybe<Scalars['Boolean']['input']>;
  smokingRoom?: InputMaybe<Scalars['Boolean']['input']>;
  sono?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<Scalars['Boolean']['input']>;
  terrace?: InputMaybe<Scalars['Boolean']['input']>;
  toilets?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<Scalars['Boolean']['input']>;
  wifi?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotHighlightInput = {
  mountainView?: InputMaybe<Scalars['Boolean']['input']>;
  oceanView?: InputMaybe<Scalars['Boolean']['input']>;
  rooftop?: InputMaybe<Scalars['Boolean']['input']>;
  seaView?: InputMaybe<Scalars['Boolean']['input']>;
  sunrise?: InputMaybe<Scalars['Boolean']['input']>;
  sunset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotNotificationInput = {
  booking?: InputMaybe<NotificationBookingInput>;
  event?: InputMaybe<NotificationEventInput>;
  feedback?: InputMaybe<NotificationFeedbackInput>;
  request?: InputMaybe<NotificationRequestInput>;
  standby?: InputMaybe<NotificationStandbyInput>;
};

export type UpdateSpotPaymentInput = {
  amex?: InputMaybe<Scalars['Boolean']['input']>;
  blueCard?: InputMaybe<Scalars['Boolean']['input']>;
  cash?: InputMaybe<Scalars['Boolean']['input']>;
  checks?: InputMaybe<Scalars['Boolean']['input']>;
  mealTickets?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotScheduleInput = {
  breakIn?: InputMaybe<Scalars['String']['input']>;
  breakOut?: InputMaybe<Scalars['String']['input']>;
  closingTime?: InputMaybe<Scalars['String']['input']>;
  dayOfWeek: Scalars['Int']['input'];
  openTime?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpotServiceInput = {
  dj?: InputMaybe<Scalars['Boolean']['input']>;
  entertainmentShow?: InputMaybe<Scalars['Boolean']['input']>;
  karaoke?: InputMaybe<Scalars['Boolean']['input']>;
  liveMusic?: InputMaybe<Scalars['Boolean']['input']>;
  ownMusic?: InputMaybe<Scalars['Boolean']['input']>;
  takeout?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotSuitableInput = {
  afterwork?: InputMaybe<Scalars['Boolean']['input']>;
  bachelor?: InputMaybe<Scalars['Boolean']['input']>;
  birthday?: InputMaybe<Scalars['Boolean']['input']>;
  businessMeal?: InputMaybe<Scalars['Boolean']['input']>;
  cocktailPro?: InputMaybe<Scalars['Boolean']['input']>;
  companyEvent?: InputMaybe<Scalars['Boolean']['input']>;
  exposition?: InputMaybe<Scalars['Boolean']['input']>;
  farewell?: InputMaybe<Scalars['Boolean']['input']>;
  fashionShow?: InputMaybe<Scalars['Boolean']['input']>;
  friendsDrink?: InputMaybe<Scalars['Boolean']['input']>;
  kids?: InputMaybe<Scalars['Boolean']['input']>;
  productLaunch?: InputMaybe<Scalars['Boolean']['input']>;
  studentParty?: InputMaybe<Scalars['Boolean']['input']>;
  teamMeal?: InputMaybe<Scalars['Boolean']['input']>;
  telework?: InputMaybe<Scalars['Boolean']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  veggie?: InputMaybe<Scalars['Boolean']['input']>;
  watchSport?: InputMaybe<Scalars['Boolean']['input']>;
  wedding?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotTypeInput = {
  amusementPark?: InputMaybe<Scalars['Boolean']['input']>;
  aquarium?: InputMaybe<Scalars['Boolean']['input']>;
  artGallery?: InputMaybe<Scalars['Boolean']['input']>;
  bar?: InputMaybe<Scalars['Boolean']['input']>;
  cafe?: InputMaybe<Scalars['Boolean']['input']>;
  campground?: InputMaybe<Scalars['Boolean']['input']>;
  casino?: InputMaybe<Scalars['Boolean']['input']>;
  concertHall?: InputMaybe<Scalars['Boolean']['input']>;
  departmentStore?: InputMaybe<Scalars['Boolean']['input']>;
  nightClub?: InputMaybe<Scalars['Boolean']['input']>;
  park?: InputMaybe<Scalars['Boolean']['input']>;
  restaurant?: InputMaybe<Scalars['Boolean']['input']>;
  sportClub?: InputMaybe<Scalars['Boolean']['input']>;
  stadium?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSpotTypesInput = {
  primaryType?: InputMaybe<SpotTypeEnum>;
  secondaryType?: InputMaybe<SpotTypeEnum>;
  tertiaryType?: InputMaybe<SpotTypeEnum>;
};

export type UpdateSupportNotificationInput = {
  standby?: InputMaybe<NotificationStandbyInput>;
};

export type UpdateUserInput = {
  address?: InputMaybe<Scalars['Date']['input']>;
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserPreferencesInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertEventFaqInput = {
  answer: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  question: Scalars['String']['input'];
};

export type UpsertSpotMenuInput = {
  accountId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  homemade?: InputMaybe<Scalars['Boolean']['input']>;
  img?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  pers?: InputMaybe<Scalars['Int']['input']>;
  price: PricesInput;
  suggested?: InputMaybe<Scalars['Boolean']['input']>;
  type: Scalars['String']['input'];
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  accounts: Array<Account>;
  birthdate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  emailTokenSentAt?: Maybe<Scalars['Date']['output']>;
  firstname: Scalars['String']['output'];
  gender?: Maybe<GenderEnum>;
  id: Scalars['ID']['output'];
  images: UserImages;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isVerified?: Maybe<Scalars['Boolean']['output']>;
  lastname: Scalars['String']['output'];
  mobilePhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferences: UserPreferences;
  ssoProvider?: Maybe<Scalars['String']['output']>;
  ssoProviderId?: Maybe<Scalars['String']['output']>;
  supportTickets: Array<SupportTicket>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  updates: Array<UserUpdates>;
};

export type UserImages = {
  __typename?: 'UserImages';
  avatar?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
};

export type UserPreferences = {
  __typename?: 'UserPreferences';
  language?: Maybe<Scalars['String']['output']>;
  theme: Scalars['String']['output'];
};

export type UserPushTokenInput = {
  device?: InputMaybe<Scalars['JSON']['input']>;
  platform: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UserUpdates = {
  __typename?: 'UserUpdates';
  action: Scalars['String']['output'];
  authorId: Scalars['ID']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type UsersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'Mutation', signup: boolean };

export type SignupSsoMutationVariables = Exact<{
  input: SignupSsoInput;
}>;


export type SignupSsoMutation = { __typename?: 'Mutation', signupSSO: { __typename?: 'User', id: string, firstname: string, lastname: string, birthdate?: any | null, gender?: GenderEnum | null } };

export type SearchAddressesQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchAddressesQuery = { __typename?: 'Query', searchAddresses: Array<{ __typename?: 'AddressSearch', label: string, postalCode: string, city: string }> };

export type GetSpotBySiretQueryVariables = Exact<{
  siret: Scalars['String']['input'];
}>;


export type GetSpotBySiretQuery = { __typename?: 'Query', getSpotBySiret: { __typename?: 'SpotBySiret', isExists: boolean, isConflict: boolean, isRegistered: boolean, name?: string | null, address?: string | null } };

export type ListMyBookingsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type ListMyBookingsQuery = { __typename?: 'Query', myBookings: Array<{ __typename?: 'Booking', id: string, ref: string, startTime: any, status: BookingStatusEnum, participants: number, occasion?: BookingOccasionEnum | null, origin: AccountTypeEnum, spot: { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null }, client: { __typename?: 'BookingClient', id: string, firstname: string, lastname?: string | null } | { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, deletedAt?: any | null } } }> };

export type ListMyEventsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type ListMyEventsQuery = { __typename?: 'Query', myEvents: Array<{ __typename?: 'Event', id: string, ref: string, title: string, description?: string | null, from: any, to?: any | null, status: EventStatusEnum, isPrivate: boolean, createdAt: any, publishedAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, covers: Array<{ __typename?: 'EventImage', id: string, url: string }>, creator: { __typename?: 'Consumer', id: string } | { __typename?: 'Maker', id: string } | { __typename?: 'Organizer', id: string } | { __typename?: 'Spot', id: string } | { __typename?: 'Support', id: string }, participants: { __typename?: 'Participants', eventId: string, invited: number, confirmed: number, interested: number, declined: number, canceled: number, removed: number, me?: { __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } | null, list: Array<{ __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } }> }, likers: { __typename?: 'Likers', count: number }, category?: { __typename?: 'EventCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, label: string }>, spot?: { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | null }> };

export type BookBySpotMutationVariables = Exact<{
  input: BookBySpotInput;
}>;


export type BookBySpotMutation = { __typename?: 'Mutation', bookBySpot: { __typename?: 'Booking', id: string, startTime: any, status: BookingStatusEnum, participants: number, occasion?: BookingOccasionEnum | null, origin: AccountTypeEnum, client: { __typename?: 'BookingClient', id: string, firstname: string, lastname?: string | null, email?: string | null, clientPhone: string } | { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, gender?: GenderEnum | null, birthdate?: any | null, mobilePhone?: string | null } } } };

export type OnBookingCreateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnBookingCreateSubscription = { __typename?: 'Subscription', bookingCreate: { __typename?: 'Booking', id: string, origin: AccountTypeEnum, status: BookingStatusEnum, occasion?: BookingOccasionEnum | null, date: string, time: string, startTime: any, endTime?: any | null, participants: number, createdAt: any, updatedAt?: any | null, author: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, deletedAt?: any | null } } | { __typename?: 'Spot', id: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } } };

export type OnBookingUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnBookingUpdateSubscription = { __typename?: 'Subscription', bookingUpdate: { __typename?: 'BookingUpdate', id: string, status?: BookingStatusEnum | null, message?: string | null, occasion?: BookingOccasionEnum | null, startTime?: any | null, participants?: number | null, createdAt: any, booking: { __typename?: 'Booking', id: string, origin: AccountTypeEnum, status: BookingStatusEnum, occasion?: BookingOccasionEnum | null, startTime: any, participants: number, createdAt: any }, author: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, deletedAt?: any | null } } | { __typename?: 'Spot', id: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } } };

export type BookingFragment = { __typename?: 'Booking', id: string, origin: AccountTypeEnum, status: BookingStatusEnum, occasion?: BookingOccasionEnum | null, startTime: any, participants: number, createdAt: any };

export type BookingUpdateFragment = { __typename?: 'BookingUpdate', id: string, status?: BookingStatusEnum | null, message?: string | null, occasion?: BookingOccasionEnum | null, startTime?: any | null, participants?: number | null, createdAt: any, booking: { __typename?: 'Booking', id: string, origin: AccountTypeEnum, status: BookingStatusEnum, occasion?: BookingOccasionEnum | null, startTime: any, participants: number, createdAt: any } };

export type GetAccountConversationQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetAccountConversationQuery = { __typename?: 'Query', accountConversation?: { __typename?: 'Conversation', id: string, name?: string | null, members: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer' } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support' }> } | null };

export type CreateConversationMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  participants: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateConversationMutation = { __typename?: 'Mutation', createConversation: { __typename?: 'Conversation', id: string, name?: string | null, members: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer' } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support' }> } };

export type HandleFriendMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  action: Scalars['String']['input'];
}>;


export type HandleFriendMutation = { __typename?: 'Mutation', handleFriend: { __typename?: 'Friend', id: string, isAccepted: boolean, isPending: boolean, isSent: boolean } };

export type GetFriendshipQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetFriendshipQuery = { __typename?: 'Query', getFriendship?: { __typename?: 'Friend', id: string, isAccepted: boolean, isPending: boolean, isSent: boolean } | null };

export type ListFriendsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type ListFriendsQuery = { __typename?: 'Query', listFriends: { __typename?: 'Friendships', active: { __typename?: 'FriendshipsDetail', count: number, list: Array<{ __typename?: 'Friend', id: string, isAccepted: boolean, isPending: boolean, isSent: boolean, friend: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } }> }, pending?: { __typename?: 'FriendshipsDetail', count: number, list: Array<{ __typename?: 'Friend', id: string, isAccepted: boolean, isPending: boolean, isSent: boolean, friend: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } }> } | null } };

export type SearchFriendsQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type SearchFriendsQuery = { __typename?: 'Query', searchFriends: Array<{ __typename?: 'Friend', id: string, isAccepted: boolean, isPending: boolean, isSent: boolean, friend: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, type: AccountImageTypeEnum, fileId: string, fileName: string, size: number, mimeType: string } | null } }> };

export type SearchMyFriendsQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type SearchMyFriendsQuery = { __typename?: 'Query', searchMyFriends: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }> };

export type GetConsumerDetailedQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetConsumerDetailedQuery = { __typename?: 'Query', consumer: { __typename?: 'Consumer', id: string, name: string, slug: string, description?: string | null, isFollowing: boolean, isMyFriend: boolean, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, following: Array<{ __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }>, friendships: { __typename?: 'Friendships', active: { __typename?: 'FriendshipsDetail', count: number }, pending?: { __typename?: 'FriendshipsDetail', count: number, list: Array<{ __typename?: 'Friend', id: string, isAccepted: boolean, isPending: boolean, isSent: boolean, friend: { __typename?: 'Consumer', id: string, name: string } }> } | null }, events: Array<{ __typename?: 'Event', id: string, title: string, description?: string | null, status: EventStatusEnum, from: any, to?: any | null, thumb?: string | null, flyer?: string | null, meta: any, settings: any, publishedAt?: any | null, updatedAt?: any | null, covers: Array<{ __typename?: 'EventImage', id: string, idx: number, url: string, type: EventImageTypeEnum, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, tickets: Array<{ __typename?: 'EventTicket', id: string, idx: number, label: string, description?: string | null, currency: string, price: number, quantity: number, from?: any | null, to?: any | null }>, makers: Array<{ __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, category?: { __typename?: 'EventCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, label: string }> }> } };

export type UpdateEventParticipantsMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  participantIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateEventParticipantsMutation = { __typename?: 'Mutation', updateEventParticipants: { __typename?: 'Event', id: string, participants: { __typename?: 'Participants', eventId: string, invited: number, confirmed: number, interested: number, declined: number, canceled: number, removed: number, me?: { __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } | null, list: Array<{ __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } }> } } };

export type UpsertEventFaqMutationVariables = Exact<{
  input: UpsertEventFaqInput;
}>;


export type UpsertEventFaqMutation = { __typename?: 'Mutation', upsertEventFAQ: { __typename?: 'FAQs', id: string, idx: number, question: string, answer: string } };

export type RemoveEventFaqMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveEventFaqMutation = { __typename?: 'Mutation', removeEventFAQ: boolean };

export type SortEventFaqMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  order: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SortEventFaqMutation = { __typename?: 'Mutation', sortEventFAQ: Array<{ __typename?: 'FAQs', id: string, idx: number }> };

export type UpsertEventImageMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  type: EventImageTypeEnum;
  image: Scalars['Upload']['input'];
}>;


export type UpsertEventImageMutation = { __typename?: 'Mutation', upsertEventImage: { __typename?: 'Image', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } };

export type RemoveEventImageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RemoveEventImageMutation = { __typename?: 'Mutation', removeEventImage: boolean };

export type GetEventDetailedQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventDetailedQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: string, isLiking: boolean, isPrivate: boolean, title: string, description?: string | null, thumb?: string | null, flyer?: string | null, status: EventStatusEnum, from: any, to?: any | null, category?: { __typename?: 'EventCategory', id: string, name: string, description?: string | null } | null, address?: { __typename?: 'Address', label: string, id: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null, FAQs: Array<{ __typename?: 'FAQs', id: string, idx: number, question: string, answer: string }>, creator: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }, participants: { __typename?: 'Participants', eventId: string, invited: number, confirmed: number, interested: number, declined: number, canceled: number, removed: number, me?: { __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } | null, list: Array<{ __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } }> }, likers: { __typename?: 'Likers', eventId: string, count: number, accounts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer' } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support' }> }, tickets: Array<{ __typename?: 'EventTicket', id: string, idx: number, from?: any | null, label: string, description?: string | null, to?: any | null, price: number, currency: string }>, spot?: { __typename?: 'Spot', id: string, name: string, slug: string, covers: Array<{ __typename?: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, avatar?: { __typename?: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, address?: { __typename?: 'Address', id: string, city: string, label: string, latitude: number, longitude: number, placeId?: string | null } | null, type: { __typename?: 'SpotType', id: string, amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, casino?: boolean | null, concertHall?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null, updatedAt?: any | null }, configuration: { __typename?: 'SpotConfiguration', id: string, defaultImage?: string | null, pricing?: SpotPricingEnum | null, primaryType?: SpotTypeEnum | null, secondaryType?: SpotTypeEnum | null, tertiaryType?: SpotTypeEnum | null, closeSpaces?: number | null, entryPrice?: any | null, capacity?: number | null, musicalGenre?: SpotMusicalGenreEnum | null, updatedAt?: any | null } } | null, tags: Array<{ __typename?: 'Tag', id: string, label: string }>, updates: Array<{ __typename?: 'EventUpdate', id: string, from?: any | null, to?: any | null, status?: EventStatusEnum | null, title?: string | null, description?: string | null, message?: string | null, createdAt: any }>, makers: Array<{ __typename: 'Maker', id: string, name: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> } };

export type LikeEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type LikeEventMutation = { __typename?: 'Mutation', likeEvent: boolean };

export type UnlikeEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type UnlikeEventMutation = { __typename?: 'Mutation', unlikeEvent: boolean };

export type UpdateEventParticipationMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  status: EventParticipationStatusEnum;
}>;


export type UpdateEventParticipationMutation = { __typename?: 'Mutation', updateEventParticipation: { __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null } };

export type GetSpotDetailedQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
  withDeletedAt?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetSpotDetailedQuery = { __typename?: 'Query', spot: { __typename?: 'Spot', id: string, name: string, slug: string, description?: string | null, isFollowing: boolean, isActive: boolean, isVerified: boolean, deletedAt?: any | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, addicts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }>, feedbacks: Array<{ __typename?: 'SpotFeedback', id: string, rate?: number | null, text?: string | null, createdAt: any, updatedAt?: any | null, author: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } }>, address?: { __typename?: 'Address', id: string, city: string, label: string, placeId?: string | null, timezone?: string | null } | null, FAQs: Array<{ __typename?: 'FAQs', id: string, idx: number, question: string, answer: string }>, opening: Array<{ __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null }>, closing: Array<{ __typename?: 'SpotSchedulesClosing', id: string, reason?: string | null, description: string, from: any, to?: any | null }>, atmosphere: { __typename?: 'SpotAtmosphere', id: string, calm?: boolean | null, lively?: boolean | null, dancing?: boolean | null, updatedAt?: any | null }, bringable: { __typename?: 'SpotBringable', id: string, birthdayCake?: boolean | null, drinks?: boolean | null, food?: boolean | null, dogs?: boolean | null, updatedAt?: any | null }, configuration: { __typename?: 'SpotConfiguration', id: string, defaultImage?: string | null, pricing?: SpotPricingEnum | null, primaryType?: SpotTypeEnum | null, secondaryType?: SpotTypeEnum | null, tertiaryType?: SpotTypeEnum | null, closeSpaces?: number | null, entryPrice?: any | null, capacity?: number | null, musicalGenre?: SpotMusicalGenreEnum | null, isClaimed?: boolean | null, isEphemeral?: boolean | null, updatedAt?: any | null }, equipment: { __typename?: 'SpotEquipment', id: string, amphitheater?: boolean | null, auditorium?: boolean | null, changingTable?: boolean | null, dancefloor?: boolean | null, locker?: boolean | null, microphone?: boolean | null, parking?: boolean | null, prmAccess?: boolean | null, prmToilets?: boolean | null, smokingRoom?: boolean | null, sono?: boolean | null, stage?: boolean | null, terrace?: boolean | null, toilets?: boolean | null, updatedAt?: any | null, video?: boolean | null, wifi?: boolean | null }, highlight: { __typename?: 'SpotHighlight', id: string, mountainView?: boolean | null, oceanView?: boolean | null, rooftop?: boolean | null, seaView?: boolean | null, sunset?: boolean | null, sunrise?: boolean | null }, service: { __typename?: 'SpotService', id: string, dj?: boolean | null, entertainmentShow?: boolean | null, karaoke?: boolean | null, liveMusic?: boolean | null, ownMusic?: boolean | null, takeout?: boolean | null, updatedAt?: any | null }, payment: { __typename?: 'SpotPayment', id: string, amex?: boolean | null, blueCard?: boolean | null, cash?: boolean | null, checks?: boolean | null, mealTickets?: boolean | null, updatedAt?: any | null }, suitable: { __typename?: 'SpotSuitable', id: string, afterwork?: boolean | null, bachelor?: boolean | null, birthday?: boolean | null, businessMeal?: boolean | null, cocktailPro?: boolean | null, companyEvent?: boolean | null, exposition?: boolean | null, kids?: boolean | null, farewell?: boolean | null, fashionShow?: boolean | null, friendsDrink?: boolean | null, productLaunch?: boolean | null, studentParty?: boolean | null, teamMeal?: boolean | null, telework?: boolean | null, veggie?: boolean | null, vegan?: boolean | null, watchSport?: boolean | null, wedding?: boolean | null, updatedAt?: any | null }, type: { __typename?: 'SpotType', id: string, bar?: boolean | null, cafe?: boolean | null, nightClub?: boolean | null, restaurant?: boolean | null, updatedAt?: any | null }, events: Array<{ __typename?: 'Event', id: string, title: string, description?: string | null, from: any, to?: any | null, thumb?: string | null, flyer?: string | null, meta: any, settings: any, publishedAt?: any | null, updatedAt?: any | null, covers: Array<{ __typename?: 'EventImage', id: string, idx: number, url: string, type: EventImageTypeEnum, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, tickets: Array<{ __typename?: 'EventTicket', id: string, idx: number, label: string, description?: string | null, currency: string, price: number, quantity: number, from?: any | null, to?: any | null }>, makers: Array<{ __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, category?: { __typename?: 'EventCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, label: string }> }> } };

export type GetSpoEventsQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetSpoEventsQuery = { __typename?: 'Query', spot: { __typename?: 'Spot', id: string, events: Array<{ __typename?: 'Event', id: string, title: string, description?: string | null, from: any, to?: any | null, thumb?: string | null, flyer?: string | null, meta: any, settings: any, publishedAt?: any | null, updatedAt?: any | null, covers: Array<{ __typename?: 'EventImage', id: string, idx: number, url: string, type: EventImageTypeEnum, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, tickets: Array<{ __typename?: 'EventTicket', id: string, idx: number, label: string, description?: string | null, currency: string, price: number, quantity: number, from?: any | null, to?: any | null }>, makers: Array<{ __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, category?: { __typename?: 'EventCategory', id: string, name: string } | null, tags: Array<{ __typename?: 'Tag', id: string, label: string }> }> } };

export type FollowMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type FollowMutation = { __typename?: 'Mutation', follow: { __typename?: 'Consumer', id: string } | { __typename?: 'Maker', id: string } | { __typename?: 'Organizer', id: string } | { __typename?: 'Spot', id: string, isFollowing: boolean, addicts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null }> } | { __typename?: 'Support' } };

export type UnfollowMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type UnfollowMutation = { __typename?: 'Mutation', unfollow: { __typename?: 'Consumer', id: string } | { __typename?: 'Maker', id: string } | { __typename?: 'Organizer', id: string } | { __typename?: 'Spot', id: string, isFollowing: boolean, addicts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string }> } | { __typename?: 'Support' } };

export type BookByConsumerMutationVariables = Exact<{
  input: BookByConsumerInput;
}>;


export type BookByConsumerMutation = { __typename?: 'Mutation', bookByConsumer: { __typename?: 'Booking', id: string, startTime: any, status: BookingStatusEnum, occasion?: BookingOccasionEnum | null, participants: number, updates: Array<{ __typename?: 'BookingUpdate', message?: string | null }>, spot: { __typename?: 'Spot', id: string, name: string } } };

export type RegisterMobilePhoneMutationVariables = Exact<{
  mobilePhone: Scalars['String']['input'];
}>;


export type RegisterMobilePhoneMutation = { __typename?: 'Mutation', registerMobilePhone: { __typename?: 'User', id: string, mobilePhone?: string | null } };

export type ClaimSpotMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ClaimInput;
}>;


export type ClaimSpotMutation = { __typename?: 'Mutation', claimSpot: boolean };

export type UpsertAvatarMutationVariables = Exact<{
  avatar: Scalars['Upload']['input'];
}>;


export type UpsertAvatarMutation = { __typename?: 'Mutation', upsertAvatar: { __typename?: 'Image', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } };

export type RemoveAvatarMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAvatarMutation = { __typename?: 'Mutation', removeAvatar: boolean };

export type UpdateSpotAtmosphereMutationVariables = Exact<{
  input: UpdateSpotAtmosphereInput;
}>;


export type UpdateSpotAtmosphereMutation = { __typename?: 'Mutation', updateSpotAtmosphere: { __typename?: 'SpotAtmosphere', id: string, calm?: boolean | null, lively?: boolean | null, dancing?: boolean | null, updatedAt?: any | null } };

export type UpdateSpotBringableMutationVariables = Exact<{
  input: UpdateSpotBringableInput;
}>;


export type UpdateSpotBringableMutation = { __typename?: 'Mutation', updateSpotBringable: { __typename?: 'SpotBringable', id: string, dogs?: boolean | null, food?: boolean | null, drinks?: boolean | null, birthdayCake?: boolean | null, updatedAt?: any | null } };

export type UpdateSpotPricingMutationVariables = Exact<{
  pricing: SpotPricingEnum;
}>;


export type UpdateSpotPricingMutation = { __typename?: 'Mutation', updateSpotPricing: { __typename?: 'SpotConfiguration', id: string, pricing?: SpotPricingEnum | null } };

export type UpdateSpotCapacityMutationVariables = Exact<{
  value: Scalars['Int']['input'];
}>;


export type UpdateSpotCapacityMutation = { __typename?: 'Mutation', updateSpotCapacity: { __typename?: 'SpotConfiguration', id: string, capacity?: number | null } };

export type UpdateSpotCloseSpacesMutationVariables = Exact<{
  value: Scalars['Int']['input'];
}>;


export type UpdateSpotCloseSpacesMutation = { __typename?: 'Mutation', updateSpotCloseSpaces: { __typename?: 'SpotConfiguration', id: string, closeSpaces?: number | null } };

export type UpdateSpotEquipmentMutationVariables = Exact<{
  input: UpdateSpotEquipmentInput;
}>;


export type UpdateSpotEquipmentMutation = { __typename?: 'Mutation', updateSpotEquipment: { __typename?: 'SpotEquipment', id: string, amphitheater?: boolean | null, auditorium?: boolean | null, sono?: boolean | null, wifi?: boolean | null, stage?: boolean | null, video?: boolean | null, locker?: boolean | null, terrace?: boolean | null, toilets?: boolean | null, prmAccess?: boolean | null, dancefloor?: boolean | null, microphone?: boolean | null, prmToilets?: boolean | null, smokingRoom?: boolean | null, parking?: boolean | null, changingTable?: boolean | null, updatedAt?: any | null } };

export type UpdateSpotPaymentMutationVariables = Exact<{
  input: UpdateSpotPaymentInput;
}>;


export type UpdateSpotPaymentMutation = { __typename?: 'Mutation', updateSpotPayment: { __typename?: 'SpotPayment', id: string, amex?: boolean | null, cash?: boolean | null, checks?: boolean | null, blueCard?: boolean | null, mealTickets?: boolean | null, updatedAt?: any | null } };

export type UpdateSpotServiceMutationVariables = Exact<{
  input: UpdateSpotServiceInput;
}>;


export type UpdateSpotServiceMutation = { __typename?: 'Mutation', updateSpotService: { __typename?: 'SpotService', id: string, dj?: boolean | null, karaoke?: boolean | null, ownMusic?: boolean | null, liveMusic?: boolean | null, entertainmentShow?: boolean | null, takeout?: boolean | null, updatedAt?: any | null } };

export type UpdateSpotSuitableMutationVariables = Exact<{
  input: UpdateSpotSuitableInput;
}>;


export type UpdateSpotSuitableMutation = { __typename?: 'Mutation', updateSpotSuitable: { __typename?: 'SpotSuitable', id: string, bachelor?: boolean | null, birthday?: boolean | null, farewell?: boolean | null, teamMeal?: boolean | null, wedding?: boolean | null, afterwork?: boolean | null, exposition?: boolean | null, cocktailPro?: boolean | null, fashionShow?: boolean | null, businessMeal?: boolean | null, companyEvent?: boolean | null, friendsDrink?: boolean | null, studentParty?: boolean | null, productLaunch?: boolean | null, kids?: boolean | null, watchSport?: boolean | null, telework?: boolean | null, veggie?: boolean | null, vegan?: boolean | null, updatedAt?: any | null } };

export type UpdateSpotTypeMutationVariables = Exact<{
  input: UpdateSpotTypeInput;
}>;


export type UpdateSpotTypeMutation = { __typename?: 'Mutation', updateSpotType: { __typename?: 'SpotType', id: string, amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, concertHall?: boolean | null, casino?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null, updatedAt?: any | null } };

export type GetAccountNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountNotificationsQuery = { __typename?: 'Query', getAccountNotifications: { __typename: 'ConsumerNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, request: { __typename?: 'ConsumerRequestNotifications', friendship: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, message: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, mention: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, booking: { __typename?: 'ConsumerBookingNotifications', update: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, message: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, event: { __typename?: 'ConsumerEventNotifications', invitation: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, update: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, upcoming: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'MakerNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'OrganizerNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'SpotNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, request: { __typename?: 'SpotRequestNotifications', message: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, mention: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, booking: { __typename?: 'SpotBookingNotifications', new: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, update: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, late: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, feedback: { __typename?: 'AccountFeedbackNotifications', new: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'SupportNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } };

export type UpdateNotificationsMutationVariables = Exact<{
  input: UpdateNotificationInput;
}>;


export type UpdateNotificationsMutation = { __typename?: 'Mutation', updateNotifications: { __typename: 'ConsumerNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, booking: { __typename?: 'ConsumerBookingNotifications', update: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, message: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, event: { __typename?: 'ConsumerEventNotifications', invitation: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, update: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, upcoming: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'MakerNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'OrganizerNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'SpotNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, request: { __typename?: 'SpotRequestNotifications', message: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, mention: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, booking: { __typename?: 'SpotBookingNotifications', new: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, update: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } }, late: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } }, feedback: { __typename?: 'AccountFeedbackNotifications', new: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } | { __typename: 'SupportNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } } };

export type GetConversationQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetConversationQuery = { __typename?: 'Query', conversation: { __typename?: 'Conversation', id: string, name?: string | null, lastReadMessageId?: string | null, lastMessage?: { __typename?: 'Message', id: string } | null, members: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }>, messages: { __typename?: 'MessageConnection', edges: Array<{ __typename?: 'MessageEdge', cursor: string, node: { __typename?: 'Message', id: string, conversationId: string, content: string, createdAt: any, sender: { __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } };

export type GetConversationInfosQueryVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type GetConversationInfosQuery = { __typename?: 'Query', conversation: { __typename?: 'Conversation', id: string, name?: string | null, lastReadMessageId?: string | null, lastMessage?: { __typename?: 'Message', id: string } | null, members: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }> } };

export type ResetUnreadCountMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type ResetUnreadCountMutation = { __typename?: 'Mutation', resetUnreadCount: boolean };

export type SendMessageMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage: boolean };

export type OnTypingSubscriptionVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type OnTypingSubscription = { __typename?: 'Subscription', typing: { __typename?: 'TypingEvent', conversationId: string, senderId: string, isTyping: boolean } };

export type SetTypingMutationVariables = Exact<{
  conversationId: Scalars['ID']['input'];
  isTyping: Scalars['Boolean']['input'];
}>;


export type SetTypingMutation = { __typename?: 'Mutation', setTyping: boolean };

export type OnMessageSentSubscriptionVariables = Exact<{
  conversationId: Scalars['ID']['input'];
}>;


export type OnMessageSentSubscription = { __typename?: 'Subscription', messageSent: { __typename?: 'MessageEdge', cursor: string, node: { __typename?: 'Message', id: string, content: string, createdAt: any, conversationId: string, sender: { __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } } };

export type ListConversationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListConversationsQuery = { __typename?: 'Query', conversations: Array<{ __typename?: 'Conversation', id: string, name?: string | null, unreadCount: number, members: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }>, lastMessage?: { __typename?: 'Message', id: string, content: string, createdAt: any, sender: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } | null }> };

export type OnConversationUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnConversationUpdateSubscription = { __typename?: 'Subscription', conversationUpdate: { __typename?: 'Conversation', id: string, name?: string | null, unreadCount: number, members: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }>, lastMessage?: { __typename?: 'Message', id: string, content: string, createdAt: any, sender: { __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } | null } };

export type NotificationFieldsFragment = { __typename?: 'Notification', id: string, entityId: string, title: string, subtitle?: string | null, type: NotificationTypeEnum, action: NotificationActionEnum, count: number, link?: string | null, createdAt: any, source?: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | null };

export type ListNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, entityId: string, title: string, subtitle?: string | null, type: NotificationTypeEnum, action: NotificationActionEnum, count: number, link?: string | null, createdAt: any, source?: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | null }> };

export type MarkNotificationAsReadMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead: { __typename?: 'Notification', id: string, count: number } };

export type OnNotificationUpdateSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNotificationUpdateSubscription = { __typename?: 'Subscription', notificationUpdate: { __typename?: 'Notification', id: string, entityId: string, title: string, subtitle?: string | null, type: NotificationTypeEnum, action: NotificationActionEnum, count: number, link?: string | null, createdAt: any, source?: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | null } };

export type OnNotificationDeleteSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnNotificationDeleteSubscription = { __typename?: 'Subscription', notificationDelete: string };

export type GetConsumerMetaQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetConsumerMetaQuery = { __typename?: 'Query', consumer: { __typename?: 'Consumer', id: string, name: string, description?: string | null, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } };

export type GetSpotMetaQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetSpotMetaQuery = { __typename?: 'Query', spot: { __typename?: 'Spot', id: string, name: string, description?: string | null, slug: string, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> } };

export type GetEventMetaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventMetaQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: string, title: string, description?: string | null, covers: Array<{ __typename?: 'EventImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> } };

export type GetBookingMetaQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingMetaQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id: string, startTime: any, origin: AccountTypeEnum, spot: { __typename?: 'Spot', id: string, slug: string, name: string }, client: { __typename?: 'BookingClient', id: string, firstname: string } | { __typename?: 'Consumer', id: string, user: { __typename?: 'User', id: string, firstname: string } } } };

export type IsSlugAvailableQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type IsSlugAvailableQuery = { __typename?: 'Query', isSlugAvailable: boolean };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Consumer', id: string, name: string, slug: string } | { __typename?: 'Maker', id: string, name: string, slug: string } | { __typename?: 'Organizer' } | { __typename?: 'Spot', id: string, name: string, slug: string } | { __typename?: 'Support' } };

export type UpdateAccountDescriptionMutationVariables = Exact<{
  input: UpdateAccountDescriptionInput;
}>;


export type UpdateAccountDescriptionMutation = { __typename?: 'Mutation', updateAccountDescription: boolean };

export type UpsertSpotMenuMutationVariables = Exact<{
  input: UpsertSpotMenuInput;
}>;


export type UpsertSpotMenuMutation = { __typename?: 'Mutation', upsertSpotMenu: boolean };

export type IsEmailAvailableQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type IsEmailAvailableQuery = { __typename?: 'Query', isEmailAvailable: boolean };

export type IsPasswordValidMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type IsPasswordValidMutation = { __typename?: 'Mutation', isPasswordValid: boolean };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type SwitchAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SwitchAccountMutation = { __typename?: 'Mutation', switchAccount: boolean };

export type SaveUserPushTokenMutationVariables = Exact<{
  input: UserPushTokenInput;
}>;


export type SaveUserPushTokenMutation = { __typename?: 'Mutation', saveUserPushToken?: boolean | null };

export type GetSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSessionQuery = { __typename?: 'Query', session?: { __typename?: 'User', id: string, ssoProvider?: string | null, email: string, emailTokenSentAt?: any | null, firstname: string, lastname: string, gender?: GenderEnum | null, birthdate?: any | null, mobilePhone?: string | null, isActive?: boolean | null, isVerified?: boolean | null, isDelete?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deletedAt?: any | null, preferences: { __typename?: 'UserPreferences', language?: string | null, theme: string }, accounts: Array<{ __typename: 'Consumer', id: string, isCurrent: boolean, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, isPrivate: boolean, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, isCurrent: boolean, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, isCurrent: boolean, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, isCurrent: boolean, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, address?: { __typename?: 'Address', id: string, timezone?: string | null } | null, notifications: { __typename?: 'SpotNotifications', id: string, standby: { __typename?: 'AccountStandbyNotifications', all: { __typename?: 'AccountNotification', email: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean }, push: { __typename?: 'NotificationChannelPreference', enabled: boolean, isOverridable: boolean } } } }, opening: Array<{ __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null, updatedAt?: any | null }>, closing: Array<{ __typename?: 'SpotSchedulesClosing', id: string, reason?: string | null, description: string, from: any, to?: any | null, updatedAt?: any | null }>, atmosphere: { __typename?: 'SpotAtmosphere', id: string, calm?: boolean | null, lively?: boolean | null, dancing?: boolean | null, updatedAt?: any | null }, bringable: { __typename?: 'SpotBringable', id: string, dogs?: boolean | null, food?: boolean | null, drinks?: boolean | null, birthdayCake?: boolean | null, updatedAt?: any | null }, configuration: { __typename?: 'SpotConfiguration', id: string, defaultImage?: string | null, primaryType?: SpotTypeEnum | null, secondaryType?: SpotTypeEnum | null, tertiaryType?: SpotTypeEnum | null, pricing?: SpotPricingEnum | null, closeSpaces?: number | null, musicalGenre?: SpotMusicalGenreEnum | null, capacity?: number | null, entryPrice?: any | null, updatedAt?: any | null }, equipment: { __typename?: 'SpotEquipment', id: string, amphitheater?: boolean | null, auditorium?: boolean | null, sono?: boolean | null, wifi?: boolean | null, stage?: boolean | null, video?: boolean | null, locker?: boolean | null, terrace?: boolean | null, toilets?: boolean | null, prmAccess?: boolean | null, dancefloor?: boolean | null, microphone?: boolean | null, prmToilets?: boolean | null, smokingRoom?: boolean | null, parking?: boolean | null, changingTable?: boolean | null, updatedAt?: any | null }, highlight: { __typename?: 'SpotHighlight', id: string, mountainView?: boolean | null, oceanView?: boolean | null, rooftop?: boolean | null, seaView?: boolean | null, sunset?: boolean | null, sunrise?: boolean | null, updatedAt?: any | null }, payment: { __typename?: 'SpotPayment', id: string, amex?: boolean | null, cash?: boolean | null, checks?: boolean | null, blueCard?: boolean | null, mealTickets?: boolean | null, updatedAt?: any | null }, service: { __typename?: 'SpotService', id: string, dj?: boolean | null, karaoke?: boolean | null, ownMusic?: boolean | null, liveMusic?: boolean | null, entertainmentShow?: boolean | null, takeout?: boolean | null, updatedAt?: any | null }, suitable: { __typename?: 'SpotSuitable', id: string, bachelor?: boolean | null, birthday?: boolean | null, farewell?: boolean | null, teamMeal?: boolean | null, wedding?: boolean | null, afterwork?: boolean | null, exposition?: boolean | null, cocktailPro?: boolean | null, fashionShow?: boolean | null, businessMeal?: boolean | null, companyEvent?: boolean | null, friendsDrink?: boolean | null, studentParty?: boolean | null, productLaunch?: boolean | null, kids?: boolean | null, watchSport?: boolean | null, telework?: boolean | null, veggie?: boolean | null, vegan?: boolean | null, updatedAt?: any | null }, type: { __typename?: 'SpotType', id: string, amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, concertHall?: boolean | null, casino?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null, updatedAt?: any | null } } | { __typename: 'Support', id: string, isCurrent: boolean, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }> } | null };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Tokens', access: string, refresh: string } };

export type RefreshTokensMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokensMutation = { __typename?: 'Mutation', refreshTokens: { __typename?: 'Tokens', access: string, refresh: string } };

export type LoginSsoMutationVariables = Exact<{
  input: LoginSsoInput;
}>;


export type LoginSsoMutation = { __typename?: 'Mutation', loginSSO: { __typename: 'ProfileSSO', email: string, firstname?: string | null, lastname?: string | null, avatar?: { __typename?: 'Image', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Tokens', access: string, refresh: string } };

export type GetUserByEmailTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type GetUserByEmailTokenQuery = { __typename?: 'Query', userByEmailToken?: { __typename?: 'User', id: string, isVerified?: boolean | null } | null };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail: { __typename?: 'User', id: string, isVerified?: boolean | null, isActive?: boolean | null, updatedAt?: any | null } };

export type ReSendActivationMailMutationVariables = Exact<{ [key: string]: never; }>;


export type ReSendActivationMailMutation = { __typename?: 'Mutation', reSendActivationMail: { __typename?: 'User', id: string, emailTokenSentAt?: any | null } };

export type LogoutMutationVariables = Exact<{
  FCMToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: boolean };

export type ListCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, name: string, description?: string | null, cover?: string | null }> };

export type EventsQueryVariables = Exact<{
  input: EventsInput;
}>;


export type EventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: string, title: string, description?: string | null, thumb?: string | null, flyer?: string | null, status: EventStatusEnum, isPrivate: boolean, from: any, to?: any | null, category?: { __typename?: 'EventCategory', id: string, name: string, description?: string | null } | null, address?: { __typename?: 'Address', id: string, city: string, label: string, latitude: number, longitude: number, placeId?: string | null } | null, makers: Array<{ __typename: 'Maker', id: string, name: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }> };

export type EventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EventQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: string, title: string, description?: string | null, thumb?: string | null, flyer?: string | null, status: EventStatusEnum, isPrivate: boolean, from: any, to?: any | null, category?: { __typename?: 'EventCategory', id: string, name: string, description?: string | null } | null, address?: { __typename?: 'Address', id: string, city: string, label: string, latitude: number, longitude: number, placeId?: string | null } | null, makers: Array<{ __typename: 'Maker', id: string, name: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> } };

export type GuestFragmentFragment = { __typename: 'Maker', id: string, name: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> };

type ConversationMemberFields_Consumer_Fragment = { __typename: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null };

type ConversationMemberFields_Maker_Fragment = { __typename: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null };

type ConversationMemberFields_Organizer_Fragment = { __typename: 'Organizer' };

type ConversationMemberFields_Spot_Fragment = { __typename: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null };

type ConversationMemberFields_Support_Fragment = { __typename: 'Support' };

export type ConversationMemberFieldsFragment = ConversationMemberFields_Consumer_Fragment | ConversationMemberFields_Maker_Fragment | ConversationMemberFields_Organizer_Fragment | ConversationMemberFields_Spot_Fragment | ConversationMemberFields_Support_Fragment;

export type AddressFragmentFragment = { __typename?: 'Address', id: string, city: string, label: string, latitude: number, longitude: number, placeId?: string | null };

export type EventFragmentFragment = { __typename?: 'Event', id: string, title: string, description?: string | null, thumb?: string | null, flyer?: string | null, status: EventStatusEnum, isPrivate: boolean, from: any, to?: any | null, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> };

export type CategoryFragmentFragment = { __typename?: 'EventCategory', id: string, name: string, description?: string | null };

export type AccountImageFragmentFragment = { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any };

export type EventImageFragmentFragment = { __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstname: string, lastname: string, gender?: GenderEnum | null, email: string, birthdate?: any | null } };

export type UpdateUserPreferencesMutationVariables = Exact<{
  input: UpdateUserPreferencesInput;
}>;


export type UpdateUserPreferencesMutation = { __typename?: 'Mutation', updateUserPreferences?: boolean | null };

export type ListHomeEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomeEventsQuery = { __typename?: 'Query', eventCategories: Array<{ __typename?: 'EventCategory', id: string, name: string, events: Array<{ __typename?: 'Event', id: string, title: string, description?: string | null, thumb?: string | null, flyer?: string | null, status: EventStatusEnum, isPrivate: boolean, from: any, to?: any | null, category?: { __typename?: 'EventCategory', id: string, name: string, description?: string | null } | null, address?: { __typename?: 'Address', label: string, id: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null, spot?: { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, address?: { __typename?: 'Address', id: string, city: string, label: string, latitude: number, longitude: number, placeId?: string | null } | null, configuration: { __typename?: 'SpotConfiguration', id: string, defaultImage?: string | null, primaryType?: SpotTypeEnum | null, secondaryType?: SpotTypeEnum | null, tertiaryType?: SpotTypeEnum | null, pricing?: SpotPricingEnum | null }, type: { __typename?: 'SpotType', id: string, amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, concertHall?: boolean | null, casino?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null } } | null, makers: Array<{ __typename: 'Maker', id: string, name: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, tickets: Array<{ __typename?: 'EventTicket', id: string, idx: number, currency: string, price: number }>, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }> }> };

export type GetEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: string, title: string, description?: string | null, thumb?: string | null, flyer?: string | null, status: EventStatusEnum, isPrivate: boolean, from: any, to?: any | null, category?: { __typename?: 'EventCategory', id: string, name: string, description?: string | null } | null, address?: { __typename?: 'Address', label: string, id: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null, FAQs: Array<{ __typename?: 'FAQs', id: string, idx: number, question: string, answer: string }>, spot?: { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, address?: { __typename?: 'Address', id: string, city: string, label: string, latitude: number, longitude: number, placeId?: string | null } | null, type: { __typename?: 'SpotType', id: string, amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, casino?: boolean | null, concertHall?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null, updatedAt?: any | null }, configuration: { __typename?: 'SpotConfiguration', id: string, defaultImage?: string | null, closeSpaces?: number | null, entryPrice?: any | null, primaryType?: SpotTypeEnum | null, pricing?: SpotPricingEnum | null, capacity?: number | null, musicalGenre?: SpotMusicalGenreEnum | null, updatedAt?: any | null } } | null, makers: Array<{ __typename: 'Maker', id: string, name: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> }>, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }> } };

export type ListHomeMakersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomeMakersQuery = { __typename?: 'Query', homeMakers: Array<{ __typename?: 'HomeMakers', id: string, title: string, makers: Array<{ __typename?: 'Maker', id: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, address?: { __typename?: 'Address', label: string, id: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null }> }> };

export type GetSpotStatsQueryVariables = Exact<{
  range: Scalars['String']['input'];
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetSpotStatsQuery = { __typename?: 'Query', getSpotStats: { __typename?: 'SpotStats', id: string, addicts: { __typename?: 'SpotStatsCard', current?: number | null, previous?: number | null, dataSet: Array<number> }, bookings: { __typename?: 'SpotStatsCard', current?: number | null, previous?: number | null, dataSet: Array<number> }, events: { __typename?: 'SpotStatsCard', current?: number | null, previous?: number | null, dataSet: Array<number> }, transformation: { __typename?: 'SpotStatsCard', current?: number | null, previous?: number | null, dataSet: Array<number> }, bounces: { __typename?: 'SpotStatsCard', current?: number | null, previous?: number | null, dataSet: Array<number> }, views: { __typename?: 'SpotStatsCard', current?: number | null, previous?: number | null, dataSet: Array<number> } } };

export type ListMySpotBookingsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type ListMySpotBookingsQuery = { __typename?: 'Query', myBookings: Array<{ __typename?: 'Booking', id: string, ref: string, startTime: any, status: BookingStatusEnum, participants: number, occasion?: BookingOccasionEnum | null, origin: AccountTypeEnum, client: { __typename?: 'BookingClient', id: string, firstname: string, lastname?: string | null, email?: string | null, clientPhone: string } | { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, gender?: GenderEnum | null, birthdate?: any | null, mobilePhone?: string | null, deletedAt?: any | null } } }> };

export type SpotSchedulesQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type SpotSchedulesQuery = { __typename?: 'Query', spotSchedules: { __typename?: 'Spot', id: string, name: string, opening: Array<{ __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null }>, closing: Array<{ __typename?: 'SpotSchedulesClosing', id: string, reason?: string | null, description: string, from: any, to?: any | null }> } };

export type GetConsumerBookingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetConsumerBookingQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id: string, ref: string, startTime: any, status: BookingStatusEnum, participants: number, occasion?: BookingOccasionEnum | null, origin: AccountTypeEnum, spot: { __typename?: 'Spot', id: string, slug: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, address?: { __typename?: 'Address', id: string, label: string, houseNumber: string, street: string, city: string, postalCode: string } | null, opening: Array<{ __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null }>, closing: Array<{ __typename?: 'SpotSchedulesClosing', id: string, reason?: string | null, description: string, from: any, to?: any | null }> }, updates: Array<{ __typename?: 'BookingUpdate', id: string, status?: BookingStatusEnum | null, message?: string | null, occasion?: BookingOccasionEnum | null, startTime?: any | null, participants?: number | null, createdAt: any, author: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, deletedAt?: any | null } } | { __typename?: 'Spot', id: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } }> } };

export type GetSpotBookingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSpotBookingQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', id: string, ref: string, startTime: any, status: BookingStatusEnum, participants: number, occasion?: BookingOccasionEnum | null, origin: AccountTypeEnum, spot: { __typename?: 'Spot', id: string, slug: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, address?: { __typename?: 'Address', id: string, label: string } | null, opening: Array<{ __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null }>, closing: Array<{ __typename?: 'SpotSchedulesClosing', id: string, reason?: string | null, description: string, from: any, to?: any | null }> }, client: { __typename?: 'BookingClient', id: string, firstname: string, lastname?: string | null, email?: string | null, clientPhone: string } | { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, gender?: GenderEnum | null, birthdate?: any | null, mobilePhone?: string | null, deletedAt?: any | null } }, updates: Array<{ __typename?: 'BookingUpdate', id: string, status?: BookingStatusEnum | null, message?: string | null, occasion?: BookingOccasionEnum | null, startTime?: any | null, participants?: number | null, createdAt: any, author: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, deletedAt?: any | null } } | { __typename?: 'Spot', id: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } }> } };

export type UpdateBookingMutationVariables = Exact<{
  input: UpdateBookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking: { __typename?: 'Booking', id: string, ref: string, startTime: any, status: BookingStatusEnum, participants: number, occasion?: BookingOccasionEnum | null, client: { __typename?: 'BookingClient', id: string, firstname: string, lastname?: string | null, email?: string | null, clientPhone: string } | { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string, gender?: GenderEnum | null, birthdate?: any | null, mobilePhone?: string | null, deletedAt?: any | null } } } };

export type ListEventCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListEventCategoriesQuery = { __typename?: 'Query', eventCategories: Array<{ __typename?: 'EventCategory', id: string, name: string }> };

export type MyEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEventsQuery = { __typename?: 'Query', myEvents: Array<{ __typename?: 'Event', id: string, ref: string, title: string, description?: string | null, from: any, to?: any | null, status: EventStatusEnum, deletedAt?: any | null, publishedAt?: any | null, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, likers: { __typename?: 'Likers', eventId: string, count: number, accounts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer' } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support' }> }, category?: { __typename?: 'EventCategory', id: string, name: string } | null }> };

export type GetEventToEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEventToEditQuery = { __typename?: 'Query', event: { __typename?: 'Event', id: string, ref: string, title: string, description?: string | null, from: any, to?: any | null, status: EventStatusEnum, isPrivate: boolean, deletedAt?: any | null, publishedAt?: any | null, creator: { __typename?: 'Consumer', id: string } | { __typename?: 'Maker', id: string } | { __typename?: 'Organizer', id: string } | { __typename?: 'Spot', id: string } | { __typename?: 'Support', id: string }, participants: { __typename?: 'Participants', eventId: string, invited: number, confirmed: number, interested: number, declined: number, canceled: number, removed: number, me?: { __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } } | null, list: Array<{ __typename?: 'Participant', id: string, status?: EventParticipationStatusEnum | null, account: { __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } }> }, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, likers: { __typename?: 'Likers', eventId: string, count: number, accounts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer' } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support' }> }, FAQs: Array<{ __typename?: 'FAQs', id: string, idx: number, question: string, answer: string }>, spot?: { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | null, category?: { __typename?: 'EventCategory', id: string, name: string } | null } };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createEvent: { __typename?: 'Event', id: string, ref: string, title: string, description?: string | null, from: any, to?: any | null, status: EventStatusEnum, deletedAt?: any | null, publishedAt?: any | null, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, likers: { __typename?: 'Likers', eventId: string, count: number, accounts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer' } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support' }> }, category?: { __typename?: 'EventCategory', id: string, name: string } | null } };

export type UpdateEventMutationVariables = Exact<{
  input: UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'Event', id: string, ref: string, title: string, description?: string | null, from: any, to?: any | null, status: EventStatusEnum, deletedAt?: any | null, publishedAt?: any | null, covers: Array<{ __typename: 'EventImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, likers: { __typename?: 'Likers', eventId: string, count: number, accounts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer' } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename: 'AccountImage', id: string, idx: number, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support' }> }, category?: { __typename?: 'EventCategory', id: string, name: string } | null } };

export type UpdateEventStatusMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: EventStatusEnum;
}>;


export type UpdateEventStatusMutation = { __typename?: 'Mutation', updateEventStatus: { __typename?: 'Event', id: string, ref: string, status: EventStatusEnum } };

export type RegisterSpotMutationVariables = Exact<{
  input: RegisterSpotInput;
}>;


export type RegisterSpotMutation = { __typename?: 'Mutation', registerSpot: { __typename: 'Consumer' } | { __typename: 'Maker' } | { __typename: 'Organizer' } | { __typename: 'Spot', id: string, name: string, slug: string } | { __typename: 'Support' } };

export type OpenTicketAuthMutationVariables = Exact<{
  input: OpenAuthTicketInput;
}>;


export type OpenTicketAuthMutation = { __typename?: 'Mutation', openTicketAuth: { __typename?: 'SupportTicket', id: string, topic: SupportTicketTopicEnum, status: SupportTicketStatusEnum, createdAt: any } };

export type SearchSuggestLocationQueryVariables = Exact<{
  search: SearchSuggest;
}>;


export type SearchSuggestLocationQuery = { __typename?: 'Query', searchSuggestLocation: Array<{ __typename?: 'SuggestLocation', city: string, county: string, postalCode: string }> };

export type SearchSpotsQueryVariables = Exact<{
  filters: SearchSpotFiltersInput;
  pagination: SearchPagination;
}>;


export type SearchSpotsQuery = { __typename?: 'Query', searchSpots: { __typename?: 'SearchSpotsResults', total: number, spots: Array<{ __typename?: 'Spot', id: string, name: string, slug: string, description?: string | null, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, configuration: { __typename?: 'SpotConfiguration', primaryType?: SpotTypeEnum | null, secondaryType?: SpotTypeEnum | null, tertiaryType?: SpotTypeEnum | null, pricing?: SpotPricingEnum | null, defaultImage?: string | null }, atmosphere: { __typename?: 'SpotAtmosphere', calm?: boolean | null, lively?: boolean | null, dancing?: boolean | null }, type: { __typename?: 'SpotType', amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, concertHall?: boolean | null, casino?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null }, address?: { __typename?: 'Address', id: string, label: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null, opening: Array<{ __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null }>, closing: Array<{ __typename?: 'SpotSchedulesClosing', id: string, reason?: string | null, description: string, from: any, to?: any | null }> }> } };

export type SearchEventsQueryVariables = Exact<{
  filters: SearchEventFiltersInput;
  pagination: SearchPagination;
}>;


export type SearchEventsQuery = { __typename?: 'Query', searchEvents: { __typename?: 'SearchEventsResults', total: number, events: Array<{ __typename?: 'Event', id: string, title: string, thumb?: string | null, flyer?: string | null, from: any, to?: any | null, category?: { __typename?: 'EventCategory', id: string, name: string } | null, covers: Array<{ __typename?: 'EventImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, address?: { __typename?: 'Address', id: string, label: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null, spot?: { __typename?: 'Spot', id: string, name: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, address?: { __typename?: 'Address', id: string, label: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null } | null }> } };

export type SearchMembersQueryVariables = Exact<{
  filters: SearchMembersFilters;
  pagination: SearchPagination;
}>;


export type SearchMembersQuery = { __typename?: 'Query', searchMembers: { __typename?: 'SearchAccountsResults', total: number, accounts: Array<{ __typename?: 'Consumer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Maker', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Organizer', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Spot', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename?: 'Support', id: string, name: string, slug: string, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }> } };

export type ListHomeSpotsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListHomeSpotsQuery = { __typename?: 'Query', homeSpots: Array<{ __typename?: 'HomeSpots', id: string, title: string, spots: Array<{ __typename?: 'Spot', id: string, name: string, slug: string, description?: string | null, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null, covers: Array<{ __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any }>, configuration: { __typename?: 'SpotConfiguration', id: string, primaryType?: SpotTypeEnum | null, secondaryType?: SpotTypeEnum | null, tertiaryType?: SpotTypeEnum | null, pricing?: SpotPricingEnum | null, defaultImage?: string | null }, atmosphere: { __typename?: 'SpotAtmosphere', id: string, calm?: boolean | null, lively?: boolean | null, dancing?: boolean | null }, type: { __typename?: 'SpotType', id: string, amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, concertHall?: boolean | null, casino?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null }, address?: { __typename?: 'Address', id: string, label: string, city: string, latitude: number, longitude: number, placeId?: string | null } | null, opening: Array<{ __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null }>, closing: Array<{ __typename?: 'SpotSchedulesClosing', id: string, reason?: string | null, description: string, from: any, to?: any | null }> }> }> };

export type SupdateSpotAtmosphereMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotAtmosphereInput;
}>;


export type SupdateSpotAtmosphereMutation = { __typename?: 'Mutation', supdateSpotAtmosphere: { __typename?: 'SpotAtmosphere', id: string, calm?: boolean | null, lively?: boolean | null, dancing?: boolean | null, updatedAt?: any | null } };

export type SupdateSpotBringableMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotBringableInput;
}>;


export type SupdateSpotBringableMutation = { __typename?: 'Mutation', supdateSpotBringable: { __typename?: 'SpotBringable', id: string, dogs?: boolean | null, food?: boolean | null, drinks?: boolean | null, birthdayCake?: boolean | null, updatedAt?: any | null } };

export type SupdateSpotPricingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  pricing: SpotPricingEnum;
}>;


export type SupdateSpotPricingMutation = { __typename?: 'Mutation', supdateSpotPricing: { __typename?: 'SpotConfiguration', id: string, pricing?: SpotPricingEnum | null } };

export type SupdateSpotCapacityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
}>;


export type SupdateSpotCapacityMutation = { __typename?: 'Mutation', supdateSpotCapacity: { __typename?: 'SpotConfiguration', id: string, capacity?: number | null } };

export type SupdateSpotCloseSpacesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
}>;


export type SupdateSpotCloseSpacesMutation = { __typename?: 'Mutation', supdateSpotCloseSpaces: { __typename?: 'SpotConfiguration', id: string, closeSpaces?: number | null } };

export type SupdateSpotEquipmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotEquipmentInput;
}>;


export type SupdateSpotEquipmentMutation = { __typename?: 'Mutation', supdateSpotEquipment: { __typename?: 'SpotEquipment', id: string, amphitheater?: boolean | null, auditorium?: boolean | null, sono?: boolean | null, wifi?: boolean | null, stage?: boolean | null, video?: boolean | null, locker?: boolean | null, terrace?: boolean | null, toilets?: boolean | null, prmAccess?: boolean | null, dancefloor?: boolean | null, microphone?: boolean | null, prmToilets?: boolean | null, smokingRoom?: boolean | null, parking?: boolean | null, changingTable?: boolean | null, updatedAt?: any | null } };

export type SupdateSpotPaymentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotPaymentInput;
}>;


export type SupdateSpotPaymentMutation = { __typename?: 'Mutation', supdateSpotPayment: { __typename?: 'SpotPayment', id: string, amex?: boolean | null, cash?: boolean | null, checks?: boolean | null, blueCard?: boolean | null, mealTickets?: boolean | null, updatedAt?: any | null } };

export type SupdateSpotScheduleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotScheduleInput;
}>;


export type SupdateSpotScheduleMutation = { __typename?: 'Mutation', supdateSpotSchedule: { __typename?: 'SpotSchedulesOpening', id: string, dayOfWeek: number, openTime?: string | null, closingTime?: string | null, breakIn?: string | null, breakOut?: string | null, updatedAt?: any | null } };

export type SupdateSpotServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotServiceInput;
}>;


export type SupdateSpotServiceMutation = { __typename?: 'Mutation', supdateSpotService: { __typename?: 'SpotService', id: string, dj?: boolean | null, karaoke?: boolean | null, ownMusic?: boolean | null, liveMusic?: boolean | null, entertainmentShow?: boolean | null, takeout?: boolean | null, updatedAt?: any | null } };

export type SupdateSpotSuitableMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotSuitableInput;
}>;


export type SupdateSpotSuitableMutation = { __typename?: 'Mutation', supdateSpotSuitable: { __typename?: 'SpotSuitable', id: string, bachelor?: boolean | null, birthday?: boolean | null, farewell?: boolean | null, teamMeal?: boolean | null, wedding?: boolean | null, afterwork?: boolean | null, exposition?: boolean | null, cocktailPro?: boolean | null, fashionShow?: boolean | null, businessMeal?: boolean | null, companyEvent?: boolean | null, friendsDrink?: boolean | null, studentParty?: boolean | null, productLaunch?: boolean | null, kids?: boolean | null, watchSport?: boolean | null, telework?: boolean | null, veggie?: boolean | null, vegan?: boolean | null, updatedAt?: any | null } };

export type SupdateSpotTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotTypeInput;
}>;


export type SupdateSpotTypeMutation = { __typename?: 'Mutation', supdateSpotType: { __typename?: 'SpotType', id: string, amusementPark?: boolean | null, aquarium?: boolean | null, artGallery?: boolean | null, bar?: boolean | null, cafe?: boolean | null, campground?: boolean | null, concertHall?: boolean | null, casino?: boolean | null, departmentStore?: boolean | null, nightClub?: boolean | null, park?: boolean | null, restaurant?: boolean | null, sportClub?: boolean | null, stadium?: boolean | null, updatedAt?: any | null } };

export type SupdateSpotTypesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotTypesInput;
}>;


export type SupdateSpotTypesMutation = { __typename?: 'Mutation', supdateSpotTypes: { __typename?: 'SpotConfiguration', id: string, primaryType?: SpotTypeEnum | null, secondaryType?: SpotTypeEnum | null, tertiaryType?: SpotTypeEnum | null, updatedAt?: any | null } };

export type SupdateSpotHighlightMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateSpotHighlightInput;
}>;


export type SupdateSpotHighlightMutation = { __typename?: 'Mutation', supdateSpotHighlight: { __typename?: 'SpotHighlight', id: string, mountainView?: boolean | null, oceanView?: boolean | null, rooftop?: boolean | null, seaView?: boolean | null, sunset?: boolean | null, sunrise?: boolean | null, updatedAt?: any | null } };

export type SearchAccountsQueryVariables = Exact<{
  filters: SearchAccountsFilters;
  pagination: SearchPagination;
}>;


export type SearchAccountsQuery = { __typename?: 'Query', searchAccounts: { __typename?: 'SearchAccountsResults', total: number, accounts: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, isPrivate: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename: 'Maker', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename: 'Spot', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null } | { __typename: 'Support', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null }> } };

export type GetAccountQueryVariables = Exact<{
  input: AccountInput;
}>;


export type GetAccountQuery = { __typename?: 'Query', account: { __typename: 'Consumer', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, isPrivate: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string } } | { __typename: 'Maker', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string } } | { __typename: 'Organizer', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string } } | { __typename: 'Spot', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string } } | { __typename: 'Support', id: string, name: string, slug: string, isActive: boolean, isVerified: boolean, deletedAt?: any | null, avatar?: { __typename?: 'AccountImage', id: string, url: string } | null, user: { __typename?: 'User', id: string, firstname: string, lastname: string } } };

export type RemoveImageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RemoveImageInput;
}>;


export type RemoveImageMutation = { __typename?: 'Mutation', removeImage: boolean };

export type SupdateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
}>;


export type SupdateAccountMutation = { __typename?: 'Mutation', supdateAccount: { __typename: 'Consumer', id: string, name: string, description?: string | null, slug: string, updatedAt?: any | null } | { __typename: 'Maker', id: string, name: string, description?: string | null, slug: string, updatedAt?: any | null } | { __typename: 'Organizer', id: string, name: string, description?: string | null, slug: string, updatedAt?: any | null } | { __typename: 'Spot', id: string, name: string, description?: string | null, slug: string, updatedAt?: any | null } | { __typename: 'Support' } };

export type SupdateAccountStatusesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AccountStatusesInput;
}>;


export type SupdateAccountStatusesMutation = { __typename?: 'Mutation', supdateAccountStatuses: { __typename: 'Consumer', id: string, isActive: boolean, isVerified: boolean, isPrivate: boolean, updatedAt?: any | null } | { __typename: 'Maker', id: string, isActive: boolean, isVerified: boolean, updatedAt?: any | null } | { __typename: 'Organizer' } | { __typename: 'Spot', id: string, isActive: boolean, isVerified: boolean, updatedAt?: any | null } | { __typename: 'Support' } };

export type GetAccountCountsQueryVariables = Exact<{
  dateRange?: InputMaybe<DateRangeInput>;
}>;


export type GetAccountCountsQuery = { __typename?: 'Query', accountCounts: { __typename?: 'SupportAccountCounts', current: { __typename?: 'AccountCounts', spot: number, consumer: number, artist: number }, previous?: { __typename?: 'AccountCounts', spot: number, consumer: number, artist: number } | null } };

export type ListUsersQueryVariables = Exact<{
  filters: ListUserFilters;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers: Array<{ __typename?: 'User', id: string, firstname: string, lastname: string, gender?: GenderEnum | null, birthdate?: any | null, email: string, phone?: string | null, mobilePhone?: string | null, isActive?: boolean | null, isVerified?: boolean | null, deletedAt?: any | null, createdAt?: any | null, updatedAt?: any | null }> };

export type ListSupportTicketTopicsQueryVariables = Exact<{
  locale?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListSupportTicketTopicsQuery = { __typename?: 'Query', listSupportTicketTopics: Array<{ __typename?: 'SupportTicketTopic', id: string, topic: SupportTicketTopicEnum, code: string, label: string }> };

export type ListAccountsQueryVariables = Exact<{
  filters: ListAccountFilters;
}>;


export type ListAccountsQuery = { __typename?: 'Query', listAccounts: Array<{ __typename: 'Consumer', id: string, name: string, slug: string, phone?: string | null, description?: string | null, isActive: boolean, isVerified: boolean, createdAt: any, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Maker', id: string, name: string, slug: string, phone?: string | null, description?: string | null, isActive: boolean, isVerified: boolean, createdAt: any, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Organizer', id: string, name: string, slug: string, phone?: string | null, description?: string | null, isActive: boolean, isVerified: boolean, createdAt: any, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Spot', id: string, name: string, slug: string, phone?: string | null, description?: string | null, isActive: boolean, isVerified: boolean, createdAt: any, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null } | { __typename: 'Support', id: string, name: string, slug: string, phone?: string | null, description?: string | null, isActive: boolean, isVerified: boolean, createdAt: any, avatar?: { __typename?: 'AccountImage', id: string, url: string, fileId: string, fileName: string, size: number, mimeType: string, createdAt: any } | null }> };

export const BookingFragmentDoc = gql`
    fragment Booking on Booking {
  id
  origin
  status
  occasion
  startTime
  participants
  createdAt
}
    `;
export const BookingUpdateFragmentDoc = gql`
    fragment BookingUpdate on BookingUpdate {
  id
  status
  message
  occasion
  startTime
  participants
  createdAt
  booking {
    id
    origin
    status
    occasion
    startTime
    participants
    createdAt
  }
}
    `;
export const NotificationFieldsFragmentDoc = gql`
    fragment NotificationFields on Notification {
  id
  entityId
  title
  subtitle
  type
  action
  count
  link
  source {
    id
    name
    slug
    avatar {
      id
      url
    }
  }
  createdAt
}
    `;
export const AccountImageFragmentFragmentDoc = gql`
    fragment AccountImageFragment on AccountImage {
  __typename
  id
  idx
  url
  fileId
  fileName
  size
  mimeType
  createdAt
}
    `;
export const GuestFragmentFragmentDoc = gql`
    fragment GuestFragment on Maker {
  __typename
  id
  name
  avatar {
    ...AccountImageFragment
  }
  covers {
    ...AccountImageFragment
  }
}
    ${AccountImageFragmentFragmentDoc}`;
export const ConversationMemberFieldsFragmentDoc = gql`
    fragment ConversationMemberFields on Account {
  __typename
  ... on Spot {
    id
    name
    slug
    avatar {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
  }
  ... on Consumer {
    id
    name
    slug
    avatar {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
  }
  ... on Maker {
    id
    name
    slug
    avatar {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
  }
}
    `;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  id
  city
  label
  latitude
  longitude
  placeId
}
    `;
export const EventImageFragmentFragmentDoc = gql`
    fragment EventImageFragment on EventImage {
  __typename
  id
  idx
  url
  fileId
  fileName
  size
  mimeType
  createdAt
}
    `;
export const EventFragmentFragmentDoc = gql`
    fragment EventFragment on Event {
  id
  title
  description
  thumb
  flyer
  status
  covers {
    ...EventImageFragment
  }
  isPrivate
  from
  to
}
    ${EventImageFragmentFragmentDoc}`;
export const CategoryFragmentFragmentDoc = gql`
    fragment CategoryFragment on EventCategory {
  id
  name
  description
}
    `;
export const SignupDocument = gql`
    mutation Signup($input: SignupInput!) {
  signup(input: $input)
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const SignupSsoDocument = gql`
    mutation SignupSSO($input: SignupSSOInput!) {
  signupSSO(input: $input) {
    id
    firstname
    lastname
    birthdate
    gender
  }
}
    `;
export type SignupSsoMutationFn = Apollo.MutationFunction<SignupSsoMutation, SignupSsoMutationVariables>;

/**
 * __useSignupSsoMutation__
 *
 * To run a mutation, you first call `useSignupSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupSsoMutation, { data, loading, error }] = useSignupSsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupSsoMutation(baseOptions?: Apollo.MutationHookOptions<SignupSsoMutation, SignupSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupSsoMutation, SignupSsoMutationVariables>(SignupSsoDocument, options);
      }
export type SignupSsoMutationHookResult = ReturnType<typeof useSignupSsoMutation>;
export type SignupSsoMutationResult = Apollo.MutationResult<SignupSsoMutation>;
export type SignupSsoMutationOptions = Apollo.BaseMutationOptions<SignupSsoMutation, SignupSsoMutationVariables>;
export const SearchAddressesDocument = gql`
    query SearchAddresses($search: String!) {
  searchAddresses(search: $search) {
    label
    postalCode
    city
  }
}
    `;

/**
 * __useSearchAddressesQuery__
 *
 * To run a query within a React component, call `useSearchAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAddressesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchAddressesQuery(baseOptions: Apollo.QueryHookOptions<SearchAddressesQuery, SearchAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAddressesQuery, SearchAddressesQueryVariables>(SearchAddressesDocument, options);
      }
export function useSearchAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAddressesQuery, SearchAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAddressesQuery, SearchAddressesQueryVariables>(SearchAddressesDocument, options);
        }
export type SearchAddressesQueryHookResult = ReturnType<typeof useSearchAddressesQuery>;
export type SearchAddressesLazyQueryHookResult = ReturnType<typeof useSearchAddressesLazyQuery>;
export type SearchAddressesQueryResult = Apollo.QueryResult<SearchAddressesQuery, SearchAddressesQueryVariables>;
export const GetSpotBySiretDocument = gql`
    query getSpotBySiret($siret: String!) {
  getSpotBySiret(siret: $siret) {
    isExists
    isConflict
    isRegistered
    name
    address
  }
}
    `;

/**
 * __useGetSpotBySiretQuery__
 *
 * To run a query within a React component, call `useGetSpotBySiretQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotBySiretQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotBySiretQuery({
 *   variables: {
 *      siret: // value for 'siret'
 *   },
 * });
 */
export function useGetSpotBySiretQuery(baseOptions: Apollo.QueryHookOptions<GetSpotBySiretQuery, GetSpotBySiretQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotBySiretQuery, GetSpotBySiretQueryVariables>(GetSpotBySiretDocument, options);
      }
export function useGetSpotBySiretLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotBySiretQuery, GetSpotBySiretQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotBySiretQuery, GetSpotBySiretQueryVariables>(GetSpotBySiretDocument, options);
        }
export type GetSpotBySiretQueryHookResult = ReturnType<typeof useGetSpotBySiretQuery>;
export type GetSpotBySiretLazyQueryHookResult = ReturnType<typeof useGetSpotBySiretLazyQuery>;
export type GetSpotBySiretQueryResult = Apollo.QueryResult<GetSpotBySiretQuery, GetSpotBySiretQueryVariables>;
export const ListMyBookingsDocument = gql`
    query ListMyBookings($dateRange: DateRangeInput) {
  myBookings(dateRange: $dateRange) {
    id
    ref
    startTime
    status
    participants
    occasion
    origin
    spot {
      id
      name
      slug
      avatar {
        id
        url
      }
    }
    client {
      ... on BookingClient {
        id
        firstname
        lastname
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        user {
          id
          firstname
          lastname
          deletedAt
        }
      }
    }
  }
}
    `;

/**
 * __useListMyBookingsQuery__
 *
 * To run a query within a React component, call `useListMyBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyBookingsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useListMyBookingsQuery(baseOptions?: Apollo.QueryHookOptions<ListMyBookingsQuery, ListMyBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMyBookingsQuery, ListMyBookingsQueryVariables>(ListMyBookingsDocument, options);
      }
export function useListMyBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMyBookingsQuery, ListMyBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMyBookingsQuery, ListMyBookingsQueryVariables>(ListMyBookingsDocument, options);
        }
export type ListMyBookingsQueryHookResult = ReturnType<typeof useListMyBookingsQuery>;
export type ListMyBookingsLazyQueryHookResult = ReturnType<typeof useListMyBookingsLazyQuery>;
export type ListMyBookingsQueryResult = Apollo.QueryResult<ListMyBookingsQuery, ListMyBookingsQueryVariables>;
export const ListMyEventsDocument = gql`
    query ListMyEvents($dateRange: DateRangeInput) {
  myEvents(dateRange: $dateRange) {
    id
    ref
    title
    description
    from
    to
    status
    covers {
      id
      url
    }
    isPrivate
    creator {
      id
    }
    participants {
      eventId
      invited
      confirmed
      interested
      declined
      canceled
      removed
      me {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
      list {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
    likers {
      count
    }
    category {
      id
      name
    }
    tags {
      id
      label
    }
    spot {
      id
      name
      slug
      avatar {
        id
        url
      }
    }
    createdAt
    publishedAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useListMyEventsQuery__
 *
 * To run a query within a React component, call `useListMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMyEventsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useListMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<ListMyEventsQuery, ListMyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMyEventsQuery, ListMyEventsQueryVariables>(ListMyEventsDocument, options);
      }
export function useListMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMyEventsQuery, ListMyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMyEventsQuery, ListMyEventsQueryVariables>(ListMyEventsDocument, options);
        }
export type ListMyEventsQueryHookResult = ReturnType<typeof useListMyEventsQuery>;
export type ListMyEventsLazyQueryHookResult = ReturnType<typeof useListMyEventsLazyQuery>;
export type ListMyEventsQueryResult = Apollo.QueryResult<ListMyEventsQuery, ListMyEventsQueryVariables>;
export const BookBySpotDocument = gql`
    mutation BookBySpot($input: BookBySpotInput!) {
  bookBySpot(input: $input) {
    id
    startTime
    status
    participants
    occasion
    origin
    client {
      ... on BookingClient {
        id
        firstname
        lastname
        clientPhone: phone
        email
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        user {
          id
          firstname
          lastname
          gender
          birthdate
          mobilePhone
        }
      }
    }
  }
}
    `;
export type BookBySpotMutationFn = Apollo.MutationFunction<BookBySpotMutation, BookBySpotMutationVariables>;

/**
 * __useBookBySpotMutation__
 *
 * To run a mutation, you first call `useBookBySpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookBySpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookBySpotMutation, { data, loading, error }] = useBookBySpotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookBySpotMutation(baseOptions?: Apollo.MutationHookOptions<BookBySpotMutation, BookBySpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookBySpotMutation, BookBySpotMutationVariables>(BookBySpotDocument, options);
      }
export type BookBySpotMutationHookResult = ReturnType<typeof useBookBySpotMutation>;
export type BookBySpotMutationResult = Apollo.MutationResult<BookBySpotMutation>;
export type BookBySpotMutationOptions = Apollo.BaseMutationOptions<BookBySpotMutation, BookBySpotMutationVariables>;
export const OnBookingCreateDocument = gql`
    subscription OnBookingCreate {
  bookingCreate {
    id
    author {
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        user {
          id
          firstname
          lastname
          deletedAt
        }
      }
      ... on Spot {
        id
        name
        avatar {
          id
          url
        }
      }
    }
    origin
    status
    occasion
    date
    time
    startTime
    endTime
    participants
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useOnBookingCreateSubscription__
 *
 * To run a query within a React component, call `useOnBookingCreateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnBookingCreateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnBookingCreateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnBookingCreateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnBookingCreateSubscription, OnBookingCreateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnBookingCreateSubscription, OnBookingCreateSubscriptionVariables>(OnBookingCreateDocument, options);
      }
export type OnBookingCreateSubscriptionHookResult = ReturnType<typeof useOnBookingCreateSubscription>;
export type OnBookingCreateSubscriptionResult = Apollo.SubscriptionResult<OnBookingCreateSubscription>;
export const OnBookingUpdateDocument = gql`
    subscription OnBookingUpdate {
  bookingUpdate {
    id
    status
    message
    occasion
    startTime
    participants
    booking {
      id
      origin
      status
      occasion
      startTime
      participants
      createdAt
    }
    author {
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        user {
          id
          firstname
          lastname
          deletedAt
        }
      }
      ... on Spot {
        id
        name
        avatar {
          id
          url
        }
      }
    }
    createdAt
  }
}
    `;

/**
 * __useOnBookingUpdateSubscription__
 *
 * To run a query within a React component, call `useOnBookingUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnBookingUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnBookingUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnBookingUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnBookingUpdateSubscription, OnBookingUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnBookingUpdateSubscription, OnBookingUpdateSubscriptionVariables>(OnBookingUpdateDocument, options);
      }
export type OnBookingUpdateSubscriptionHookResult = ReturnType<typeof useOnBookingUpdateSubscription>;
export type OnBookingUpdateSubscriptionResult = Apollo.SubscriptionResult<OnBookingUpdateSubscription>;
export const GetAccountConversationDocument = gql`
    query GetAccountConversation($accountId: ID!) {
  accountConversation(accountId: $accountId) {
    id
    name
    members {
      ...ConversationMemberFields
    }
  }
}
    ${ConversationMemberFieldsFragmentDoc}`;

/**
 * __useGetAccountConversationQuery__
 *
 * To run a query within a React component, call `useGetAccountConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountConversationQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountConversationQuery(baseOptions: Apollo.QueryHookOptions<GetAccountConversationQuery, GetAccountConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountConversationQuery, GetAccountConversationQueryVariables>(GetAccountConversationDocument, options);
      }
export function useGetAccountConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountConversationQuery, GetAccountConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountConversationQuery, GetAccountConversationQueryVariables>(GetAccountConversationDocument, options);
        }
export type GetAccountConversationQueryHookResult = ReturnType<typeof useGetAccountConversationQuery>;
export type GetAccountConversationLazyQueryHookResult = ReturnType<typeof useGetAccountConversationLazyQuery>;
export type GetAccountConversationQueryResult = Apollo.QueryResult<GetAccountConversationQuery, GetAccountConversationQueryVariables>;
export const CreateConversationDocument = gql`
    mutation CreateConversation($name: String, $participants: [ID!]!) {
  createConversation(name: $name, participants: $participants) {
    id
    name
    members {
      ...ConversationMemberFields
    }
  }
}
    ${ConversationMemberFieldsFragmentDoc}`;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      participants: // value for 'participants'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const HandleFriendDocument = gql`
    mutation handleFriend($accountId: ID!, $action: String!) {
  handleFriend(accountId: $accountId, action: $action) {
    id
    isAccepted
    isPending
    isSent
  }
}
    `;
export type HandleFriendMutationFn = Apollo.MutationFunction<HandleFriendMutation, HandleFriendMutationVariables>;

/**
 * __useHandleFriendMutation__
 *
 * To run a mutation, you first call `useHandleFriendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHandleFriendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [handleFriendMutation, { data, loading, error }] = useHandleFriendMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useHandleFriendMutation(baseOptions?: Apollo.MutationHookOptions<HandleFriendMutation, HandleFriendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HandleFriendMutation, HandleFriendMutationVariables>(HandleFriendDocument, options);
      }
export type HandleFriendMutationHookResult = ReturnType<typeof useHandleFriendMutation>;
export type HandleFriendMutationResult = Apollo.MutationResult<HandleFriendMutation>;
export type HandleFriendMutationOptions = Apollo.BaseMutationOptions<HandleFriendMutation, HandleFriendMutationVariables>;
export const GetFriendshipDocument = gql`
    query GetFriendship($accountId: ID!) {
  getFriendship(accountId: $accountId) {
    id
    isAccepted
    isPending
    isSent
  }
}
    `;

/**
 * __useGetFriendshipQuery__
 *
 * To run a query within a React component, call `useGetFriendshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFriendshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFriendshipQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetFriendshipQuery(baseOptions: Apollo.QueryHookOptions<GetFriendshipQuery, GetFriendshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFriendshipQuery, GetFriendshipQueryVariables>(GetFriendshipDocument, options);
      }
export function useGetFriendshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFriendshipQuery, GetFriendshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFriendshipQuery, GetFriendshipQueryVariables>(GetFriendshipDocument, options);
        }
export type GetFriendshipQueryHookResult = ReturnType<typeof useGetFriendshipQuery>;
export type GetFriendshipLazyQueryHookResult = ReturnType<typeof useGetFriendshipLazyQuery>;
export type GetFriendshipQueryResult = Apollo.QueryResult<GetFriendshipQuery, GetFriendshipQueryVariables>;
export const ListFriendsDocument = gql`
    query ListFriends($accountId: ID!) {
  listFriends(accountId: $accountId) {
    active {
      count
      list {
        id
        isAccepted
        isPending
        isSent
        friend {
          id
          name
          slug
          avatar {
            id
            url
          }
        }
      }
    }
    pending {
      count
      list {
        id
        isAccepted
        isPending
        isSent
        friend {
          id
          name
          slug
          avatar {
            id
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListFriendsQuery__
 *
 * To run a query within a React component, call `useListFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFriendsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useListFriendsQuery(baseOptions: Apollo.QueryHookOptions<ListFriendsQuery, ListFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFriendsQuery, ListFriendsQueryVariables>(ListFriendsDocument, options);
      }
export function useListFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFriendsQuery, ListFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFriendsQuery, ListFriendsQueryVariables>(ListFriendsDocument, options);
        }
export type ListFriendsQueryHookResult = ReturnType<typeof useListFriendsQuery>;
export type ListFriendsLazyQueryHookResult = ReturnType<typeof useListFriendsLazyQuery>;
export type ListFriendsQueryResult = Apollo.QueryResult<ListFriendsQuery, ListFriendsQueryVariables>;
export const SearchFriendsDocument = gql`
    query SearchFriends($text: String!) {
  searchFriends(text: $text) {
    id
    isAccepted
    isPending
    isSent
    friend {
      id
      name
      slug
      avatar {
        id
        url
        type
        fileId
        fileName
        size
        mimeType
      }
    }
  }
}
    `;

/**
 * __useSearchFriendsQuery__
 *
 * To run a query within a React component, call `useSearchFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFriendsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSearchFriendsQuery(baseOptions: Apollo.QueryHookOptions<SearchFriendsQuery, SearchFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFriendsQuery, SearchFriendsQueryVariables>(SearchFriendsDocument, options);
      }
export function useSearchFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFriendsQuery, SearchFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFriendsQuery, SearchFriendsQueryVariables>(SearchFriendsDocument, options);
        }
export type SearchFriendsQueryHookResult = ReturnType<typeof useSearchFriendsQuery>;
export type SearchFriendsLazyQueryHookResult = ReturnType<typeof useSearchFriendsLazyQuery>;
export type SearchFriendsQueryResult = Apollo.QueryResult<SearchFriendsQuery, SearchFriendsQueryVariables>;
export const SearchMyFriendsDocument = gql`
    query SearchMyFriends($text: String!) {
  searchMyFriends(text: $text) {
    id
    name
    slug
    avatar {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
  }
}
    `;

/**
 * __useSearchMyFriendsQuery__
 *
 * To run a query within a React component, call `useSearchMyFriendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMyFriendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMyFriendsQuery({
 *   variables: {
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSearchMyFriendsQuery(baseOptions: Apollo.QueryHookOptions<SearchMyFriendsQuery, SearchMyFriendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMyFriendsQuery, SearchMyFriendsQueryVariables>(SearchMyFriendsDocument, options);
      }
export function useSearchMyFriendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMyFriendsQuery, SearchMyFriendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMyFriendsQuery, SearchMyFriendsQueryVariables>(SearchMyFriendsDocument, options);
        }
export type SearchMyFriendsQueryHookResult = ReturnType<typeof useSearchMyFriendsQuery>;
export type SearchMyFriendsLazyQueryHookResult = ReturnType<typeof useSearchMyFriendsLazyQuery>;
export type SearchMyFriendsQueryResult = Apollo.QueryResult<SearchMyFriendsQuery, SearchMyFriendsQueryVariables>;
export const GetConsumerDetailedDocument = gql`
    query GetConsumerDetailed($slug: ID!) {
  consumer(slug: $slug) {
    id
    name
    slug
    covers {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
    avatar {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
    description
    isFollowing
    following {
      id
      name
      slug
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
    }
    isMyFriend
    friendships {
      active {
        count
      }
      pending {
        count
        list {
          id
          isAccepted
          isPending
          isSent
          friend {
            id
            name
          }
        }
      }
    }
    events {
      id
      title
      description
      status
      from
      to
      thumb
      flyer
      covers {
        id
        idx
        url
        type
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      meta
      settings
      tickets {
        id
        idx
        label
        description
        currency
        price
        quantity
        from
        to
      }
      makers {
        id
        name
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        covers {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        slug
      }
      category {
        id
        name
      }
      tags {
        id
        label
      }
      publishedAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetConsumerDetailedQuery__
 *
 * To run a query within a React component, call `useGetConsumerDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerDetailedQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetConsumerDetailedQuery(baseOptions: Apollo.QueryHookOptions<GetConsumerDetailedQuery, GetConsumerDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsumerDetailedQuery, GetConsumerDetailedQueryVariables>(GetConsumerDetailedDocument, options);
      }
export function useGetConsumerDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsumerDetailedQuery, GetConsumerDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsumerDetailedQuery, GetConsumerDetailedQueryVariables>(GetConsumerDetailedDocument, options);
        }
export type GetConsumerDetailedQueryHookResult = ReturnType<typeof useGetConsumerDetailedQuery>;
export type GetConsumerDetailedLazyQueryHookResult = ReturnType<typeof useGetConsumerDetailedLazyQuery>;
export type GetConsumerDetailedQueryResult = Apollo.QueryResult<GetConsumerDetailedQuery, GetConsumerDetailedQueryVariables>;
export const UpdateEventParticipantsDocument = gql`
    mutation UpdateEventParticipants($eventId: ID!, $participantIds: [ID!]!) {
  updateEventParticipants(eventId: $eventId, participantIds: $participantIds) {
    id
    participants {
      eventId
      invited
      confirmed
      interested
      declined
      canceled
      removed
      me {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
      list {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
  }
}
    `;
export type UpdateEventParticipantsMutationFn = Apollo.MutationFunction<UpdateEventParticipantsMutation, UpdateEventParticipantsMutationVariables>;

/**
 * __useUpdateEventParticipantsMutation__
 *
 * To run a mutation, you first call `useUpdateEventParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventParticipantsMutation, { data, loading, error }] = useUpdateEventParticipantsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      participantIds: // value for 'participantIds'
 *   },
 * });
 */
export function useUpdateEventParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventParticipantsMutation, UpdateEventParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventParticipantsMutation, UpdateEventParticipantsMutationVariables>(UpdateEventParticipantsDocument, options);
      }
export type UpdateEventParticipantsMutationHookResult = ReturnType<typeof useUpdateEventParticipantsMutation>;
export type UpdateEventParticipantsMutationResult = Apollo.MutationResult<UpdateEventParticipantsMutation>;
export type UpdateEventParticipantsMutationOptions = Apollo.BaseMutationOptions<UpdateEventParticipantsMutation, UpdateEventParticipantsMutationVariables>;
export const UpsertEventFaqDocument = gql`
    mutation UpsertEventFAQ($input: UpsertEventFAQInput!) {
  upsertEventFAQ(input: $input) {
    id
    idx
    question
    answer
  }
}
    `;
export type UpsertEventFaqMutationFn = Apollo.MutationFunction<UpsertEventFaqMutation, UpsertEventFaqMutationVariables>;

/**
 * __useUpsertEventFaqMutation__
 *
 * To run a mutation, you first call `useUpsertEventFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEventFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEventFaqMutation, { data, loading, error }] = useUpsertEventFaqMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertEventFaqMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEventFaqMutation, UpsertEventFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEventFaqMutation, UpsertEventFaqMutationVariables>(UpsertEventFaqDocument, options);
      }
export type UpsertEventFaqMutationHookResult = ReturnType<typeof useUpsertEventFaqMutation>;
export type UpsertEventFaqMutationResult = Apollo.MutationResult<UpsertEventFaqMutation>;
export type UpsertEventFaqMutationOptions = Apollo.BaseMutationOptions<UpsertEventFaqMutation, UpsertEventFaqMutationVariables>;
export const RemoveEventFaqDocument = gql`
    mutation RemoveEventFAQ($id: ID!) {
  removeEventFAQ(id: $id)
}
    `;
export type RemoveEventFaqMutationFn = Apollo.MutationFunction<RemoveEventFaqMutation, RemoveEventFaqMutationVariables>;

/**
 * __useRemoveEventFaqMutation__
 *
 * To run a mutation, you first call `useRemoveEventFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventFaqMutation, { data, loading, error }] = useRemoveEventFaqMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventFaqMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventFaqMutation, RemoveEventFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventFaqMutation, RemoveEventFaqMutationVariables>(RemoveEventFaqDocument, options);
      }
export type RemoveEventFaqMutationHookResult = ReturnType<typeof useRemoveEventFaqMutation>;
export type RemoveEventFaqMutationResult = Apollo.MutationResult<RemoveEventFaqMutation>;
export type RemoveEventFaqMutationOptions = Apollo.BaseMutationOptions<RemoveEventFaqMutation, RemoveEventFaqMutationVariables>;
export const SortEventFaqDocument = gql`
    mutation SortEventFAQ($eventId: ID!, $order: [ID!]!) {
  sortEventFAQ(eventId: $eventId, order: $order) {
    id
    idx
  }
}
    `;
export type SortEventFaqMutationFn = Apollo.MutationFunction<SortEventFaqMutation, SortEventFaqMutationVariables>;

/**
 * __useSortEventFaqMutation__
 *
 * To run a mutation, you first call `useSortEventFaqMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSortEventFaqMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sortEventFaqMutation, { data, loading, error }] = useSortEventFaqMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSortEventFaqMutation(baseOptions?: Apollo.MutationHookOptions<SortEventFaqMutation, SortEventFaqMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SortEventFaqMutation, SortEventFaqMutationVariables>(SortEventFaqDocument, options);
      }
export type SortEventFaqMutationHookResult = ReturnType<typeof useSortEventFaqMutation>;
export type SortEventFaqMutationResult = Apollo.MutationResult<SortEventFaqMutation>;
export type SortEventFaqMutationOptions = Apollo.BaseMutationOptions<SortEventFaqMutation, SortEventFaqMutationVariables>;
export const UpsertEventImageDocument = gql`
    mutation UpsertEventImage($eventId: ID!, $type: EventImageTypeEnum!, $image: Upload!) {
  upsertEventImage(eventId: $eventId, type: $type, image: $image) {
    id
    idx
    url
    fileId
    fileName
    size
    mimeType
    createdAt
  }
}
    `;
export type UpsertEventImageMutationFn = Apollo.MutationFunction<UpsertEventImageMutation, UpsertEventImageMutationVariables>;

/**
 * __useUpsertEventImageMutation__
 *
 * To run a mutation, you first call `useUpsertEventImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEventImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEventImageMutation, { data, loading, error }] = useUpsertEventImageMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      type: // value for 'type'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpsertEventImageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEventImageMutation, UpsertEventImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEventImageMutation, UpsertEventImageMutationVariables>(UpsertEventImageDocument, options);
      }
export type UpsertEventImageMutationHookResult = ReturnType<typeof useUpsertEventImageMutation>;
export type UpsertEventImageMutationResult = Apollo.MutationResult<UpsertEventImageMutation>;
export type UpsertEventImageMutationOptions = Apollo.BaseMutationOptions<UpsertEventImageMutation, UpsertEventImageMutationVariables>;
export const RemoveEventImageDocument = gql`
    mutation RemoveEventImage($id: ID!) {
  removeEventImage(id: $id)
}
    `;
export type RemoveEventImageMutationFn = Apollo.MutationFunction<RemoveEventImageMutation, RemoveEventImageMutationVariables>;

/**
 * __useRemoveEventImageMutation__
 *
 * To run a mutation, you first call `useRemoveEventImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEventImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEventImageMutation, { data, loading, error }] = useRemoveEventImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEventImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEventImageMutation, RemoveEventImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEventImageMutation, RemoveEventImageMutationVariables>(RemoveEventImageDocument, options);
      }
export type RemoveEventImageMutationHookResult = ReturnType<typeof useRemoveEventImageMutation>;
export type RemoveEventImageMutationResult = Apollo.MutationResult<RemoveEventImageMutation>;
export type RemoveEventImageMutationOptions = Apollo.BaseMutationOptions<RemoveEventImageMutation, RemoveEventImageMutationVariables>;
export const GetEventDetailedDocument = gql`
    query GetEventDetailed($id: ID!) {
  event(id: $id) {
    id
    ...EventFragment
    category {
      ...CategoryFragment
    }
    address {
      ...AddressFragment
      label
    }
    FAQs {
      id
      idx
      question
      answer
    }
    creator {
      id
      name
      slug
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
    }
    isLiking
    isPrivate
    participants {
      eventId
      invited
      confirmed
      interested
      declined
      canceled
      removed
      me {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
      list {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
    likers {
      eventId
      count
      accounts {
        ... on Consumer {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Spot {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
    tickets {
      id
      idx
      from
      label
      description
      to
      price
      currency
    }
    spot {
      id
      name
      slug
      covers {
        id
        idx
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      avatar {
        id
        idx
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      address {
        ...AddressFragment
      }
      type {
        id
        amusementPark
        aquarium
        artGallery
        bar
        cafe
        campground
        casino
        concertHall
        departmentStore
        nightClub
        park
        restaurant
        sportClub
        stadium
        updatedAt
      }
      configuration {
        id
        defaultImage
        pricing
        primaryType
        secondaryType
        tertiaryType
        closeSpaces
        entryPrice
        capacity
        musicalGenre
        updatedAt
      }
    }
    tags {
      id
      label
    }
    updates {
      id
      from
      to
      status
      title
      description
      message
      createdAt
    }
    makers {
      ...GuestFragment
    }
  }
}
    ${EventFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${GuestFragmentFragmentDoc}`;

/**
 * __useGetEventDetailedQuery__
 *
 * To run a query within a React component, call `useGetEventDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDetailedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventDetailedQuery(baseOptions: Apollo.QueryHookOptions<GetEventDetailedQuery, GetEventDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventDetailedQuery, GetEventDetailedQueryVariables>(GetEventDetailedDocument, options);
      }
export function useGetEventDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventDetailedQuery, GetEventDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventDetailedQuery, GetEventDetailedQueryVariables>(GetEventDetailedDocument, options);
        }
export type GetEventDetailedQueryHookResult = ReturnType<typeof useGetEventDetailedQuery>;
export type GetEventDetailedLazyQueryHookResult = ReturnType<typeof useGetEventDetailedLazyQuery>;
export type GetEventDetailedQueryResult = Apollo.QueryResult<GetEventDetailedQuery, GetEventDetailedQueryVariables>;
export const LikeEventDocument = gql`
    mutation likeEvent($eventId: ID!) {
  likeEvent(eventId: $eventId)
}
    `;
export type LikeEventMutationFn = Apollo.MutationFunction<LikeEventMutation, LikeEventMutationVariables>;

/**
 * __useLikeEventMutation__
 *
 * To run a mutation, you first call `useLikeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeEventMutation, { data, loading, error }] = useLikeEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useLikeEventMutation(baseOptions?: Apollo.MutationHookOptions<LikeEventMutation, LikeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeEventMutation, LikeEventMutationVariables>(LikeEventDocument, options);
      }
export type LikeEventMutationHookResult = ReturnType<typeof useLikeEventMutation>;
export type LikeEventMutationResult = Apollo.MutationResult<LikeEventMutation>;
export type LikeEventMutationOptions = Apollo.BaseMutationOptions<LikeEventMutation, LikeEventMutationVariables>;
export const UnlikeEventDocument = gql`
    mutation unlikeEvent($eventId: ID!) {
  unlikeEvent(eventId: $eventId)
}
    `;
export type UnlikeEventMutationFn = Apollo.MutationFunction<UnlikeEventMutation, UnlikeEventMutationVariables>;

/**
 * __useUnlikeEventMutation__
 *
 * To run a mutation, you first call `useUnlikeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikeEventMutation, { data, loading, error }] = useUnlikeEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUnlikeEventMutation(baseOptions?: Apollo.MutationHookOptions<UnlikeEventMutation, UnlikeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikeEventMutation, UnlikeEventMutationVariables>(UnlikeEventDocument, options);
      }
export type UnlikeEventMutationHookResult = ReturnType<typeof useUnlikeEventMutation>;
export type UnlikeEventMutationResult = Apollo.MutationResult<UnlikeEventMutation>;
export type UnlikeEventMutationOptions = Apollo.BaseMutationOptions<UnlikeEventMutation, UnlikeEventMutationVariables>;
export const UpdateEventParticipationDocument = gql`
    mutation UpdateEventParticipation($eventId: ID!, $status: EventParticipationStatusEnum!) {
  updateEventParticipation(eventId: $eventId, status: $status) {
    id
    status
  }
}
    `;
export type UpdateEventParticipationMutationFn = Apollo.MutationFunction<UpdateEventParticipationMutation, UpdateEventParticipationMutationVariables>;

/**
 * __useUpdateEventParticipationMutation__
 *
 * To run a mutation, you first call `useUpdateEventParticipationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventParticipationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventParticipationMutation, { data, loading, error }] = useUpdateEventParticipationMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateEventParticipationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventParticipationMutation, UpdateEventParticipationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventParticipationMutation, UpdateEventParticipationMutationVariables>(UpdateEventParticipationDocument, options);
      }
export type UpdateEventParticipationMutationHookResult = ReturnType<typeof useUpdateEventParticipationMutation>;
export type UpdateEventParticipationMutationResult = Apollo.MutationResult<UpdateEventParticipationMutation>;
export type UpdateEventParticipationMutationOptions = Apollo.BaseMutationOptions<UpdateEventParticipationMutation, UpdateEventParticipationMutationVariables>;
export const GetSpotDetailedDocument = gql`
    query GetSpotDetailed($slug: ID!, $withDeletedAt: Boolean = false) {
  spot(slug: $slug) {
    id
    name
    slug
    covers {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
    avatar {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
    description
    isFollowing
    isActive
    isVerified
    deletedAt @include(if: $withDeletedAt)
    addicts {
      id
      name
      slug
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
    }
    feedbacks {
      id
      author {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      rate
      text
      createdAt
      updatedAt
    }
    address {
      id
      city
      label
      placeId
      timezone
    }
    FAQs {
      id
      idx
      question
      answer
    }
    opening {
      id
      dayOfWeek
      openTime
      closingTime
      breakIn
      breakOut
    }
    closing {
      id
      reason
      description
      from
      to
    }
    atmosphere {
      id
      calm
      lively
      dancing
      updatedAt
    }
    bringable {
      id
      birthdayCake
      drinks
      food
      dogs
      updatedAt
    }
    configuration {
      id
      defaultImage
      pricing
      primaryType
      secondaryType
      tertiaryType
      closeSpaces
      entryPrice
      capacity
      musicalGenre
      isClaimed
      isEphemeral
      updatedAt
    }
    equipment {
      id
      amphitheater
      auditorium
      changingTable
      dancefloor
      locker
      microphone
      parking
      prmAccess
      prmToilets
      smokingRoom
      sono
      stage
      terrace
      toilets
      updatedAt
      video
      wifi
    }
    highlight {
      id
      mountainView
      oceanView
      rooftop
      seaView
      sunset
      sunrise
    }
    service {
      id
      dj
      entertainmentShow
      karaoke
      liveMusic
      ownMusic
      takeout
      updatedAt
    }
    payment {
      id
      amex
      blueCard
      cash
      checks
      mealTickets
      updatedAt
    }
    suitable {
      id
      afterwork
      bachelor
      birthday
      businessMeal
      cocktailPro
      companyEvent
      exposition
      kids
      farewell
      fashionShow
      friendsDrink
      productLaunch
      studentParty
      teamMeal
      telework
      veggie
      vegan
      watchSport
      wedding
      updatedAt
    }
    type {
      id
      bar
      cafe
      nightClub
      restaurant
      updatedAt
    }
    events {
      id
      title
      description
      from
      to
      thumb
      flyer
      covers {
        id
        idx
        url
        type
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      meta
      settings
      tickets {
        id
        idx
        label
        description
        currency
        price
        quantity
        from
        to
      }
      makers {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        covers {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      category {
        id
        name
      }
      tags {
        id
        label
      }
      publishedAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetSpotDetailedQuery__
 *
 * To run a query within a React component, call `useGetSpotDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotDetailedQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      withDeletedAt: // value for 'withDeletedAt'
 *   },
 * });
 */
export function useGetSpotDetailedQuery(baseOptions: Apollo.QueryHookOptions<GetSpotDetailedQuery, GetSpotDetailedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotDetailedQuery, GetSpotDetailedQueryVariables>(GetSpotDetailedDocument, options);
      }
export function useGetSpotDetailedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotDetailedQuery, GetSpotDetailedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotDetailedQuery, GetSpotDetailedQueryVariables>(GetSpotDetailedDocument, options);
        }
export type GetSpotDetailedQueryHookResult = ReturnType<typeof useGetSpotDetailedQuery>;
export type GetSpotDetailedLazyQueryHookResult = ReturnType<typeof useGetSpotDetailedLazyQuery>;
export type GetSpotDetailedQueryResult = Apollo.QueryResult<GetSpotDetailedQuery, GetSpotDetailedQueryVariables>;
export const GetSpoEventsDocument = gql`
    query GetSpoEvents($slug: ID!, $dateRange: DateRangeInput) {
  spot(slug: $slug, dateRange: $dateRange) {
    id
    events {
      id
      title
      description
      from
      to
      thumb
      flyer
      covers {
        id
        idx
        url
        type
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      meta
      settings
      tickets {
        id
        idx
        label
        description
        currency
        price
        quantity
        from
        to
      }
      makers {
        id
        name
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        covers {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        slug
      }
      category {
        id
        name
      }
      tags {
        id
        label
      }
      publishedAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetSpoEventsQuery__
 *
 * To run a query within a React component, call `useGetSpoEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpoEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpoEventsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetSpoEventsQuery(baseOptions: Apollo.QueryHookOptions<GetSpoEventsQuery, GetSpoEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpoEventsQuery, GetSpoEventsQueryVariables>(GetSpoEventsDocument, options);
      }
export function useGetSpoEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpoEventsQuery, GetSpoEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpoEventsQuery, GetSpoEventsQueryVariables>(GetSpoEventsDocument, options);
        }
export type GetSpoEventsQueryHookResult = ReturnType<typeof useGetSpoEventsQuery>;
export type GetSpoEventsLazyQueryHookResult = ReturnType<typeof useGetSpoEventsLazyQuery>;
export type GetSpoEventsQueryResult = Apollo.QueryResult<GetSpoEventsQuery, GetSpoEventsQueryVariables>;
export const FollowDocument = gql`
    mutation follow($accountId: ID!) {
  follow(accountId: $accountId) {
    ... on Consumer {
      id
    }
    ... on Maker {
      id
    }
    ... on Organizer {
      id
    }
    ... on Spot {
      id
      isFollowing
      addicts {
        id
        avatar {
          id
          url
        }
        name
        slug
      }
    }
  }
}
    `;
export type FollowMutationFn = Apollo.MutationFunction<FollowMutation, FollowMutationVariables>;

/**
 * __useFollowMutation__
 *
 * To run a mutation, you first call `useFollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followMutation, { data, loading, error }] = useFollowMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useFollowMutation(baseOptions?: Apollo.MutationHookOptions<FollowMutation, FollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowMutation, FollowMutationVariables>(FollowDocument, options);
      }
export type FollowMutationHookResult = ReturnType<typeof useFollowMutation>;
export type FollowMutationResult = Apollo.MutationResult<FollowMutation>;
export type FollowMutationOptions = Apollo.BaseMutationOptions<FollowMutation, FollowMutationVariables>;
export const UnfollowDocument = gql`
    mutation unfollow($accountId: ID!) {
  unfollow(accountId: $accountId) {
    ... on Consumer {
      id
    }
    ... on Maker {
      id
    }
    ... on Organizer {
      id
    }
    ... on Spot {
      id
      isFollowing
      addicts {
        id
        name
        slug
      }
    }
  }
}
    `;
export type UnfollowMutationFn = Apollo.MutationFunction<UnfollowMutation, UnfollowMutationVariables>;

/**
 * __useUnfollowMutation__
 *
 * To run a mutation, you first call `useUnfollowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowMutation, { data, loading, error }] = useUnfollowMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useUnfollowMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowMutation, UnfollowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowMutation, UnfollowMutationVariables>(UnfollowDocument, options);
      }
export type UnfollowMutationHookResult = ReturnType<typeof useUnfollowMutation>;
export type UnfollowMutationResult = Apollo.MutationResult<UnfollowMutation>;
export type UnfollowMutationOptions = Apollo.BaseMutationOptions<UnfollowMutation, UnfollowMutationVariables>;
export const BookByConsumerDocument = gql`
    mutation bookByConsumer($input: BookByConsumerInput!) {
  bookByConsumer(input: $input) {
    id
    startTime
    status
    occasion
    participants
    updates {
      message
    }
    spot {
      id
      name
    }
  }
}
    `;
export type BookByConsumerMutationFn = Apollo.MutationFunction<BookByConsumerMutation, BookByConsumerMutationVariables>;

/**
 * __useBookByConsumerMutation__
 *
 * To run a mutation, you first call `useBookByConsumerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookByConsumerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookByConsumerMutation, { data, loading, error }] = useBookByConsumerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookByConsumerMutation(baseOptions?: Apollo.MutationHookOptions<BookByConsumerMutation, BookByConsumerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookByConsumerMutation, BookByConsumerMutationVariables>(BookByConsumerDocument, options);
      }
export type BookByConsumerMutationHookResult = ReturnType<typeof useBookByConsumerMutation>;
export type BookByConsumerMutationResult = Apollo.MutationResult<BookByConsumerMutation>;
export type BookByConsumerMutationOptions = Apollo.BaseMutationOptions<BookByConsumerMutation, BookByConsumerMutationVariables>;
export const RegisterMobilePhoneDocument = gql`
    mutation RegisterMobilePhone($mobilePhone: String!) {
  registerMobilePhone(mobilePhone: $mobilePhone) {
    id
    mobilePhone
  }
}
    `;
export type RegisterMobilePhoneMutationFn = Apollo.MutationFunction<RegisterMobilePhoneMutation, RegisterMobilePhoneMutationVariables>;

/**
 * __useRegisterMobilePhoneMutation__
 *
 * To run a mutation, you first call `useRegisterMobilePhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMobilePhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMobilePhoneMutation, { data, loading, error }] = useRegisterMobilePhoneMutation({
 *   variables: {
 *      mobilePhone: // value for 'mobilePhone'
 *   },
 * });
 */
export function useRegisterMobilePhoneMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMobilePhoneMutation, RegisterMobilePhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMobilePhoneMutation, RegisterMobilePhoneMutationVariables>(RegisterMobilePhoneDocument, options);
      }
export type RegisterMobilePhoneMutationHookResult = ReturnType<typeof useRegisterMobilePhoneMutation>;
export type RegisterMobilePhoneMutationResult = Apollo.MutationResult<RegisterMobilePhoneMutation>;
export type RegisterMobilePhoneMutationOptions = Apollo.BaseMutationOptions<RegisterMobilePhoneMutation, RegisterMobilePhoneMutationVariables>;
export const ClaimSpotDocument = gql`
    mutation ClaimSpot($id: ID!, $input: ClaimInput!) {
  claimSpot(id: $id, input: $input)
}
    `;
export type ClaimSpotMutationFn = Apollo.MutationFunction<ClaimSpotMutation, ClaimSpotMutationVariables>;

/**
 * __useClaimSpotMutation__
 *
 * To run a mutation, you first call `useClaimSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimSpotMutation, { data, loading, error }] = useClaimSpotMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimSpotMutation(baseOptions?: Apollo.MutationHookOptions<ClaimSpotMutation, ClaimSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimSpotMutation, ClaimSpotMutationVariables>(ClaimSpotDocument, options);
      }
export type ClaimSpotMutationHookResult = ReturnType<typeof useClaimSpotMutation>;
export type ClaimSpotMutationResult = Apollo.MutationResult<ClaimSpotMutation>;
export type ClaimSpotMutationOptions = Apollo.BaseMutationOptions<ClaimSpotMutation, ClaimSpotMutationVariables>;
export const UpsertAvatarDocument = gql`
    mutation UpsertAvatar($avatar: Upload!) {
  upsertAvatar(avatar: $avatar) {
    id
    idx
    url
    fileId
    fileName
    size
    mimeType
    createdAt
  }
}
    `;
export type UpsertAvatarMutationFn = Apollo.MutationFunction<UpsertAvatarMutation, UpsertAvatarMutationVariables>;

/**
 * __useUpsertAvatarMutation__
 *
 * To run a mutation, you first call `useUpsertAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAvatarMutation, { data, loading, error }] = useUpsertAvatarMutation({
 *   variables: {
 *      avatar: // value for 'avatar'
 *   },
 * });
 */
export function useUpsertAvatarMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAvatarMutation, UpsertAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAvatarMutation, UpsertAvatarMutationVariables>(UpsertAvatarDocument, options);
      }
export type UpsertAvatarMutationHookResult = ReturnType<typeof useUpsertAvatarMutation>;
export type UpsertAvatarMutationResult = Apollo.MutationResult<UpsertAvatarMutation>;
export type UpsertAvatarMutationOptions = Apollo.BaseMutationOptions<UpsertAvatarMutation, UpsertAvatarMutationVariables>;
export const RemoveAvatarDocument = gql`
    mutation RemoveAvatar {
  removeAvatar
}
    `;
export type RemoveAvatarMutationFn = Apollo.MutationFunction<RemoveAvatarMutation, RemoveAvatarMutationVariables>;

/**
 * __useRemoveAvatarMutation__
 *
 * To run a mutation, you first call `useRemoveAvatarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAvatarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAvatarMutation, { data, loading, error }] = useRemoveAvatarMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveAvatarMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAvatarMutation, RemoveAvatarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAvatarMutation, RemoveAvatarMutationVariables>(RemoveAvatarDocument, options);
      }
export type RemoveAvatarMutationHookResult = ReturnType<typeof useRemoveAvatarMutation>;
export type RemoveAvatarMutationResult = Apollo.MutationResult<RemoveAvatarMutation>;
export type RemoveAvatarMutationOptions = Apollo.BaseMutationOptions<RemoveAvatarMutation, RemoveAvatarMutationVariables>;
export const UpdateSpotAtmosphereDocument = gql`
    mutation UpdateSpotAtmosphere($input: UpdateSpotAtmosphereInput!) {
  updateSpotAtmosphere(input: $input) {
    id
    calm
    lively
    dancing
    updatedAt
  }
}
    `;
export type UpdateSpotAtmosphereMutationFn = Apollo.MutationFunction<UpdateSpotAtmosphereMutation, UpdateSpotAtmosphereMutationVariables>;

/**
 * __useUpdateSpotAtmosphereMutation__
 *
 * To run a mutation, you first call `useUpdateSpotAtmosphereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotAtmosphereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotAtmosphereMutation, { data, loading, error }] = useUpdateSpotAtmosphereMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotAtmosphereMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotAtmosphereMutation, UpdateSpotAtmosphereMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotAtmosphereMutation, UpdateSpotAtmosphereMutationVariables>(UpdateSpotAtmosphereDocument, options);
      }
export type UpdateSpotAtmosphereMutationHookResult = ReturnType<typeof useUpdateSpotAtmosphereMutation>;
export type UpdateSpotAtmosphereMutationResult = Apollo.MutationResult<UpdateSpotAtmosphereMutation>;
export type UpdateSpotAtmosphereMutationOptions = Apollo.BaseMutationOptions<UpdateSpotAtmosphereMutation, UpdateSpotAtmosphereMutationVariables>;
export const UpdateSpotBringableDocument = gql`
    mutation UpdateSpotBringable($input: UpdateSpotBringableInput!) {
  updateSpotBringable(input: $input) {
    id
    dogs
    food
    drinks
    birthdayCake
    updatedAt
  }
}
    `;
export type UpdateSpotBringableMutationFn = Apollo.MutationFunction<UpdateSpotBringableMutation, UpdateSpotBringableMutationVariables>;

/**
 * __useUpdateSpotBringableMutation__
 *
 * To run a mutation, you first call `useUpdateSpotBringableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotBringableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotBringableMutation, { data, loading, error }] = useUpdateSpotBringableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotBringableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotBringableMutation, UpdateSpotBringableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotBringableMutation, UpdateSpotBringableMutationVariables>(UpdateSpotBringableDocument, options);
      }
export type UpdateSpotBringableMutationHookResult = ReturnType<typeof useUpdateSpotBringableMutation>;
export type UpdateSpotBringableMutationResult = Apollo.MutationResult<UpdateSpotBringableMutation>;
export type UpdateSpotBringableMutationOptions = Apollo.BaseMutationOptions<UpdateSpotBringableMutation, UpdateSpotBringableMutationVariables>;
export const UpdateSpotPricingDocument = gql`
    mutation UpdateSpotPricing($pricing: SpotPricingEnum!) {
  updateSpotPricing(pricing: $pricing) {
    id
    pricing
  }
}
    `;
export type UpdateSpotPricingMutationFn = Apollo.MutationFunction<UpdateSpotPricingMutation, UpdateSpotPricingMutationVariables>;

/**
 * __useUpdateSpotPricingMutation__
 *
 * To run a mutation, you first call `useUpdateSpotPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotPricingMutation, { data, loading, error }] = useUpdateSpotPricingMutation({
 *   variables: {
 *      pricing: // value for 'pricing'
 *   },
 * });
 */
export function useUpdateSpotPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotPricingMutation, UpdateSpotPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotPricingMutation, UpdateSpotPricingMutationVariables>(UpdateSpotPricingDocument, options);
      }
export type UpdateSpotPricingMutationHookResult = ReturnType<typeof useUpdateSpotPricingMutation>;
export type UpdateSpotPricingMutationResult = Apollo.MutationResult<UpdateSpotPricingMutation>;
export type UpdateSpotPricingMutationOptions = Apollo.BaseMutationOptions<UpdateSpotPricingMutation, UpdateSpotPricingMutationVariables>;
export const UpdateSpotCapacityDocument = gql`
    mutation UpdateSpotCapacity($value: Int!) {
  updateSpotCapacity(value: $value) {
    id
    capacity
  }
}
    `;
export type UpdateSpotCapacityMutationFn = Apollo.MutationFunction<UpdateSpotCapacityMutation, UpdateSpotCapacityMutationVariables>;

/**
 * __useUpdateSpotCapacityMutation__
 *
 * To run a mutation, you first call `useUpdateSpotCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotCapacityMutation, { data, loading, error }] = useUpdateSpotCapacityMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateSpotCapacityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotCapacityMutation, UpdateSpotCapacityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotCapacityMutation, UpdateSpotCapacityMutationVariables>(UpdateSpotCapacityDocument, options);
      }
export type UpdateSpotCapacityMutationHookResult = ReturnType<typeof useUpdateSpotCapacityMutation>;
export type UpdateSpotCapacityMutationResult = Apollo.MutationResult<UpdateSpotCapacityMutation>;
export type UpdateSpotCapacityMutationOptions = Apollo.BaseMutationOptions<UpdateSpotCapacityMutation, UpdateSpotCapacityMutationVariables>;
export const UpdateSpotCloseSpacesDocument = gql`
    mutation UpdateSpotCloseSpaces($value: Int!) {
  updateSpotCloseSpaces(value: $value) {
    id
    closeSpaces
  }
}
    `;
export type UpdateSpotCloseSpacesMutationFn = Apollo.MutationFunction<UpdateSpotCloseSpacesMutation, UpdateSpotCloseSpacesMutationVariables>;

/**
 * __useUpdateSpotCloseSpacesMutation__
 *
 * To run a mutation, you first call `useUpdateSpotCloseSpacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotCloseSpacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotCloseSpacesMutation, { data, loading, error }] = useUpdateSpotCloseSpacesMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateSpotCloseSpacesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotCloseSpacesMutation, UpdateSpotCloseSpacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotCloseSpacesMutation, UpdateSpotCloseSpacesMutationVariables>(UpdateSpotCloseSpacesDocument, options);
      }
export type UpdateSpotCloseSpacesMutationHookResult = ReturnType<typeof useUpdateSpotCloseSpacesMutation>;
export type UpdateSpotCloseSpacesMutationResult = Apollo.MutationResult<UpdateSpotCloseSpacesMutation>;
export type UpdateSpotCloseSpacesMutationOptions = Apollo.BaseMutationOptions<UpdateSpotCloseSpacesMutation, UpdateSpotCloseSpacesMutationVariables>;
export const UpdateSpotEquipmentDocument = gql`
    mutation UpdateSpotEquipment($input: UpdateSpotEquipmentInput!) {
  updateSpotEquipment(input: $input) {
    id
    amphitheater
    auditorium
    sono
    wifi
    stage
    video
    locker
    terrace
    toilets
    prmAccess
    dancefloor
    microphone
    prmToilets
    smokingRoom
    parking
    changingTable
    updatedAt
  }
}
    `;
export type UpdateSpotEquipmentMutationFn = Apollo.MutationFunction<UpdateSpotEquipmentMutation, UpdateSpotEquipmentMutationVariables>;

/**
 * __useUpdateSpotEquipmentMutation__
 *
 * To run a mutation, you first call `useUpdateSpotEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotEquipmentMutation, { data, loading, error }] = useUpdateSpotEquipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotEquipmentMutation, UpdateSpotEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotEquipmentMutation, UpdateSpotEquipmentMutationVariables>(UpdateSpotEquipmentDocument, options);
      }
export type UpdateSpotEquipmentMutationHookResult = ReturnType<typeof useUpdateSpotEquipmentMutation>;
export type UpdateSpotEquipmentMutationResult = Apollo.MutationResult<UpdateSpotEquipmentMutation>;
export type UpdateSpotEquipmentMutationOptions = Apollo.BaseMutationOptions<UpdateSpotEquipmentMutation, UpdateSpotEquipmentMutationVariables>;
export const UpdateSpotPaymentDocument = gql`
    mutation UpdateSpotPayment($input: UpdateSpotPaymentInput!) {
  updateSpotPayment(input: $input) {
    id
    amex
    cash
    checks
    blueCard
    mealTickets
    updatedAt
  }
}
    `;
export type UpdateSpotPaymentMutationFn = Apollo.MutationFunction<UpdateSpotPaymentMutation, UpdateSpotPaymentMutationVariables>;

/**
 * __useUpdateSpotPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateSpotPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotPaymentMutation, { data, loading, error }] = useUpdateSpotPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotPaymentMutation, UpdateSpotPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotPaymentMutation, UpdateSpotPaymentMutationVariables>(UpdateSpotPaymentDocument, options);
      }
export type UpdateSpotPaymentMutationHookResult = ReturnType<typeof useUpdateSpotPaymentMutation>;
export type UpdateSpotPaymentMutationResult = Apollo.MutationResult<UpdateSpotPaymentMutation>;
export type UpdateSpotPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateSpotPaymentMutation, UpdateSpotPaymentMutationVariables>;
export const UpdateSpotServiceDocument = gql`
    mutation UpdateSpotService($input: UpdateSpotServiceInput!) {
  updateSpotService(input: $input) {
    id
    dj
    karaoke
    ownMusic
    liveMusic
    entertainmentShow
    takeout
    updatedAt
  }
}
    `;
export type UpdateSpotServiceMutationFn = Apollo.MutationFunction<UpdateSpotServiceMutation, UpdateSpotServiceMutationVariables>;

/**
 * __useUpdateSpotServiceMutation__
 *
 * To run a mutation, you first call `useUpdateSpotServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotServiceMutation, { data, loading, error }] = useUpdateSpotServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotServiceMutation, UpdateSpotServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotServiceMutation, UpdateSpotServiceMutationVariables>(UpdateSpotServiceDocument, options);
      }
export type UpdateSpotServiceMutationHookResult = ReturnType<typeof useUpdateSpotServiceMutation>;
export type UpdateSpotServiceMutationResult = Apollo.MutationResult<UpdateSpotServiceMutation>;
export type UpdateSpotServiceMutationOptions = Apollo.BaseMutationOptions<UpdateSpotServiceMutation, UpdateSpotServiceMutationVariables>;
export const UpdateSpotSuitableDocument = gql`
    mutation UpdateSpotSuitable($input: UpdateSpotSuitableInput!) {
  updateSpotSuitable(input: $input) {
    id
    bachelor
    birthday
    farewell
    teamMeal
    wedding
    afterwork
    exposition
    cocktailPro
    fashionShow
    businessMeal
    companyEvent
    friendsDrink
    studentParty
    productLaunch
    kids
    watchSport
    telework
    veggie
    vegan
    updatedAt
  }
}
    `;
export type UpdateSpotSuitableMutationFn = Apollo.MutationFunction<UpdateSpotSuitableMutation, UpdateSpotSuitableMutationVariables>;

/**
 * __useUpdateSpotSuitableMutation__
 *
 * To run a mutation, you first call `useUpdateSpotSuitableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotSuitableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotSuitableMutation, { data, loading, error }] = useUpdateSpotSuitableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotSuitableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotSuitableMutation, UpdateSpotSuitableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotSuitableMutation, UpdateSpotSuitableMutationVariables>(UpdateSpotSuitableDocument, options);
      }
export type UpdateSpotSuitableMutationHookResult = ReturnType<typeof useUpdateSpotSuitableMutation>;
export type UpdateSpotSuitableMutationResult = Apollo.MutationResult<UpdateSpotSuitableMutation>;
export type UpdateSpotSuitableMutationOptions = Apollo.BaseMutationOptions<UpdateSpotSuitableMutation, UpdateSpotSuitableMutationVariables>;
export const UpdateSpotTypeDocument = gql`
    mutation UpdateSpotType($input: UpdateSpotTypeInput!) {
  updateSpotType(input: $input) {
    id
    amusementPark
    aquarium
    artGallery
    bar
    cafe
    campground
    concertHall
    casino
    departmentStore
    nightClub
    park
    restaurant
    sportClub
    stadium
    updatedAt
  }
}
    `;
export type UpdateSpotTypeMutationFn = Apollo.MutationFunction<UpdateSpotTypeMutation, UpdateSpotTypeMutationVariables>;

/**
 * __useUpdateSpotTypeMutation__
 *
 * To run a mutation, you first call `useUpdateSpotTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSpotTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSpotTypeMutation, { data, loading, error }] = useUpdateSpotTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSpotTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSpotTypeMutation, UpdateSpotTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSpotTypeMutation, UpdateSpotTypeMutationVariables>(UpdateSpotTypeDocument, options);
      }
export type UpdateSpotTypeMutationHookResult = ReturnType<typeof useUpdateSpotTypeMutation>;
export type UpdateSpotTypeMutationResult = Apollo.MutationResult<UpdateSpotTypeMutation>;
export type UpdateSpotTypeMutationOptions = Apollo.BaseMutationOptions<UpdateSpotTypeMutation, UpdateSpotTypeMutationVariables>;
export const GetAccountNotificationsDocument = gql`
    query GetAccountNotifications {
  getAccountNotifications {
    __typename
    ... on ConsumerNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      request {
        friendship {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        message {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        mention {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      booking {
        update {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        message {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      event {
        invitation {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        update {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        upcoming {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on SupportNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on OrganizerNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on MakerNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on SpotNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      request {
        message {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        mention {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      booking {
        new {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        update {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        late {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      feedback {
        new {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAccountNotificationsQuery__
 *
 * To run a query within a React component, call `useGetAccountNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountNotificationsQuery, GetAccountNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountNotificationsQuery, GetAccountNotificationsQueryVariables>(GetAccountNotificationsDocument, options);
      }
export function useGetAccountNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountNotificationsQuery, GetAccountNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountNotificationsQuery, GetAccountNotificationsQueryVariables>(GetAccountNotificationsDocument, options);
        }
export type GetAccountNotificationsQueryHookResult = ReturnType<typeof useGetAccountNotificationsQuery>;
export type GetAccountNotificationsLazyQueryHookResult = ReturnType<typeof useGetAccountNotificationsLazyQuery>;
export type GetAccountNotificationsQueryResult = Apollo.QueryResult<GetAccountNotificationsQuery, GetAccountNotificationsQueryVariables>;
export const UpdateNotificationsDocument = gql`
    mutation UpdateNotifications($input: UpdateNotificationInput!) {
  updateNotifications(input: $input) {
    __typename
    ... on ConsumerNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      booking {
        update {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        message {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      event {
        invitation {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        update {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        upcoming {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on SupportNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on OrganizerNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on MakerNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
    ... on SpotNotifications {
      id
      standby {
        all {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      request {
        message {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        mention {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      booking {
        new {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        update {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
        late {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
      feedback {
        new {
          email {
            enabled
            isOverridable
          }
          push {
            enabled
            isOverridable
          }
        }
      }
    }
  }
}
    `;
export type UpdateNotificationsMutationFn = Apollo.MutationFunction<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;

/**
 * __useUpdateNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsMutation, { data, loading, error }] = useUpdateNotificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>(UpdateNotificationsDocument, options);
      }
export type UpdateNotificationsMutationHookResult = ReturnType<typeof useUpdateNotificationsMutation>;
export type UpdateNotificationsMutationResult = Apollo.MutationResult<UpdateNotificationsMutation>;
export type UpdateNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;
export const GetConversationDocument = gql`
    query GetConversation($conversationId: ID!, $first: Int = 30, $after: String) {
  conversation(conversationId: $conversationId) {
    id
    name
    lastReadMessageId
    lastMessage {
      id
    }
    members {
      __typename
      ... on Spot {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Maker {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Support {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Organizer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
    }
    messages(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          conversationId
          content
          createdAt
          sender {
            __typename
            ... on Spot {
              id
              name
              slug
              avatar {
                id
                url
                fileId
                fileName
                size
                mimeType
                createdAt
              }
            }
            ... on Consumer {
              id
              name
              slug
              avatar {
                id
                url
                fileId
                fileName
                size
                mimeType
                createdAt
              }
            }
            ... on Maker {
              id
              name
              slug
              avatar {
                id
                url
                fileId
                fileName
                size
                mimeType
                createdAt
              }
            }
            ... on Support {
              id
              name
              slug
              avatar {
                id
                url
                fileId
                fileName
                size
                mimeType
                createdAt
              }
            }
            ... on Organizer {
              id
              name
              slug
              avatar {
                id
                url
                fileId
                fileName
                size
                mimeType
                createdAt
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    `;

/**
 * __useGetConversationQuery__
 *
 * To run a query within a React component, call `useGetConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetConversationQuery(baseOptions: Apollo.QueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
      }
export function useGetConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationQuery, GetConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationQuery, GetConversationQueryVariables>(GetConversationDocument, options);
        }
export type GetConversationQueryHookResult = ReturnType<typeof useGetConversationQuery>;
export type GetConversationLazyQueryHookResult = ReturnType<typeof useGetConversationLazyQuery>;
export type GetConversationQueryResult = Apollo.QueryResult<GetConversationQuery, GetConversationQueryVariables>;
export const GetConversationInfosDocument = gql`
    query GetConversationInfos($conversationId: ID!) {
  conversation(conversationId: $conversationId) {
    id
    name
    lastReadMessageId
    lastMessage {
      id
    }
    members {
      __typename
      ... on Spot {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Maker {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Support {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Organizer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetConversationInfosQuery__
 *
 * To run a query within a React component, call `useGetConversationInfosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConversationInfosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConversationInfosQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetConversationInfosQuery(baseOptions: Apollo.QueryHookOptions<GetConversationInfosQuery, GetConversationInfosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConversationInfosQuery, GetConversationInfosQueryVariables>(GetConversationInfosDocument, options);
      }
export function useGetConversationInfosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConversationInfosQuery, GetConversationInfosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConversationInfosQuery, GetConversationInfosQueryVariables>(GetConversationInfosDocument, options);
        }
export type GetConversationInfosQueryHookResult = ReturnType<typeof useGetConversationInfosQuery>;
export type GetConversationInfosLazyQueryHookResult = ReturnType<typeof useGetConversationInfosLazyQuery>;
export type GetConversationInfosQueryResult = Apollo.QueryResult<GetConversationInfosQuery, GetConversationInfosQueryVariables>;
export const ResetUnreadCountDocument = gql`
    mutation ResetUnreadCount($conversationId: ID!) {
  resetUnreadCount(conversationId: $conversationId)
}
    `;
export type ResetUnreadCountMutationFn = Apollo.MutationFunction<ResetUnreadCountMutation, ResetUnreadCountMutationVariables>;

/**
 * __useResetUnreadCountMutation__
 *
 * To run a mutation, you first call `useResetUnreadCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUnreadCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUnreadCountMutation, { data, loading, error }] = useResetUnreadCountMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useResetUnreadCountMutation(baseOptions?: Apollo.MutationHookOptions<ResetUnreadCountMutation, ResetUnreadCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUnreadCountMutation, ResetUnreadCountMutationVariables>(ResetUnreadCountDocument, options);
      }
export type ResetUnreadCountMutationHookResult = ReturnType<typeof useResetUnreadCountMutation>;
export type ResetUnreadCountMutationResult = Apollo.MutationResult<ResetUnreadCountMutation>;
export type ResetUnreadCountMutationOptions = Apollo.BaseMutationOptions<ResetUnreadCountMutation, ResetUnreadCountMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($conversationId: ID!, $content: String!) {
  sendMessage(conversationId: $conversationId, content: $content)
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const OnTypingDocument = gql`
    subscription OnTyping($conversationId: ID!) {
  typing(conversationId: $conversationId) {
    conversationId
    senderId
    isTyping
  }
}
    `;

/**
 * __useOnTypingSubscription__
 *
 * To run a query within a React component, call `useOnTypingSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnTypingSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnTypingSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useOnTypingSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnTypingSubscription, OnTypingSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnTypingSubscription, OnTypingSubscriptionVariables>(OnTypingDocument, options);
      }
export type OnTypingSubscriptionHookResult = ReturnType<typeof useOnTypingSubscription>;
export type OnTypingSubscriptionResult = Apollo.SubscriptionResult<OnTypingSubscription>;
export const SetTypingDocument = gql`
    mutation SetTyping($conversationId: ID!, $isTyping: Boolean!) {
  setTyping(conversationId: $conversationId, isTyping: $isTyping)
}
    `;
export type SetTypingMutationFn = Apollo.MutationFunction<SetTypingMutation, SetTypingMutationVariables>;

/**
 * __useSetTypingMutation__
 *
 * To run a mutation, you first call `useSetTypingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTypingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTypingMutation, { data, loading, error }] = useSetTypingMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      isTyping: // value for 'isTyping'
 *   },
 * });
 */
export function useSetTypingMutation(baseOptions?: Apollo.MutationHookOptions<SetTypingMutation, SetTypingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTypingMutation, SetTypingMutationVariables>(SetTypingDocument, options);
      }
export type SetTypingMutationHookResult = ReturnType<typeof useSetTypingMutation>;
export type SetTypingMutationResult = Apollo.MutationResult<SetTypingMutation>;
export type SetTypingMutationOptions = Apollo.BaseMutationOptions<SetTypingMutation, SetTypingMutationVariables>;
export const OnMessageSentDocument = gql`
    subscription OnMessageSent($conversationId: ID!) {
  messageSent(conversationId: $conversationId) {
    cursor
    node {
      id
      content
      createdAt
      conversationId
      sender {
        __typename
        ... on Spot {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Consumer {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Support {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Organizer {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOnMessageSentSubscription__
 *
 * To run a query within a React component, call `useOnMessageSentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnMessageSentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnMessageSentSubscription({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useOnMessageSentSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnMessageSentSubscription, OnMessageSentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnMessageSentSubscription, OnMessageSentSubscriptionVariables>(OnMessageSentDocument, options);
      }
export type OnMessageSentSubscriptionHookResult = ReturnType<typeof useOnMessageSentSubscription>;
export type OnMessageSentSubscriptionResult = Apollo.SubscriptionResult<OnMessageSentSubscription>;
export const ListConversationsDocument = gql`
    query ListConversations {
  conversations {
    id
    name
    members {
      __typename
      ... on Spot {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Maker {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Support {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Organizer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
    }
    unreadCount
    lastMessage {
      id
      content
      createdAt
      sender {
        ... on Spot {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Consumer {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Support {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Organizer {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListConversationsQuery__
 *
 * To run a query within a React component, call `useListConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConversationsQuery, ListConversationsQueryVariables>(ListConversationsDocument, options);
      }
export function useListConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConversationsQuery, ListConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConversationsQuery, ListConversationsQueryVariables>(ListConversationsDocument, options);
        }
export type ListConversationsQueryHookResult = ReturnType<typeof useListConversationsQuery>;
export type ListConversationsLazyQueryHookResult = ReturnType<typeof useListConversationsLazyQuery>;
export type ListConversationsQueryResult = Apollo.QueryResult<ListConversationsQuery, ListConversationsQueryVariables>;
export const OnConversationUpdateDocument = gql`
    subscription OnConversationUpdate {
  conversationUpdate {
    id
    name
    members {
      __typename
      ... on Spot {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Maker {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Support {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
      ... on Organizer {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
      }
    }
    unreadCount
    lastMessage {
      id
      content
      createdAt
      sender {
        __typename
        ... on Spot {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Consumer {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Support {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
        ... on Organizer {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOnConversationUpdateSubscription__
 *
 * To run a query within a React component, call `useOnConversationUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnConversationUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnConversationUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnConversationUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnConversationUpdateSubscription, OnConversationUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnConversationUpdateSubscription, OnConversationUpdateSubscriptionVariables>(OnConversationUpdateDocument, options);
      }
export type OnConversationUpdateSubscriptionHookResult = ReturnType<typeof useOnConversationUpdateSubscription>;
export type OnConversationUpdateSubscriptionResult = Apollo.SubscriptionResult<OnConversationUpdateSubscription>;
export const ListNotificationsDocument = gql`
    query ListNotifications {
  notifications {
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useListNotificationsQuery__
 *
 * To run a query within a React component, call `useListNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<ListNotificationsQuery, ListNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListNotificationsQuery, ListNotificationsQueryVariables>(ListNotificationsDocument, options);
      }
export function useListNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListNotificationsQuery, ListNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListNotificationsQuery, ListNotificationsQueryVariables>(ListNotificationsDocument, options);
        }
export type ListNotificationsQueryHookResult = ReturnType<typeof useListNotificationsQuery>;
export type ListNotificationsLazyQueryHookResult = ReturnType<typeof useListNotificationsLazyQuery>;
export type ListNotificationsQueryResult = Apollo.QueryResult<ListNotificationsQuery, ListNotificationsQueryVariables>;
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($notificationId: ID!) {
  markNotificationAsRead(notificationId: $notificationId) {
    id
    count
  }
}
    `;
export type MarkNotificationAsReadMutationFn = Apollo.MutationFunction<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;

/**
 * __useMarkNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationAsReadMutation, { data, loading, error }] = useMarkNotificationAsReadMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useMarkNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument, options);
      }
export type MarkNotificationAsReadMutationHookResult = ReturnType<typeof useMarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationResult = Apollo.MutationResult<MarkNotificationAsReadMutation>;
export type MarkNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const OnNotificationUpdateDocument = gql`
    subscription OnNotificationUpdate {
  notificationUpdate {
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;

/**
 * __useOnNotificationUpdateSubscription__
 *
 * To run a query within a React component, call `useOnNotificationUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNotificationUpdateSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNotificationUpdateSubscription, OnNotificationUpdateSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotificationUpdateSubscription, OnNotificationUpdateSubscriptionVariables>(OnNotificationUpdateDocument, options);
      }
export type OnNotificationUpdateSubscriptionHookResult = ReturnType<typeof useOnNotificationUpdateSubscription>;
export type OnNotificationUpdateSubscriptionResult = Apollo.SubscriptionResult<OnNotificationUpdateSubscription>;
export const OnNotificationDeleteDocument = gql`
    subscription OnNotificationDelete {
  notificationDelete
}
    `;

/**
 * __useOnNotificationDeleteSubscription__
 *
 * To run a query within a React component, call `useOnNotificationDeleteSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnNotificationDeleteSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnNotificationDeleteSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnNotificationDeleteSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnNotificationDeleteSubscription, OnNotificationDeleteSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnNotificationDeleteSubscription, OnNotificationDeleteSubscriptionVariables>(OnNotificationDeleteDocument, options);
      }
export type OnNotificationDeleteSubscriptionHookResult = ReturnType<typeof useOnNotificationDeleteSubscription>;
export type OnNotificationDeleteSubscriptionResult = Apollo.SubscriptionResult<OnNotificationDeleteSubscription>;
export const GetConsumerMetaDocument = gql`
    query GetConsumerMeta($slug: ID!) {
  consumer(slug: $slug) {
    id
    name
    description
    slug
    avatar {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
  }
}
    `;

/**
 * __useGetConsumerMetaQuery__
 *
 * To run a query within a React component, call `useGetConsumerMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerMetaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetConsumerMetaQuery(baseOptions: Apollo.QueryHookOptions<GetConsumerMetaQuery, GetConsumerMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsumerMetaQuery, GetConsumerMetaQueryVariables>(GetConsumerMetaDocument, options);
      }
export function useGetConsumerMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsumerMetaQuery, GetConsumerMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsumerMetaQuery, GetConsumerMetaQueryVariables>(GetConsumerMetaDocument, options);
        }
export type GetConsumerMetaQueryHookResult = ReturnType<typeof useGetConsumerMetaQuery>;
export type GetConsumerMetaLazyQueryHookResult = ReturnType<typeof useGetConsumerMetaLazyQuery>;
export type GetConsumerMetaQueryResult = Apollo.QueryResult<GetConsumerMetaQuery, GetConsumerMetaQueryVariables>;
export const GetSpotMetaDocument = gql`
    query GetSpotMeta($slug: ID!) {
  spot(slug: $slug) {
    id
    name
    description
    slug
    covers {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
  }
}
    `;

/**
 * __useGetSpotMetaQuery__
 *
 * To run a query within a React component, call `useGetSpotMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotMetaQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetSpotMetaQuery(baseOptions: Apollo.QueryHookOptions<GetSpotMetaQuery, GetSpotMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotMetaQuery, GetSpotMetaQueryVariables>(GetSpotMetaDocument, options);
      }
export function useGetSpotMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotMetaQuery, GetSpotMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotMetaQuery, GetSpotMetaQueryVariables>(GetSpotMetaDocument, options);
        }
export type GetSpotMetaQueryHookResult = ReturnType<typeof useGetSpotMetaQuery>;
export type GetSpotMetaLazyQueryHookResult = ReturnType<typeof useGetSpotMetaLazyQuery>;
export type GetSpotMetaQueryResult = Apollo.QueryResult<GetSpotMetaQuery, GetSpotMetaQueryVariables>;
export const GetEventMetaDocument = gql`
    query GetEventMeta($id: ID!) {
  event(id: $id) {
    id
    title
    description
    covers {
      id
      url
      fileId
      fileName
      size
      mimeType
      createdAt
    }
  }
}
    `;

/**
 * __useGetEventMetaQuery__
 *
 * To run a query within a React component, call `useGetEventMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventMetaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventMetaQuery(baseOptions: Apollo.QueryHookOptions<GetEventMetaQuery, GetEventMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventMetaQuery, GetEventMetaQueryVariables>(GetEventMetaDocument, options);
      }
export function useGetEventMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventMetaQuery, GetEventMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventMetaQuery, GetEventMetaQueryVariables>(GetEventMetaDocument, options);
        }
export type GetEventMetaQueryHookResult = ReturnType<typeof useGetEventMetaQuery>;
export type GetEventMetaLazyQueryHookResult = ReturnType<typeof useGetEventMetaLazyQuery>;
export type GetEventMetaQueryResult = Apollo.QueryResult<GetEventMetaQuery, GetEventMetaQueryVariables>;
export const GetBookingMetaDocument = gql`
    query GetBookingMeta($id: ID!) {
  booking(id: $id) {
    id
    startTime
    origin
    spot {
      id
      slug
      name
    }
    client {
      ... on BookingClient {
        id
        firstname
      }
      ... on Consumer {
        id
        user {
          id
          firstname
        }
      }
    }
  }
}
    `;

/**
 * __useGetBookingMetaQuery__
 *
 * To run a query within a React component, call `useGetBookingMetaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingMetaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingMetaQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBookingMetaQuery(baseOptions: Apollo.QueryHookOptions<GetBookingMetaQuery, GetBookingMetaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBookingMetaQuery, GetBookingMetaQueryVariables>(GetBookingMetaDocument, options);
      }
export function useGetBookingMetaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBookingMetaQuery, GetBookingMetaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBookingMetaQuery, GetBookingMetaQueryVariables>(GetBookingMetaDocument, options);
        }
export type GetBookingMetaQueryHookResult = ReturnType<typeof useGetBookingMetaQuery>;
export type GetBookingMetaLazyQueryHookResult = ReturnType<typeof useGetBookingMetaLazyQuery>;
export type GetBookingMetaQueryResult = Apollo.QueryResult<GetBookingMetaQuery, GetBookingMetaQueryVariables>;
export const IsSlugAvailableDocument = gql`
    query isSlugAvailable($slug: String!) {
  isSlugAvailable(slug: $slug)
}
    `;

/**
 * __useIsSlugAvailableQuery__
 *
 * To run a query within a React component, call `useIsSlugAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsSlugAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsSlugAvailableQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useIsSlugAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsSlugAvailableQuery, IsSlugAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsSlugAvailableQuery, IsSlugAvailableQueryVariables>(IsSlugAvailableDocument, options);
      }
export function useIsSlugAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsSlugAvailableQuery, IsSlugAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsSlugAvailableQuery, IsSlugAvailableQueryVariables>(IsSlugAvailableDocument, options);
        }
export type IsSlugAvailableQueryHookResult = ReturnType<typeof useIsSlugAvailableQuery>;
export type IsSlugAvailableLazyQueryHookResult = ReturnType<typeof useIsSlugAvailableLazyQuery>;
export type IsSlugAvailableQueryResult = Apollo.QueryResult<IsSlugAvailableQuery, IsSlugAvailableQueryVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($input: UpdateAccountInput!) {
  updateAccount(input: $input) {
    ... on Consumer {
      id
      name
      slug
    }
    ... on Spot {
      id
      name
      slug
    }
    ... on Maker {
      id
      name
      slug
    }
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateAccountDescriptionDocument = gql`
    mutation UpdateAccountDescription($input: UpdateAccountDescriptionInput!) {
  updateAccountDescription(input: $input)
}
    `;
export type UpdateAccountDescriptionMutationFn = Apollo.MutationFunction<UpdateAccountDescriptionMutation, UpdateAccountDescriptionMutationVariables>;

/**
 * __useUpdateAccountDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateAccountDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountDescriptionMutation, { data, loading, error }] = useUpdateAccountDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountDescriptionMutation, UpdateAccountDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountDescriptionMutation, UpdateAccountDescriptionMutationVariables>(UpdateAccountDescriptionDocument, options);
      }
export type UpdateAccountDescriptionMutationHookResult = ReturnType<typeof useUpdateAccountDescriptionMutation>;
export type UpdateAccountDescriptionMutationResult = Apollo.MutationResult<UpdateAccountDescriptionMutation>;
export type UpdateAccountDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateAccountDescriptionMutation, UpdateAccountDescriptionMutationVariables>;
export const UpsertSpotMenuDocument = gql`
    mutation upsertSpotMenu($input: UpsertSpotMenuInput!) {
  upsertSpotMenu(input: $input)
}
    `;
export type UpsertSpotMenuMutationFn = Apollo.MutationFunction<UpsertSpotMenuMutation, UpsertSpotMenuMutationVariables>;

/**
 * __useUpsertSpotMenuMutation__
 *
 * To run a mutation, you first call `useUpsertSpotMenuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSpotMenuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSpotMenuMutation, { data, loading, error }] = useUpsertSpotMenuMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertSpotMenuMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSpotMenuMutation, UpsertSpotMenuMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSpotMenuMutation, UpsertSpotMenuMutationVariables>(UpsertSpotMenuDocument, options);
      }
export type UpsertSpotMenuMutationHookResult = ReturnType<typeof useUpsertSpotMenuMutation>;
export type UpsertSpotMenuMutationResult = Apollo.MutationResult<UpsertSpotMenuMutation>;
export type UpsertSpotMenuMutationOptions = Apollo.BaseMutationOptions<UpsertSpotMenuMutation, UpsertSpotMenuMutationVariables>;
export const IsEmailAvailableDocument = gql`
    query isEmailAvailable($email: String!) {
  isEmailAvailable(email: $email)
}
    `;

/**
 * __useIsEmailAvailableQuery__
 *
 * To run a query within a React component, call `useIsEmailAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsEmailAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsEmailAvailableQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useIsEmailAvailableQuery(baseOptions: Apollo.QueryHookOptions<IsEmailAvailableQuery, IsEmailAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsEmailAvailableQuery, IsEmailAvailableQueryVariables>(IsEmailAvailableDocument, options);
      }
export function useIsEmailAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsEmailAvailableQuery, IsEmailAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsEmailAvailableQuery, IsEmailAvailableQueryVariables>(IsEmailAvailableDocument, options);
        }
export type IsEmailAvailableQueryHookResult = ReturnType<typeof useIsEmailAvailableQuery>;
export type IsEmailAvailableLazyQueryHookResult = ReturnType<typeof useIsEmailAvailableLazyQuery>;
export type IsEmailAvailableQueryResult = Apollo.QueryResult<IsEmailAvailableQuery, IsEmailAvailableQueryVariables>;
export const IsPasswordValidDocument = gql`
    mutation isPasswordValid($password: String!) {
  isPasswordValid(password: $password)
}
    `;
export type IsPasswordValidMutationFn = Apollo.MutationFunction<IsPasswordValidMutation, IsPasswordValidMutationVariables>;

/**
 * __useIsPasswordValidMutation__
 *
 * To run a mutation, you first call `useIsPasswordValidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsPasswordValidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isPasswordValidMutation, { data, loading, error }] = useIsPasswordValidMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useIsPasswordValidMutation(baseOptions?: Apollo.MutationHookOptions<IsPasswordValidMutation, IsPasswordValidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsPasswordValidMutation, IsPasswordValidMutationVariables>(IsPasswordValidDocument, options);
      }
export type IsPasswordValidMutationHookResult = ReturnType<typeof useIsPasswordValidMutation>;
export type IsPasswordValidMutationResult = Apollo.MutationResult<IsPasswordValidMutation>;
export type IsPasswordValidMutationOptions = Apollo.BaseMutationOptions<IsPasswordValidMutation, IsPasswordValidMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($password: String!) {
  changePassword(password: $password)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const SwitchAccountDocument = gql`
    mutation SwitchAccount($id: ID!) {
  switchAccount(id: $id)
}
    `;
export type SwitchAccountMutationFn = Apollo.MutationFunction<SwitchAccountMutation, SwitchAccountMutationVariables>;

/**
 * __useSwitchAccountMutation__
 *
 * To run a mutation, you first call `useSwitchAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchAccountMutation, { data, loading, error }] = useSwitchAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSwitchAccountMutation(baseOptions?: Apollo.MutationHookOptions<SwitchAccountMutation, SwitchAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchAccountMutation, SwitchAccountMutationVariables>(SwitchAccountDocument, options);
      }
export type SwitchAccountMutationHookResult = ReturnType<typeof useSwitchAccountMutation>;
export type SwitchAccountMutationResult = Apollo.MutationResult<SwitchAccountMutation>;
export type SwitchAccountMutationOptions = Apollo.BaseMutationOptions<SwitchAccountMutation, SwitchAccountMutationVariables>;
export const SaveUserPushTokenDocument = gql`
    mutation SaveUserPushToken($input: UserPushTokenInput!) {
  saveUserPushToken(input: $input)
}
    `;
export type SaveUserPushTokenMutationFn = Apollo.MutationFunction<SaveUserPushTokenMutation, SaveUserPushTokenMutationVariables>;

/**
 * __useSaveUserPushTokenMutation__
 *
 * To run a mutation, you first call `useSaveUserPushTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserPushTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserPushTokenMutation, { data, loading, error }] = useSaveUserPushTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUserPushTokenMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserPushTokenMutation, SaveUserPushTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserPushTokenMutation, SaveUserPushTokenMutationVariables>(SaveUserPushTokenDocument, options);
      }
export type SaveUserPushTokenMutationHookResult = ReturnType<typeof useSaveUserPushTokenMutation>;
export type SaveUserPushTokenMutationResult = Apollo.MutationResult<SaveUserPushTokenMutation>;
export type SaveUserPushTokenMutationOptions = Apollo.BaseMutationOptions<SaveUserPushTokenMutation, SaveUserPushTokenMutationVariables>;
export const GetSessionDocument = gql`
    query GetSession {
  session {
    id
    ssoProvider
    email
    emailTokenSentAt
    firstname
    lastname
    gender
    birthdate
    mobilePhone
    preferences {
      language
      theme
    }
    isActive
    isVerified
    isDelete
    createdAt
    updatedAt
    deletedAt
    accounts {
      __typename
      ... on Consumer {
        id
        isCurrent
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        isActive
        isVerified
        deletedAt
        isPrivate
      }
      ... on Support {
        id
        isCurrent
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        isActive
        isVerified
        deletedAt
      }
      ... on Organizer {
        id
        isCurrent
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        isActive
        isVerified
        deletedAt
      }
      ... on Maker {
        id
        isCurrent
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        isActive
        isVerified
        deletedAt
      }
      ... on Spot {
        id
        isCurrent
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        isActive
        isVerified
        deletedAt
        address {
          id
          timezone
        }
        notifications {
          id
          standby {
            all {
              email {
                enabled
                isOverridable
              }
              push {
                enabled
                isOverridable
              }
            }
          }
        }
        opening {
          id
          dayOfWeek
          openTime
          closingTime
          breakIn
          breakOut
          updatedAt
        }
        closing {
          id
          reason
          description
          from
          to
          updatedAt
        }
        atmosphere {
          id
          calm
          lively
          dancing
          updatedAt
        }
        bringable {
          id
          dogs
          food
          drinks
          birthdayCake
          updatedAt
        }
        configuration {
          id
          defaultImage
          primaryType
          secondaryType
          tertiaryType
          pricing
          closeSpaces
          musicalGenre
          capacity
          entryPrice
          updatedAt
        }
        equipment {
          id
          amphitheater
          auditorium
          sono
          wifi
          stage
          video
          locker
          terrace
          toilets
          prmAccess
          dancefloor
          microphone
          prmToilets
          smokingRoom
          parking
          changingTable
          updatedAt
        }
        highlight {
          id
          mountainView
          oceanView
          rooftop
          seaView
          sunset
          sunrise
          updatedAt
        }
        payment {
          id
          amex
          cash
          checks
          blueCard
          mealTickets
          updatedAt
        }
        service {
          id
          dj
          karaoke
          ownMusic
          liveMusic
          entertainmentShow
          takeout
          updatedAt
        }
        suitable {
          id
          bachelor
          birthday
          farewell
          teamMeal
          wedding
          afterwork
          exposition
          cocktailPro
          fashionShow
          businessMeal
          companyEvent
          friendsDrink
          studentParty
          productLaunch
          kids
          watchSport
          telework
          veggie
          vegan
          updatedAt
        }
        type {
          id
          amusementPark
          aquarium
          artGallery
          bar
          cafe
          campground
          concertHall
          casino
          departmentStore
          nightClub
          park
          restaurant
          sportClub
          stadium
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetSessionQuery__
 *
 * To run a query within a React component, call `useGetSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSessionQuery(baseOptions?: Apollo.QueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
      }
export function useGetSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionQuery, GetSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionQuery, GetSessionQueryVariables>(GetSessionDocument, options);
        }
export type GetSessionQueryHookResult = ReturnType<typeof useGetSessionQuery>;
export type GetSessionLazyQueryHookResult = ReturnType<typeof useGetSessionLazyQuery>;
export type GetSessionQueryResult = Apollo.QueryResult<GetSessionQuery, GetSessionQueryVariables>;
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    access
    refresh
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RefreshTokensDocument = gql`
    mutation refreshTokens($refreshToken: String!) {
  refreshTokens(refreshToken: $refreshToken) {
    access
    refresh
  }
}
    `;
export type RefreshTokensMutationFn = Apollo.MutationFunction<RefreshTokensMutation, RefreshTokensMutationVariables>;

/**
 * __useRefreshTokensMutation__
 *
 * To run a mutation, you first call `useRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokensMutation, { data, loading, error }] = useRefreshTokensMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokensMutation, RefreshTokensMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokensMutation, RefreshTokensMutationVariables>(RefreshTokensDocument, options);
      }
export type RefreshTokensMutationHookResult = ReturnType<typeof useRefreshTokensMutation>;
export type RefreshTokensMutationResult = Apollo.MutationResult<RefreshTokensMutation>;
export type RefreshTokensMutationOptions = Apollo.BaseMutationOptions<RefreshTokensMutation, RefreshTokensMutationVariables>;
export const LoginSsoDocument = gql`
    mutation loginSSO($input: LoginSSOInput!) {
  loginSSO(input: $input) {
    __typename
    ... on Tokens {
      access
      refresh
    }
    ... on ProfileSSO {
      email
      firstname
      lastname
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
    }
  }
}
    `;
export type LoginSsoMutationFn = Apollo.MutationFunction<LoginSsoMutation, LoginSsoMutationVariables>;

/**
 * __useLoginSsoMutation__
 *
 * To run a mutation, you first call `useLoginSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginSsoMutation, { data, loading, error }] = useLoginSsoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginSsoMutation(baseOptions?: Apollo.MutationHookOptions<LoginSsoMutation, LoginSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginSsoMutation, LoginSsoMutationVariables>(LoginSsoDocument, options);
      }
export type LoginSsoMutationHookResult = ReturnType<typeof useLoginSsoMutation>;
export type LoginSsoMutationResult = Apollo.MutationResult<LoginSsoMutation>;
export type LoginSsoMutationOptions = Apollo.BaseMutationOptions<LoginSsoMutation, LoginSsoMutationVariables>;
export const GetUserByEmailTokenDocument = gql`
    query GetUserByEmailToken($token: String!) {
  userByEmailToken(token: $token) {
    id
    isVerified
  }
}
    `;

/**
 * __useGetUserByEmailTokenQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetUserByEmailTokenQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailTokenQuery, GetUserByEmailTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailTokenQuery, GetUserByEmailTokenQueryVariables>(GetUserByEmailTokenDocument, options);
      }
export function useGetUserByEmailTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailTokenQuery, GetUserByEmailTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailTokenQuery, GetUserByEmailTokenQueryVariables>(GetUserByEmailTokenDocument, options);
        }
export type GetUserByEmailTokenQueryHookResult = ReturnType<typeof useGetUserByEmailTokenQuery>;
export type GetUserByEmailTokenLazyQueryHookResult = ReturnType<typeof useGetUserByEmailTokenLazyQuery>;
export type GetUserByEmailTokenQueryResult = Apollo.QueryResult<GetUserByEmailTokenQuery, GetUserByEmailTokenQueryVariables>;
export const VerifyEmailDocument = gql`
    mutation verifyEmail($token: String!) {
  verifyEmail(token: $token) {
    id
    isVerified
    isActive
    updatedAt
  }
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const ReSendActivationMailDocument = gql`
    mutation reSendActivationMail {
  reSendActivationMail {
    id
    emailTokenSentAt
  }
}
    `;
export type ReSendActivationMailMutationFn = Apollo.MutationFunction<ReSendActivationMailMutation, ReSendActivationMailMutationVariables>;

/**
 * __useReSendActivationMailMutation__
 *
 * To run a mutation, you first call `useReSendActivationMailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReSendActivationMailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reSendActivationMailMutation, { data, loading, error }] = useReSendActivationMailMutation({
 *   variables: {
 *   },
 * });
 */
export function useReSendActivationMailMutation(baseOptions?: Apollo.MutationHookOptions<ReSendActivationMailMutation, ReSendActivationMailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReSendActivationMailMutation, ReSendActivationMailMutationVariables>(ReSendActivationMailDocument, options);
      }
export type ReSendActivationMailMutationHookResult = ReturnType<typeof useReSendActivationMailMutation>;
export type ReSendActivationMailMutationResult = Apollo.MutationResult<ReSendActivationMailMutation>;
export type ReSendActivationMailMutationOptions = Apollo.BaseMutationOptions<ReSendActivationMailMutation, ReSendActivationMailMutationVariables>;
export const LogoutDocument = gql`
    mutation logout($FCMToken: String) {
  logout(FCMToken: $FCMToken)
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *      FCMToken: // value for 'FCMToken'
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser {
  deleteUser
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ListCategoriesDocument = gql`
    query listCategories {
  categories {
    id
    name
    description
    cover
  }
}
    `;

/**
 * __useListCategoriesQuery__
 *
 * To run a query within a React component, call `useListCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(ListCategoriesDocument, options);
      }
export function useListCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCategoriesQuery, ListCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCategoriesQuery, ListCategoriesQueryVariables>(ListCategoriesDocument, options);
        }
export type ListCategoriesQueryHookResult = ReturnType<typeof useListCategoriesQuery>;
export type ListCategoriesLazyQueryHookResult = ReturnType<typeof useListCategoriesLazyQuery>;
export type ListCategoriesQueryResult = Apollo.QueryResult<ListCategoriesQuery, ListCategoriesQueryVariables>;
export const EventsDocument = gql`
    query events($input: EventsInput!) {
  events(input: $input) {
    id
    ...EventFragment
    category {
      ...CategoryFragment
    }
    address {
      ...AddressFragment
    }
    makers {
      ...GuestFragment
    }
  }
}
    ${EventFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${GuestFragmentFragmentDoc}`;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;
export const EventDocument = gql`
    query event($id: ID!) {
  event(id: $id) {
    id
    ...EventFragment
    category {
      ...CategoryFragment
    }
    address {
      ...AddressFragment
    }
    makers {
      ...GuestFragment
    }
  }
}
    ${EventFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${GuestFragmentFragmentDoc}`;

/**
 * __useEventQuery__
 *
 * To run a query within a React component, call `useEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventQuery(baseOptions: Apollo.QueryHookOptions<EventQuery, EventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventQuery, EventQueryVariables>(EventDocument, options);
      }
export function useEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventQuery, EventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventQuery, EventQueryVariables>(EventDocument, options);
        }
export type EventQueryHookResult = ReturnType<typeof useEventQuery>;
export type EventLazyQueryHookResult = ReturnType<typeof useEventLazyQuery>;
export type EventQueryResult = Apollo.QueryResult<EventQuery, EventQueryVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    firstname
    lastname
    gender
    email
    birthdate
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserPreferencesDocument = gql`
    mutation UpdateUserPreferences($input: UpdateUserPreferencesInput!) {
  updateUserPreferences(input: $input)
}
    `;
export type UpdateUserPreferencesMutationFn = Apollo.MutationFunction<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>;

/**
 * __useUpdateUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferencesMutation, { data, loading, error }] = useUpdateUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>(UpdateUserPreferencesDocument, options);
      }
export type UpdateUserPreferencesMutationHookResult = ReturnType<typeof useUpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationResult = Apollo.MutationResult<UpdateUserPreferencesMutation>;
export type UpdateUserPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferencesMutation, UpdateUserPreferencesMutationVariables>;
export const ListHomeEventsDocument = gql`
    query ListHomeEvents {
  eventCategories {
    id
    name
    events {
      id
      ...EventFragment
      category {
        ...CategoryFragment
      }
      address {
        ...AddressFragment
        label
      }
      spot {
        id
        name
        slug
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        covers {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        address {
          ...AddressFragment
        }
        configuration {
          id
          defaultImage
          primaryType
          secondaryType
          tertiaryType
          pricing
        }
        type {
          id
          amusementPark
          aquarium
          artGallery
          bar
          cafe
          campground
          concertHall
          casino
          departmentStore
          nightClub
          park
          restaurant
          sportClub
          stadium
        }
      }
      makers {
        ...GuestFragment
      }
      tickets {
        id
        idx
        currency
        price
      }
    }
  }
}
    ${EventFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${GuestFragmentFragmentDoc}`;

/**
 * __useListHomeEventsQuery__
 *
 * To run a query within a React component, call `useListHomeEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomeEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomeEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomeEventsQuery(baseOptions?: Apollo.QueryHookOptions<ListHomeEventsQuery, ListHomeEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomeEventsQuery, ListHomeEventsQueryVariables>(ListHomeEventsDocument, options);
      }
export function useListHomeEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomeEventsQuery, ListHomeEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomeEventsQuery, ListHomeEventsQueryVariables>(ListHomeEventsDocument, options);
        }
export type ListHomeEventsQueryHookResult = ReturnType<typeof useListHomeEventsQuery>;
export type ListHomeEventsLazyQueryHookResult = ReturnType<typeof useListHomeEventsLazyQuery>;
export type ListHomeEventsQueryResult = Apollo.QueryResult<ListHomeEventsQuery, ListHomeEventsQueryVariables>;
export const GetEventDocument = gql`
    query GetEvent($id: ID!) {
  event(id: $id) {
    id
    ...EventFragment
    category {
      ...CategoryFragment
    }
    address {
      ...AddressFragment
      label
    }
    FAQs {
      id
      idx
      question
      answer
    }
    spot {
      id
      name
      slug
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      covers {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      address {
        ...AddressFragment
      }
      type {
        id
        amusementPark
        aquarium
        artGallery
        bar
        cafe
        campground
        casino
        concertHall
        departmentStore
        nightClub
        park
        restaurant
        sportClub
        stadium
        updatedAt
      }
      configuration {
        id
        defaultImage
        closeSpaces
        entryPrice
        primaryType
        pricing
        capacity
        musicalGenre
        updatedAt
      }
    }
    makers {
      ...GuestFragment
    }
  }
}
    ${EventFragmentFragmentDoc}
${CategoryFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${GuestFragmentFragmentDoc}`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const ListHomeMakersDocument = gql`
    query ListHomeMakers {
  homeMakers {
    id
    title
    makers {
      id
      name
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      covers {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      address {
        ...AddressFragment
        label
      }
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useListHomeMakersQuery__
 *
 * To run a query within a React component, call `useListHomeMakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomeMakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomeMakersQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomeMakersQuery(baseOptions?: Apollo.QueryHookOptions<ListHomeMakersQuery, ListHomeMakersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomeMakersQuery, ListHomeMakersQueryVariables>(ListHomeMakersDocument, options);
      }
export function useListHomeMakersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomeMakersQuery, ListHomeMakersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomeMakersQuery, ListHomeMakersQueryVariables>(ListHomeMakersDocument, options);
        }
export type ListHomeMakersQueryHookResult = ReturnType<typeof useListHomeMakersQuery>;
export type ListHomeMakersLazyQueryHookResult = ReturnType<typeof useListHomeMakersLazyQuery>;
export type ListHomeMakersQueryResult = Apollo.QueryResult<ListHomeMakersQuery, ListHomeMakersQueryVariables>;
export const GetSpotStatsDocument = gql`
    query GetSpotStats($range: String!, $dateRange: DateRangeInput) {
  getSpotStats(range: $range, dateRange: $dateRange) {
    id
    addicts {
      current
      previous
      dataSet
    }
    bookings {
      current
      previous
      dataSet
    }
    events {
      current
      previous
      dataSet
    }
    transformation {
      current
      previous
      dataSet
    }
    bounces {
      current
      previous
      dataSet
    }
    views {
      current
      previous
      dataSet
    }
  }
}
    `;

/**
 * __useGetSpotStatsQuery__
 *
 * To run a query within a React component, call `useGetSpotStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotStatsQuery({
 *   variables: {
 *      range: // value for 'range'
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetSpotStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSpotStatsQuery, GetSpotStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotStatsQuery, GetSpotStatsQueryVariables>(GetSpotStatsDocument, options);
      }
export function useGetSpotStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotStatsQuery, GetSpotStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotStatsQuery, GetSpotStatsQueryVariables>(GetSpotStatsDocument, options);
        }
export type GetSpotStatsQueryHookResult = ReturnType<typeof useGetSpotStatsQuery>;
export type GetSpotStatsLazyQueryHookResult = ReturnType<typeof useGetSpotStatsLazyQuery>;
export type GetSpotStatsQueryResult = Apollo.QueryResult<GetSpotStatsQuery, GetSpotStatsQueryVariables>;
export const ListMySpotBookingsDocument = gql`
    query ListMySpotBookings($dateRange: DateRangeInput) {
  myBookings(dateRange: $dateRange) {
    id
    ref
    startTime
    status
    participants
    occasion
    origin
    client {
      ... on BookingClient {
        id
        firstname
        lastname
        clientPhone: phone
        email
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        user {
          id
          firstname
          lastname
          gender
          birthdate
          mobilePhone
          deletedAt
        }
      }
    }
  }
}
    `;

/**
 * __useListMySpotBookingsQuery__
 *
 * To run a query within a React component, call `useListMySpotBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMySpotBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMySpotBookingsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useListMySpotBookingsQuery(baseOptions?: Apollo.QueryHookOptions<ListMySpotBookingsQuery, ListMySpotBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMySpotBookingsQuery, ListMySpotBookingsQueryVariables>(ListMySpotBookingsDocument, options);
      }
export function useListMySpotBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMySpotBookingsQuery, ListMySpotBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMySpotBookingsQuery, ListMySpotBookingsQueryVariables>(ListMySpotBookingsDocument, options);
        }
export type ListMySpotBookingsQueryHookResult = ReturnType<typeof useListMySpotBookingsQuery>;
export type ListMySpotBookingsLazyQueryHookResult = ReturnType<typeof useListMySpotBookingsLazyQuery>;
export type ListMySpotBookingsQueryResult = Apollo.QueryResult<ListMySpotBookingsQuery, ListMySpotBookingsQueryVariables>;
export const SpotSchedulesDocument = gql`
    query SpotSchedules($slug: ID!) {
  spotSchedules: spot(slug: $slug) {
    id
    name
    opening {
      id
      dayOfWeek
      openTime
      closingTime
      breakIn
      breakOut
    }
    closing {
      id
      reason
      description
      from
      to
    }
  }
}
    `;

/**
 * __useSpotSchedulesQuery__
 *
 * To run a query within a React component, call `useSpotSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpotSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpotSchedulesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSpotSchedulesQuery(baseOptions: Apollo.QueryHookOptions<SpotSchedulesQuery, SpotSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpotSchedulesQuery, SpotSchedulesQueryVariables>(SpotSchedulesDocument, options);
      }
export function useSpotSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpotSchedulesQuery, SpotSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpotSchedulesQuery, SpotSchedulesQueryVariables>(SpotSchedulesDocument, options);
        }
export type SpotSchedulesQueryHookResult = ReturnType<typeof useSpotSchedulesQuery>;
export type SpotSchedulesLazyQueryHookResult = ReturnType<typeof useSpotSchedulesLazyQuery>;
export type SpotSchedulesQueryResult = Apollo.QueryResult<SpotSchedulesQuery, SpotSchedulesQueryVariables>;
export const GetConsumerBookingDocument = gql`
    query GetConsumerBooking($id: ID!) {
  booking(id: $id) {
    id
    ref
    startTime
    status
    participants
    occasion
    origin
    spot {
      id
      slug
      name
      avatar {
        id
        url
      }
      address {
        id
        label
        houseNumber
        street
        city
        postalCode
      }
      opening {
        id
        dayOfWeek
        openTime
        closingTime
        breakIn
        breakOut
      }
      closing {
        id
        reason
        description
        from
        to
      }
    }
    updates {
      id
      status
      message
      occasion
      startTime
      participants
      author {
        ... on Consumer {
          id
          name
          slug
          avatar {
            id
            url
          }
          user {
            id
            firstname
            lastname
            deletedAt
          }
        }
        ... on Spot {
          id
          name
          avatar {
            id
            url
          }
        }
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetConsumerBookingQuery__
 *
 * To run a query within a React component, call `useGetConsumerBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetConsumerBookingQuery(baseOptions: Apollo.QueryHookOptions<GetConsumerBookingQuery, GetConsumerBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsumerBookingQuery, GetConsumerBookingQueryVariables>(GetConsumerBookingDocument, options);
      }
export function useGetConsumerBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsumerBookingQuery, GetConsumerBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsumerBookingQuery, GetConsumerBookingQueryVariables>(GetConsumerBookingDocument, options);
        }
export type GetConsumerBookingQueryHookResult = ReturnType<typeof useGetConsumerBookingQuery>;
export type GetConsumerBookingLazyQueryHookResult = ReturnType<typeof useGetConsumerBookingLazyQuery>;
export type GetConsumerBookingQueryResult = Apollo.QueryResult<GetConsumerBookingQuery, GetConsumerBookingQueryVariables>;
export const GetSpotBookingDocument = gql`
    query GetSpotBooking($id: ID!) {
  booking(id: $id) {
    id
    ref
    startTime
    status
    participants
    occasion
    origin
    spot {
      id
      slug
      name
      avatar {
        id
        url
      }
      address {
        id
        label
      }
      opening {
        id
        dayOfWeek
        openTime
        closingTime
        breakIn
        breakOut
      }
      closing {
        id
        reason
        description
        from
        to
      }
    }
    client {
      ... on BookingClient {
        id
        firstname
        lastname
        clientPhone: phone
        email
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        user {
          id
          firstname
          lastname
          gender
          birthdate
          mobilePhone
          deletedAt
        }
      }
    }
    updates {
      id
      status
      message
      occasion
      startTime
      participants
      author {
        ... on Consumer {
          id
          name
          slug
          avatar {
            id
            url
          }
          user {
            id
            firstname
            lastname
            deletedAt
          }
        }
        ... on Spot {
          id
          name
          avatar {
            id
            url
          }
        }
      }
      createdAt
    }
  }
}
    `;

/**
 * __useGetSpotBookingQuery__
 *
 * To run a query within a React component, call `useGetSpotBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpotBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpotBookingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSpotBookingQuery(baseOptions: Apollo.QueryHookOptions<GetSpotBookingQuery, GetSpotBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpotBookingQuery, GetSpotBookingQueryVariables>(GetSpotBookingDocument, options);
      }
export function useGetSpotBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpotBookingQuery, GetSpotBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpotBookingQuery, GetSpotBookingQueryVariables>(GetSpotBookingDocument, options);
        }
export type GetSpotBookingQueryHookResult = ReturnType<typeof useGetSpotBookingQuery>;
export type GetSpotBookingLazyQueryHookResult = ReturnType<typeof useGetSpotBookingLazyQuery>;
export type GetSpotBookingQueryResult = Apollo.QueryResult<GetSpotBookingQuery, GetSpotBookingQueryVariables>;
export const UpdateBookingDocument = gql`
    mutation updateBooking($input: UpdateBookingInput!) {
  updateBooking(input: $input) {
    id
    ref
    startTime
    status
    participants
    occasion
    client {
      ... on BookingClient {
        id
        firstname
        lastname
        clientPhone: phone
        email
      }
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        user {
          id
          firstname
          lastname
          gender
          birthdate
          mobilePhone
          deletedAt
        }
      }
    }
  }
}
    `;
export type UpdateBookingMutationFn = Apollo.MutationFunction<UpdateBookingMutation, UpdateBookingMutationVariables>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument, options);
      }
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<UpdateBookingMutation, UpdateBookingMutationVariables>;
export const ListEventCategoriesDocument = gql`
    query ListEventCategories {
  eventCategories {
    id
    name
  }
}
    `;

/**
 * __useListEventCategoriesQuery__
 *
 * To run a query within a React component, call `useListEventCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEventCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEventCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListEventCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<ListEventCategoriesQuery, ListEventCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEventCategoriesQuery, ListEventCategoriesQueryVariables>(ListEventCategoriesDocument, options);
      }
export function useListEventCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEventCategoriesQuery, ListEventCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEventCategoriesQuery, ListEventCategoriesQueryVariables>(ListEventCategoriesDocument, options);
        }
export type ListEventCategoriesQueryHookResult = ReturnType<typeof useListEventCategoriesQuery>;
export type ListEventCategoriesLazyQueryHookResult = ReturnType<typeof useListEventCategoriesLazyQuery>;
export type ListEventCategoriesQueryResult = Apollo.QueryResult<ListEventCategoriesQuery, ListEventCategoriesQueryVariables>;
export const MyEventsDocument = gql`
    query myEvents {
  myEvents {
    id
    ref
    title
    description
    from
    to
    status
    covers {
      ...EventImageFragment
    }
    likers {
      eventId
      count
      accounts {
        ... on Consumer {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Spot {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
      }
    }
    deletedAt
    publishedAt
    category {
      id
      name
    }
  }
}
    ${EventImageFragmentFragmentDoc}
${AccountImageFragmentFragmentDoc}`;

/**
 * __useMyEventsQuery__
 *
 * To run a query within a React component, call `useMyEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyEventsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyEventsQuery(baseOptions?: Apollo.QueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
      }
export function useMyEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyEventsQuery, MyEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyEventsQuery, MyEventsQueryVariables>(MyEventsDocument, options);
        }
export type MyEventsQueryHookResult = ReturnType<typeof useMyEventsQuery>;
export type MyEventsLazyQueryHookResult = ReturnType<typeof useMyEventsLazyQuery>;
export type MyEventsQueryResult = Apollo.QueryResult<MyEventsQuery, MyEventsQueryVariables>;
export const GetEventToEditDocument = gql`
    query getEventToEdit($id: ID!) {
  event(id: $id) {
    id
    ref
    title
    description
    from
    to
    status
    isPrivate
    creator {
      id
    }
    participants {
      eventId
      invited
      confirmed
      interested
      declined
      canceled
      removed
      me {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
      list {
        id
        status
        account {
          id
          name
          slug
          avatar {
            id
            url
            fileId
            fileName
            size
            mimeType
            createdAt
          }
        }
      }
    }
    covers {
      ...EventImageFragment
    }
    likers {
      eventId
      count
      accounts {
        ... on Consumer {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Spot {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
      }
    }
    FAQs {
      id
      idx
      question
      answer
    }
    spot {
      id
      name
      slug
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
    }
    deletedAt
    publishedAt
    category {
      id
      name
    }
  }
}
    ${EventImageFragmentFragmentDoc}
${AccountImageFragmentFragmentDoc}`;

/**
 * __useGetEventToEditQuery__
 *
 * To run a query within a React component, call `useGetEventToEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventToEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventToEditQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventToEditQuery(baseOptions: Apollo.QueryHookOptions<GetEventToEditQuery, GetEventToEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventToEditQuery, GetEventToEditQueryVariables>(GetEventToEditDocument, options);
      }
export function useGetEventToEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventToEditQuery, GetEventToEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventToEditQuery, GetEventToEditQueryVariables>(GetEventToEditDocument, options);
        }
export type GetEventToEditQueryHookResult = ReturnType<typeof useGetEventToEditQuery>;
export type GetEventToEditLazyQueryHookResult = ReturnType<typeof useGetEventToEditLazyQuery>;
export type GetEventToEditQueryResult = Apollo.QueryResult<GetEventToEditQuery, GetEventToEditQueryVariables>;
export const CreateEventDocument = gql`
    mutation createEvent($input: CreateEventInput!) {
  createEvent(input: $input) {
    id
    ref
    title
    description
    from
    to
    status
    covers {
      ...EventImageFragment
    }
    likers {
      eventId
      count
      accounts {
        ... on Consumer {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Spot {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
      }
    }
    deletedAt
    publishedAt
    category {
      id
      name
    }
  }
}
    ${EventImageFragmentFragmentDoc}
${AccountImageFragmentFragmentDoc}`;
export type CreateEventMutationFn = Apollo.MutationFunction<CreateEventMutation, CreateEventMutationVariables>;

/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventMutation, CreateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument, options);
      }
export type CreateEventMutationHookResult = ReturnType<typeof useCreateEventMutation>;
export type CreateEventMutationResult = Apollo.MutationResult<CreateEventMutation>;
export type CreateEventMutationOptions = Apollo.BaseMutationOptions<CreateEventMutation, CreateEventMutationVariables>;
export const UpdateEventDocument = gql`
    mutation updateEvent($input: UpdateEventInput!) {
  updateEvent(input: $input) {
    id
    ref
    title
    description
    from
    to
    status
    covers {
      ...EventImageFragment
    }
    likers {
      eventId
      count
      accounts {
        ... on Consumer {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Spot {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
        ... on Maker {
          id
          name
          slug
          avatar {
            ...AccountImageFragment
          }
        }
      }
    }
    deletedAt
    publishedAt
    category {
      id
      name
    }
  }
}
    ${EventImageFragmentFragmentDoc}
${AccountImageFragmentFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateEventStatusDocument = gql`
    mutation updateEventStatus($id: ID!, $status: EventStatusEnum!) {
  updateEventStatus(id: $id, status: $status) {
    id
    ref
    status
  }
}
    `;
export type UpdateEventStatusMutationFn = Apollo.MutationFunction<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>;

/**
 * __useUpdateEventStatusMutation__
 *
 * To run a mutation, you first call `useUpdateEventStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventStatusMutation, { data, loading, error }] = useUpdateEventStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateEventStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>(UpdateEventStatusDocument, options);
      }
export type UpdateEventStatusMutationHookResult = ReturnType<typeof useUpdateEventStatusMutation>;
export type UpdateEventStatusMutationResult = Apollo.MutationResult<UpdateEventStatusMutation>;
export type UpdateEventStatusMutationOptions = Apollo.BaseMutationOptions<UpdateEventStatusMutation, UpdateEventStatusMutationVariables>;
export const RegisterSpotDocument = gql`
    mutation RegisterSpot($input: RegisterSpotInput!) {
  registerSpot(input: $input) {
    __typename
    ... on Spot {
      id
      name
      slug
    }
  }
}
    `;
export type RegisterSpotMutationFn = Apollo.MutationFunction<RegisterSpotMutation, RegisterSpotMutationVariables>;

/**
 * __useRegisterSpotMutation__
 *
 * To run a mutation, you first call `useRegisterSpotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterSpotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerSpotMutation, { data, loading, error }] = useRegisterSpotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterSpotMutation(baseOptions?: Apollo.MutationHookOptions<RegisterSpotMutation, RegisterSpotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterSpotMutation, RegisterSpotMutationVariables>(RegisterSpotDocument, options);
      }
export type RegisterSpotMutationHookResult = ReturnType<typeof useRegisterSpotMutation>;
export type RegisterSpotMutationResult = Apollo.MutationResult<RegisterSpotMutation>;
export type RegisterSpotMutationOptions = Apollo.BaseMutationOptions<RegisterSpotMutation, RegisterSpotMutationVariables>;
export const OpenTicketAuthDocument = gql`
    mutation OpenTicketAuth($input: OpenAuthTicketInput!) {
  openTicketAuth(input: $input) {
    id
    topic
    status
    createdAt
  }
}
    `;
export type OpenTicketAuthMutationFn = Apollo.MutationFunction<OpenTicketAuthMutation, OpenTicketAuthMutationVariables>;

/**
 * __useOpenTicketAuthMutation__
 *
 * To run a mutation, you first call `useOpenTicketAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOpenTicketAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [openTicketAuthMutation, { data, loading, error }] = useOpenTicketAuthMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOpenTicketAuthMutation(baseOptions?: Apollo.MutationHookOptions<OpenTicketAuthMutation, OpenTicketAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OpenTicketAuthMutation, OpenTicketAuthMutationVariables>(OpenTicketAuthDocument, options);
      }
export type OpenTicketAuthMutationHookResult = ReturnType<typeof useOpenTicketAuthMutation>;
export type OpenTicketAuthMutationResult = Apollo.MutationResult<OpenTicketAuthMutation>;
export type OpenTicketAuthMutationOptions = Apollo.BaseMutationOptions<OpenTicketAuthMutation, OpenTicketAuthMutationVariables>;
export const SearchSuggestLocationDocument = gql`
    query SearchSuggestLocation($search: SearchSuggest!) {
  searchSuggestLocation(search: $search) {
    city
    county
    postalCode
  }
}
    `;

/**
 * __useSearchSuggestLocationQuery__
 *
 * To run a query within a React component, call `useSearchSuggestLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuggestLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuggestLocationQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchSuggestLocationQuery(baseOptions: Apollo.QueryHookOptions<SearchSuggestLocationQuery, SearchSuggestLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSuggestLocationQuery, SearchSuggestLocationQueryVariables>(SearchSuggestLocationDocument, options);
      }
export function useSearchSuggestLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSuggestLocationQuery, SearchSuggestLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSuggestLocationQuery, SearchSuggestLocationQueryVariables>(SearchSuggestLocationDocument, options);
        }
export type SearchSuggestLocationQueryHookResult = ReturnType<typeof useSearchSuggestLocationQuery>;
export type SearchSuggestLocationLazyQueryHookResult = ReturnType<typeof useSearchSuggestLocationLazyQuery>;
export type SearchSuggestLocationQueryResult = Apollo.QueryResult<SearchSuggestLocationQuery, SearchSuggestLocationQueryVariables>;
export const SearchSpotsDocument = gql`
    query SearchSpots($filters: SearchSpotFiltersInput!, $pagination: SearchPagination!) {
  searchSpots(filters: $filters, pagination: $pagination) {
    total
    spots {
      id
      name
      slug
      description
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      covers {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      configuration {
        primaryType
        secondaryType
        tertiaryType
        pricing
        defaultImage
      }
      atmosphere {
        calm
        lively
        dancing
      }
      type {
        amusementPark
        aquarium
        artGallery
        bar
        cafe
        campground
        concertHall
        casino
        departmentStore
        nightClub
        park
        restaurant
        sportClub
        stadium
      }
      address {
        ...AddressFragment
        id
        label
      }
      opening {
        id
        dayOfWeek
        openTime
        closingTime
        breakIn
        breakOut
      }
      closing {
        id
        reason
        description
        from
        to
      }
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useSearchSpotsQuery__
 *
 * To run a query within a React component, call `useSearchSpotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSpotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSpotsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchSpotsQuery(baseOptions: Apollo.QueryHookOptions<SearchSpotsQuery, SearchSpotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSpotsQuery, SearchSpotsQueryVariables>(SearchSpotsDocument, options);
      }
export function useSearchSpotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSpotsQuery, SearchSpotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSpotsQuery, SearchSpotsQueryVariables>(SearchSpotsDocument, options);
        }
export type SearchSpotsQueryHookResult = ReturnType<typeof useSearchSpotsQuery>;
export type SearchSpotsLazyQueryHookResult = ReturnType<typeof useSearchSpotsLazyQuery>;
export type SearchSpotsQueryResult = Apollo.QueryResult<SearchSpotsQuery, SearchSpotsQueryVariables>;
export const SearchEventsDocument = gql`
    query SearchEvents($filters: SearchEventFiltersInput!, $pagination: SearchPagination!) {
  searchEvents(filters: $filters, pagination: $pagination) {
    total
    events {
      id
      title
      thumb
      flyer
      from
      to
      category {
        id
        name
      }
      covers {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      address {
        ...AddressFragment
        id
        label
      }
      spot {
        id
        name
        avatar {
          id
          url
          fileId
          fileName
          size
          mimeType
          createdAt
        }
        address {
          ...AddressFragment
          id
          label
        }
      }
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useSearchEventsQuery__
 *
 * To run a query within a React component, call `useSearchEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEventsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchEventsQuery(baseOptions: Apollo.QueryHookOptions<SearchEventsQuery, SearchEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEventsQuery, SearchEventsQueryVariables>(SearchEventsDocument, options);
      }
export function useSearchEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEventsQuery, SearchEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEventsQuery, SearchEventsQueryVariables>(SearchEventsDocument, options);
        }
export type SearchEventsQueryHookResult = ReturnType<typeof useSearchEventsQuery>;
export type SearchEventsLazyQueryHookResult = ReturnType<typeof useSearchEventsLazyQuery>;
export type SearchEventsQueryResult = Apollo.QueryResult<SearchEventsQuery, SearchEventsQueryVariables>;
export const SearchMembersDocument = gql`
    query SearchMembers($filters: SearchMembersFilters!, $pagination: SearchPagination!) {
  searchMembers(filters: $filters, pagination: $pagination) {
    total
    accounts {
      id
      name
      slug
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
    }
  }
}
    `;

/**
 * __useSearchMembersQuery__
 *
 * To run a query within a React component, call `useSearchMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMembersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchMembersQuery(baseOptions: Apollo.QueryHookOptions<SearchMembersQuery, SearchMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMembersQuery, SearchMembersQueryVariables>(SearchMembersDocument, options);
      }
export function useSearchMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMembersQuery, SearchMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMembersQuery, SearchMembersQueryVariables>(SearchMembersDocument, options);
        }
export type SearchMembersQueryHookResult = ReturnType<typeof useSearchMembersQuery>;
export type SearchMembersLazyQueryHookResult = ReturnType<typeof useSearchMembersLazyQuery>;
export type SearchMembersQueryResult = Apollo.QueryResult<SearchMembersQuery, SearchMembersQueryVariables>;
export const ListHomeSpotsDocument = gql`
    query ListHomeSpots {
  homeSpots {
    id
    title
    spots {
      id
      name
      slug
      description
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      covers {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      configuration {
        id
        primaryType
        secondaryType
        tertiaryType
        pricing
        defaultImage
      }
      atmosphere {
        id
        calm
        lively
        dancing
      }
      type {
        id
        amusementPark
        aquarium
        artGallery
        bar
        cafe
        campground
        concertHall
        casino
        departmentStore
        nightClub
        park
        restaurant
        sportClub
        stadium
      }
      address {
        ...AddressFragment
        id
        label
      }
      opening {
        id
        dayOfWeek
        openTime
        closingTime
        breakIn
        breakOut
      }
      closing {
        id
        reason
        description
        from
        to
      }
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useListHomeSpotsQuery__
 *
 * To run a query within a React component, call `useListHomeSpotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomeSpotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomeSpotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomeSpotsQuery(baseOptions?: Apollo.QueryHookOptions<ListHomeSpotsQuery, ListHomeSpotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomeSpotsQuery, ListHomeSpotsQueryVariables>(ListHomeSpotsDocument, options);
      }
export function useListHomeSpotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomeSpotsQuery, ListHomeSpotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomeSpotsQuery, ListHomeSpotsQueryVariables>(ListHomeSpotsDocument, options);
        }
export type ListHomeSpotsQueryHookResult = ReturnType<typeof useListHomeSpotsQuery>;
export type ListHomeSpotsLazyQueryHookResult = ReturnType<typeof useListHomeSpotsLazyQuery>;
export type ListHomeSpotsQueryResult = Apollo.QueryResult<ListHomeSpotsQuery, ListHomeSpotsQueryVariables>;
export const SupdateSpotAtmosphereDocument = gql`
    mutation SupdateSpotAtmosphere($id: ID!, $input: UpdateSpotAtmosphereInput!) {
  supdateSpotAtmosphere(id: $id, input: $input) {
    id
    calm
    lively
    dancing
    updatedAt
  }
}
    `;
export type SupdateSpotAtmosphereMutationFn = Apollo.MutationFunction<SupdateSpotAtmosphereMutation, SupdateSpotAtmosphereMutationVariables>;

/**
 * __useSupdateSpotAtmosphereMutation__
 *
 * To run a mutation, you first call `useSupdateSpotAtmosphereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotAtmosphereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotAtmosphereMutation, { data, loading, error }] = useSupdateSpotAtmosphereMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotAtmosphereMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotAtmosphereMutation, SupdateSpotAtmosphereMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotAtmosphereMutation, SupdateSpotAtmosphereMutationVariables>(SupdateSpotAtmosphereDocument, options);
      }
export type SupdateSpotAtmosphereMutationHookResult = ReturnType<typeof useSupdateSpotAtmosphereMutation>;
export type SupdateSpotAtmosphereMutationResult = Apollo.MutationResult<SupdateSpotAtmosphereMutation>;
export type SupdateSpotAtmosphereMutationOptions = Apollo.BaseMutationOptions<SupdateSpotAtmosphereMutation, SupdateSpotAtmosphereMutationVariables>;
export const SupdateSpotBringableDocument = gql`
    mutation SupdateSpotBringable($id: ID!, $input: UpdateSpotBringableInput!) {
  supdateSpotBringable(id: $id, input: $input) {
    id
    dogs
    food
    drinks
    birthdayCake
    updatedAt
  }
}
    `;
export type SupdateSpotBringableMutationFn = Apollo.MutationFunction<SupdateSpotBringableMutation, SupdateSpotBringableMutationVariables>;

/**
 * __useSupdateSpotBringableMutation__
 *
 * To run a mutation, you first call `useSupdateSpotBringableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotBringableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotBringableMutation, { data, loading, error }] = useSupdateSpotBringableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotBringableMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotBringableMutation, SupdateSpotBringableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotBringableMutation, SupdateSpotBringableMutationVariables>(SupdateSpotBringableDocument, options);
      }
export type SupdateSpotBringableMutationHookResult = ReturnType<typeof useSupdateSpotBringableMutation>;
export type SupdateSpotBringableMutationResult = Apollo.MutationResult<SupdateSpotBringableMutation>;
export type SupdateSpotBringableMutationOptions = Apollo.BaseMutationOptions<SupdateSpotBringableMutation, SupdateSpotBringableMutationVariables>;
export const SupdateSpotPricingDocument = gql`
    mutation SupdateSpotPricing($id: ID!, $pricing: SpotPricingEnum!) {
  supdateSpotPricing(id: $id, pricing: $pricing) {
    id
    pricing
  }
}
    `;
export type SupdateSpotPricingMutationFn = Apollo.MutationFunction<SupdateSpotPricingMutation, SupdateSpotPricingMutationVariables>;

/**
 * __useSupdateSpotPricingMutation__
 *
 * To run a mutation, you first call `useSupdateSpotPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotPricingMutation, { data, loading, error }] = useSupdateSpotPricingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pricing: // value for 'pricing'
 *   },
 * });
 */
export function useSupdateSpotPricingMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotPricingMutation, SupdateSpotPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotPricingMutation, SupdateSpotPricingMutationVariables>(SupdateSpotPricingDocument, options);
      }
export type SupdateSpotPricingMutationHookResult = ReturnType<typeof useSupdateSpotPricingMutation>;
export type SupdateSpotPricingMutationResult = Apollo.MutationResult<SupdateSpotPricingMutation>;
export type SupdateSpotPricingMutationOptions = Apollo.BaseMutationOptions<SupdateSpotPricingMutation, SupdateSpotPricingMutationVariables>;
export const SupdateSpotCapacityDocument = gql`
    mutation SupdateSpotCapacity($id: ID!, $value: Int!) {
  supdateSpotCapacity(id: $id, value: $value) {
    id
    capacity
  }
}
    `;
export type SupdateSpotCapacityMutationFn = Apollo.MutationFunction<SupdateSpotCapacityMutation, SupdateSpotCapacityMutationVariables>;

/**
 * __useSupdateSpotCapacityMutation__
 *
 * To run a mutation, you first call `useSupdateSpotCapacityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotCapacityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotCapacityMutation, { data, loading, error }] = useSupdateSpotCapacityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSupdateSpotCapacityMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotCapacityMutation, SupdateSpotCapacityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotCapacityMutation, SupdateSpotCapacityMutationVariables>(SupdateSpotCapacityDocument, options);
      }
export type SupdateSpotCapacityMutationHookResult = ReturnType<typeof useSupdateSpotCapacityMutation>;
export type SupdateSpotCapacityMutationResult = Apollo.MutationResult<SupdateSpotCapacityMutation>;
export type SupdateSpotCapacityMutationOptions = Apollo.BaseMutationOptions<SupdateSpotCapacityMutation, SupdateSpotCapacityMutationVariables>;
export const SupdateSpotCloseSpacesDocument = gql`
    mutation SupdateSpotCloseSpaces($id: ID!, $value: Int!) {
  supdateSpotCloseSpaces(id: $id, value: $value) {
    id
    closeSpaces
  }
}
    `;
export type SupdateSpotCloseSpacesMutationFn = Apollo.MutationFunction<SupdateSpotCloseSpacesMutation, SupdateSpotCloseSpacesMutationVariables>;

/**
 * __useSupdateSpotCloseSpacesMutation__
 *
 * To run a mutation, you first call `useSupdateSpotCloseSpacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotCloseSpacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotCloseSpacesMutation, { data, loading, error }] = useSupdateSpotCloseSpacesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSupdateSpotCloseSpacesMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotCloseSpacesMutation, SupdateSpotCloseSpacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotCloseSpacesMutation, SupdateSpotCloseSpacesMutationVariables>(SupdateSpotCloseSpacesDocument, options);
      }
export type SupdateSpotCloseSpacesMutationHookResult = ReturnType<typeof useSupdateSpotCloseSpacesMutation>;
export type SupdateSpotCloseSpacesMutationResult = Apollo.MutationResult<SupdateSpotCloseSpacesMutation>;
export type SupdateSpotCloseSpacesMutationOptions = Apollo.BaseMutationOptions<SupdateSpotCloseSpacesMutation, SupdateSpotCloseSpacesMutationVariables>;
export const SupdateSpotEquipmentDocument = gql`
    mutation SupdateSpotEquipment($id: ID!, $input: UpdateSpotEquipmentInput!) {
  supdateSpotEquipment(id: $id, input: $input) {
    id
    amphitheater
    auditorium
    sono
    wifi
    stage
    video
    locker
    terrace
    toilets
    prmAccess
    dancefloor
    microphone
    prmToilets
    smokingRoom
    parking
    changingTable
    updatedAt
  }
}
    `;
export type SupdateSpotEquipmentMutationFn = Apollo.MutationFunction<SupdateSpotEquipmentMutation, SupdateSpotEquipmentMutationVariables>;

/**
 * __useSupdateSpotEquipmentMutation__
 *
 * To run a mutation, you first call `useSupdateSpotEquipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotEquipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotEquipmentMutation, { data, loading, error }] = useSupdateSpotEquipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotEquipmentMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotEquipmentMutation, SupdateSpotEquipmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotEquipmentMutation, SupdateSpotEquipmentMutationVariables>(SupdateSpotEquipmentDocument, options);
      }
export type SupdateSpotEquipmentMutationHookResult = ReturnType<typeof useSupdateSpotEquipmentMutation>;
export type SupdateSpotEquipmentMutationResult = Apollo.MutationResult<SupdateSpotEquipmentMutation>;
export type SupdateSpotEquipmentMutationOptions = Apollo.BaseMutationOptions<SupdateSpotEquipmentMutation, SupdateSpotEquipmentMutationVariables>;
export const SupdateSpotPaymentDocument = gql`
    mutation SupdateSpotPayment($id: ID!, $input: UpdateSpotPaymentInput!) {
  supdateSpotPayment(id: $id, input: $input) {
    id
    amex
    cash
    checks
    blueCard
    mealTickets
    updatedAt
  }
}
    `;
export type SupdateSpotPaymentMutationFn = Apollo.MutationFunction<SupdateSpotPaymentMutation, SupdateSpotPaymentMutationVariables>;

/**
 * __useSupdateSpotPaymentMutation__
 *
 * To run a mutation, you first call `useSupdateSpotPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotPaymentMutation, { data, loading, error }] = useSupdateSpotPaymentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotPaymentMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotPaymentMutation, SupdateSpotPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotPaymentMutation, SupdateSpotPaymentMutationVariables>(SupdateSpotPaymentDocument, options);
      }
export type SupdateSpotPaymentMutationHookResult = ReturnType<typeof useSupdateSpotPaymentMutation>;
export type SupdateSpotPaymentMutationResult = Apollo.MutationResult<SupdateSpotPaymentMutation>;
export type SupdateSpotPaymentMutationOptions = Apollo.BaseMutationOptions<SupdateSpotPaymentMutation, SupdateSpotPaymentMutationVariables>;
export const SupdateSpotScheduleDocument = gql`
    mutation SupdateSpotSchedule($id: ID!, $input: UpdateSpotScheduleInput!) {
  supdateSpotSchedule(id: $id, input: $input) {
    id
    dayOfWeek
    openTime
    closingTime
    breakIn
    breakOut
    updatedAt
  }
}
    `;
export type SupdateSpotScheduleMutationFn = Apollo.MutationFunction<SupdateSpotScheduleMutation, SupdateSpotScheduleMutationVariables>;

/**
 * __useSupdateSpotScheduleMutation__
 *
 * To run a mutation, you first call `useSupdateSpotScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotScheduleMutation, { data, loading, error }] = useSupdateSpotScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotScheduleMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotScheduleMutation, SupdateSpotScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotScheduleMutation, SupdateSpotScheduleMutationVariables>(SupdateSpotScheduleDocument, options);
      }
export type SupdateSpotScheduleMutationHookResult = ReturnType<typeof useSupdateSpotScheduleMutation>;
export type SupdateSpotScheduleMutationResult = Apollo.MutationResult<SupdateSpotScheduleMutation>;
export type SupdateSpotScheduleMutationOptions = Apollo.BaseMutationOptions<SupdateSpotScheduleMutation, SupdateSpotScheduleMutationVariables>;
export const SupdateSpotServiceDocument = gql`
    mutation SupdateSpotService($id: ID!, $input: UpdateSpotServiceInput!) {
  supdateSpotService(id: $id, input: $input) {
    id
    dj
    karaoke
    ownMusic
    liveMusic
    entertainmentShow
    takeout
    updatedAt
  }
}
    `;
export type SupdateSpotServiceMutationFn = Apollo.MutationFunction<SupdateSpotServiceMutation, SupdateSpotServiceMutationVariables>;

/**
 * __useSupdateSpotServiceMutation__
 *
 * To run a mutation, you first call `useSupdateSpotServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotServiceMutation, { data, loading, error }] = useSupdateSpotServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotServiceMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotServiceMutation, SupdateSpotServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotServiceMutation, SupdateSpotServiceMutationVariables>(SupdateSpotServiceDocument, options);
      }
export type SupdateSpotServiceMutationHookResult = ReturnType<typeof useSupdateSpotServiceMutation>;
export type SupdateSpotServiceMutationResult = Apollo.MutationResult<SupdateSpotServiceMutation>;
export type SupdateSpotServiceMutationOptions = Apollo.BaseMutationOptions<SupdateSpotServiceMutation, SupdateSpotServiceMutationVariables>;
export const SupdateSpotSuitableDocument = gql`
    mutation SupdateSpotSuitable($id: ID!, $input: UpdateSpotSuitableInput!) {
  supdateSpotSuitable(id: $id, input: $input) {
    id
    bachelor
    birthday
    farewell
    teamMeal
    wedding
    afterwork
    exposition
    cocktailPro
    fashionShow
    businessMeal
    companyEvent
    friendsDrink
    studentParty
    productLaunch
    kids
    watchSport
    telework
    veggie
    vegan
    updatedAt
  }
}
    `;
export type SupdateSpotSuitableMutationFn = Apollo.MutationFunction<SupdateSpotSuitableMutation, SupdateSpotSuitableMutationVariables>;

/**
 * __useSupdateSpotSuitableMutation__
 *
 * To run a mutation, you first call `useSupdateSpotSuitableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotSuitableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotSuitableMutation, { data, loading, error }] = useSupdateSpotSuitableMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotSuitableMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotSuitableMutation, SupdateSpotSuitableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotSuitableMutation, SupdateSpotSuitableMutationVariables>(SupdateSpotSuitableDocument, options);
      }
export type SupdateSpotSuitableMutationHookResult = ReturnType<typeof useSupdateSpotSuitableMutation>;
export type SupdateSpotSuitableMutationResult = Apollo.MutationResult<SupdateSpotSuitableMutation>;
export type SupdateSpotSuitableMutationOptions = Apollo.BaseMutationOptions<SupdateSpotSuitableMutation, SupdateSpotSuitableMutationVariables>;
export const SupdateSpotTypeDocument = gql`
    mutation SupdateSpotType($id: ID!, $input: UpdateSpotTypeInput!) {
  supdateSpotType(id: $id, input: $input) {
    id
    amusementPark
    aquarium
    artGallery
    bar
    cafe
    campground
    concertHall
    casino
    departmentStore
    nightClub
    park
    restaurant
    sportClub
    stadium
    updatedAt
  }
}
    `;
export type SupdateSpotTypeMutationFn = Apollo.MutationFunction<SupdateSpotTypeMutation, SupdateSpotTypeMutationVariables>;

/**
 * __useSupdateSpotTypeMutation__
 *
 * To run a mutation, you first call `useSupdateSpotTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotTypeMutation, { data, loading, error }] = useSupdateSpotTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotTypeMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotTypeMutation, SupdateSpotTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotTypeMutation, SupdateSpotTypeMutationVariables>(SupdateSpotTypeDocument, options);
      }
export type SupdateSpotTypeMutationHookResult = ReturnType<typeof useSupdateSpotTypeMutation>;
export type SupdateSpotTypeMutationResult = Apollo.MutationResult<SupdateSpotTypeMutation>;
export type SupdateSpotTypeMutationOptions = Apollo.BaseMutationOptions<SupdateSpotTypeMutation, SupdateSpotTypeMutationVariables>;
export const SupdateSpotTypesDocument = gql`
    mutation SupdateSpotTypes($id: ID!, $input: UpdateSpotTypesInput!) {
  supdateSpotTypes(id: $id, input: $input) {
    id
    primaryType
    secondaryType
    tertiaryType
    updatedAt
  }
}
    `;
export type SupdateSpotTypesMutationFn = Apollo.MutationFunction<SupdateSpotTypesMutation, SupdateSpotTypesMutationVariables>;

/**
 * __useSupdateSpotTypesMutation__
 *
 * To run a mutation, you first call `useSupdateSpotTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotTypesMutation, { data, loading, error }] = useSupdateSpotTypesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotTypesMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotTypesMutation, SupdateSpotTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotTypesMutation, SupdateSpotTypesMutationVariables>(SupdateSpotTypesDocument, options);
      }
export type SupdateSpotTypesMutationHookResult = ReturnType<typeof useSupdateSpotTypesMutation>;
export type SupdateSpotTypesMutationResult = Apollo.MutationResult<SupdateSpotTypesMutation>;
export type SupdateSpotTypesMutationOptions = Apollo.BaseMutationOptions<SupdateSpotTypesMutation, SupdateSpotTypesMutationVariables>;
export const SupdateSpotHighlightDocument = gql`
    mutation SupdateSpotHighlight($id: ID!, $input: UpdateSpotHighlightInput!) {
  supdateSpotHighlight(id: $id, input: $input) {
    id
    mountainView
    oceanView
    rooftop
    seaView
    sunset
    sunrise
    updatedAt
  }
}
    `;
export type SupdateSpotHighlightMutationFn = Apollo.MutationFunction<SupdateSpotHighlightMutation, SupdateSpotHighlightMutationVariables>;

/**
 * __useSupdateSpotHighlightMutation__
 *
 * To run a mutation, you first call `useSupdateSpotHighlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateSpotHighlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateSpotHighlightMutation, { data, loading, error }] = useSupdateSpotHighlightMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateSpotHighlightMutation(baseOptions?: Apollo.MutationHookOptions<SupdateSpotHighlightMutation, SupdateSpotHighlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateSpotHighlightMutation, SupdateSpotHighlightMutationVariables>(SupdateSpotHighlightDocument, options);
      }
export type SupdateSpotHighlightMutationHookResult = ReturnType<typeof useSupdateSpotHighlightMutation>;
export type SupdateSpotHighlightMutationResult = Apollo.MutationResult<SupdateSpotHighlightMutation>;
export type SupdateSpotHighlightMutationOptions = Apollo.BaseMutationOptions<SupdateSpotHighlightMutation, SupdateSpotHighlightMutationVariables>;
export const SearchAccountsDocument = gql`
    query SearchAccounts($filters: SearchAccountsFilters!, $pagination: SearchPagination!) {
  searchAccounts(filters: $filters, pagination: $pagination) {
    total
    accounts {
      __typename
      ... on Consumer {
        id
        name
        slug
        avatar {
          id
          url
        }
        isActive
        isVerified
        isPrivate
        deletedAt
      }
      ... on Spot {
        id
        name
        slug
        avatar {
          id
          url
        }
        isActive
        isVerified
        deletedAt
      }
      ... on Maker {
        id
        name
        slug
        avatar {
          id
          url
        }
        isActive
        isVerified
        deletedAt
      }
      ... on Support {
        id
        name
        slug
        avatar {
          id
          url
        }
        isActive
        isVerified
        deletedAt
      }
      ... on Organizer {
        id
        name
        slug
        avatar {
          id
          url
        }
        isActive
        isVerified
        deletedAt
      }
    }
  }
}
    `;

/**
 * __useSearchAccountsQuery__
 *
 * To run a query within a React component, call `useSearchAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAccountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSearchAccountsQuery(baseOptions: Apollo.QueryHookOptions<SearchAccountsQuery, SearchAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAccountsQuery, SearchAccountsQueryVariables>(SearchAccountsDocument, options);
      }
export function useSearchAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAccountsQuery, SearchAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAccountsQuery, SearchAccountsQueryVariables>(SearchAccountsDocument, options);
        }
export type SearchAccountsQueryHookResult = ReturnType<typeof useSearchAccountsQuery>;
export type SearchAccountsLazyQueryHookResult = ReturnType<typeof useSearchAccountsLazyQuery>;
export type SearchAccountsQueryResult = Apollo.QueryResult<SearchAccountsQuery, SearchAccountsQueryVariables>;
export const GetAccountDocument = gql`
    query GetAccount($input: AccountInput!) {
  account(input: $input) {
    __typename
    ... on Consumer {
      id
      name
      slug
      avatar {
        id
        url
      }
      user {
        id
        firstname
        lastname
      }
      isActive
      isVerified
      isPrivate
      deletedAt
    }
    ... on Spot {
      id
      name
      slug
      avatar {
        id
        url
      }
      user {
        id
        firstname
        lastname
      }
      isActive
      isVerified
      deletedAt
    }
    ... on Maker {
      id
      name
      slug
      avatar {
        id
        url
      }
      user {
        id
        firstname
        lastname
      }
      isActive
      isVerified
      deletedAt
    }
    ... on Support {
      id
      name
      slug
      avatar {
        id
        url
      }
      user {
        id
        firstname
        lastname
      }
      isActive
      isVerified
      deletedAt
    }
    ... on Organizer {
      id
      name
      slug
      avatar {
        id
        url
      }
      user {
        id
        firstname
        lastname
      }
      isActive
      isVerified
      deletedAt
    }
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const RemoveImageDocument = gql`
    mutation RemoveImage($id: ID!, $input: RemoveImageInput!) {
  removeImage(id: $id, input: $input)
}
    `;
export type RemoveImageMutationFn = Apollo.MutationFunction<RemoveImageMutation, RemoveImageMutationVariables>;

/**
 * __useRemoveImageMutation__
 *
 * To run a mutation, you first call `useRemoveImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeImageMutation, { data, loading, error }] = useRemoveImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveImageMutation, RemoveImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveImageMutation, RemoveImageMutationVariables>(RemoveImageDocument, options);
      }
export type RemoveImageMutationHookResult = ReturnType<typeof useRemoveImageMutation>;
export type RemoveImageMutationResult = Apollo.MutationResult<RemoveImageMutation>;
export type RemoveImageMutationOptions = Apollo.BaseMutationOptions<RemoveImageMutation, RemoveImageMutationVariables>;
export const SupdateAccountDocument = gql`
    mutation SupdateAccount($id: ID!, $input: UpdateAccountInput!) {
  supdateAccount(id: $id, input: $input) {
    __typename
    ... on Consumer {
      id
      name
      description
      slug
      updatedAt
    }
    ... on Spot {
      id
      name
      description
      slug
      updatedAt
    }
    ... on Consumer {
      id
      name
      description
      slug
      updatedAt
    }
    ... on Maker {
      id
      name
      description
      slug
      updatedAt
    }
    ... on Organizer {
      id
      name
      description
      slug
      updatedAt
    }
  }
}
    `;
export type SupdateAccountMutationFn = Apollo.MutationFunction<SupdateAccountMutation, SupdateAccountMutationVariables>;

/**
 * __useSupdateAccountMutation__
 *
 * To run a mutation, you first call `useSupdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateAccountMutation, { data, loading, error }] = useSupdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<SupdateAccountMutation, SupdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateAccountMutation, SupdateAccountMutationVariables>(SupdateAccountDocument, options);
      }
export type SupdateAccountMutationHookResult = ReturnType<typeof useSupdateAccountMutation>;
export type SupdateAccountMutationResult = Apollo.MutationResult<SupdateAccountMutation>;
export type SupdateAccountMutationOptions = Apollo.BaseMutationOptions<SupdateAccountMutation, SupdateAccountMutationVariables>;
export const SupdateAccountStatusesDocument = gql`
    mutation SupdateAccountStatuses($id: ID!, $input: AccountStatusesInput!) {
  supdateAccountStatuses(id: $id, input: $input) {
    __typename
    ... on Consumer {
      id
      isActive
      isVerified
      isPrivate
      updatedAt
    }
    ... on Spot {
      id
      isActive
      isVerified
      updatedAt
    }
    ... on Consumer {
      id
      isActive
      isVerified
      updatedAt
    }
    ... on Maker {
      id
      isActive
      isVerified
      updatedAt
    }
  }
}
    `;
export type SupdateAccountStatusesMutationFn = Apollo.MutationFunction<SupdateAccountStatusesMutation, SupdateAccountStatusesMutationVariables>;

/**
 * __useSupdateAccountStatusesMutation__
 *
 * To run a mutation, you first call `useSupdateAccountStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupdateAccountStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supdateAccountStatusesMutation, { data, loading, error }] = useSupdateAccountStatusesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupdateAccountStatusesMutation(baseOptions?: Apollo.MutationHookOptions<SupdateAccountStatusesMutation, SupdateAccountStatusesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupdateAccountStatusesMutation, SupdateAccountStatusesMutationVariables>(SupdateAccountStatusesDocument, options);
      }
export type SupdateAccountStatusesMutationHookResult = ReturnType<typeof useSupdateAccountStatusesMutation>;
export type SupdateAccountStatusesMutationResult = Apollo.MutationResult<SupdateAccountStatusesMutation>;
export type SupdateAccountStatusesMutationOptions = Apollo.BaseMutationOptions<SupdateAccountStatusesMutation, SupdateAccountStatusesMutationVariables>;
export const GetAccountCountsDocument = gql`
    query GetAccountCounts($dateRange: DateRangeInput) {
  accountCounts(dateRange: $dateRange) {
    current {
      spot
      consumer
      artist
    }
    previous {
      spot
      consumer
      artist
    }
  }
}
    `;

/**
 * __useGetAccountCountsQuery__
 *
 * To run a query within a React component, call `useGetAccountCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountCountsQuery({
 *   variables: {
 *      dateRange: // value for 'dateRange'
 *   },
 * });
 */
export function useGetAccountCountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountCountsQuery, GetAccountCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountCountsQuery, GetAccountCountsQueryVariables>(GetAccountCountsDocument, options);
      }
export function useGetAccountCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountCountsQuery, GetAccountCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountCountsQuery, GetAccountCountsQueryVariables>(GetAccountCountsDocument, options);
        }
export type GetAccountCountsQueryHookResult = ReturnType<typeof useGetAccountCountsQuery>;
export type GetAccountCountsLazyQueryHookResult = ReturnType<typeof useGetAccountCountsLazyQuery>;
export type GetAccountCountsQueryResult = Apollo.QueryResult<GetAccountCountsQuery, GetAccountCountsQueryVariables>;
export const ListUsersDocument = gql`
    query ListUsers($filters: ListUserFilters!) {
  listUsers(filters: $filters) {
    id
    firstname
    lastname
    gender
    birthdate
    email
    phone
    mobilePhone
    isActive
    isVerified
    deletedAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const ListSupportTicketTopicsDocument = gql`
    query ListSupportTicketTopics($locale: String) {
  listSupportTicketTopics(locale: $locale) {
    id
    topic
    code
    label
  }
}
    `;

/**
 * __useListSupportTicketTopicsQuery__
 *
 * To run a query within a React component, call `useListSupportTicketTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSupportTicketTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSupportTicketTopicsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useListSupportTicketTopicsQuery(baseOptions?: Apollo.QueryHookOptions<ListSupportTicketTopicsQuery, ListSupportTicketTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSupportTicketTopicsQuery, ListSupportTicketTopicsQueryVariables>(ListSupportTicketTopicsDocument, options);
      }
export function useListSupportTicketTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSupportTicketTopicsQuery, ListSupportTicketTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSupportTicketTopicsQuery, ListSupportTicketTopicsQueryVariables>(ListSupportTicketTopicsDocument, options);
        }
export type ListSupportTicketTopicsQueryHookResult = ReturnType<typeof useListSupportTicketTopicsQuery>;
export type ListSupportTicketTopicsLazyQueryHookResult = ReturnType<typeof useListSupportTicketTopicsLazyQuery>;
export type ListSupportTicketTopicsQueryResult = Apollo.QueryResult<ListSupportTicketTopicsQuery, ListSupportTicketTopicsQueryVariables>;
export const ListAccountsDocument = gql`
    query ListAccounts($filters: ListAccountFilters!) {
  listAccounts(filters: $filters) {
    __typename
    ... on Support {
      id
      name
      slug
      phone
      description
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      isActive
      isVerified
      createdAt
    }
    ... on Consumer {
      id
      name
      slug
      phone
      description
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      isActive
      isVerified
      createdAt
    }
    ... on Spot {
      id
      name
      slug
      phone
      description
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      isActive
      isVerified
      createdAt
    }
    ... on Maker {
      id
      name
      slug
      phone
      description
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      isActive
      isVerified
      createdAt
    }
    ... on Organizer {
      id
      name
      slug
      phone
      description
      avatar {
        id
        url
        fileId
        fileName
        size
        mimeType
        createdAt
      }
      isActive
      isVerified
      createdAt
    }
  }
}
    `;

/**
 * __useListAccountsQuery__
 *
 * To run a query within a React component, call `useListAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAccountsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useListAccountsQuery(baseOptions: Apollo.QueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
      }
export function useListAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAccountsQuery, ListAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAccountsQuery, ListAccountsQueryVariables>(ListAccountsDocument, options);
        }
export type ListAccountsQueryHookResult = ReturnType<typeof useListAccountsQuery>;
export type ListAccountsLazyQueryHookResult = ReturnType<typeof useListAccountsLazyQuery>;
export type ListAccountsQueryResult = Apollo.QueryResult<ListAccountsQuery, ListAccountsQueryVariables>;